import { jsx as u, jsxs as E, Fragment as dn } from "react/jsx-runtime";
import * as h from "react";
import w, { useContext as it, createContext as Zt, forwardRef as Nr, createElement as co, useCallback as Oe, useRef as Nt, useLayoutEffect as hl, useState as he, useEffect as Ct, useMemo as bt, useSyncExternalStore as pl, useId as Cr, Fragment as gl } from "react";
import { Slot as Or, AlertDialog as $e, Tooltip as sn, Accordion as zn, Avatar as Po, Checkbox as ga, Collapsible as To, Popover as Mn, Dialog as ke, DropdownMenu as De, Label as bl, Progress as ba, RadioGroup as lo, ScrollArea as En, Select as Ae, Separator as vl, Slider as Qn, Switch as va, Tabs as Dr } from "radix-ui";
import { Link as $t, useLocation as Os, Outlet as Ds } from "@tanstack/react-router";
import * as Es from "react-dom";
import yl from "react-dom";
function zs(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = zs(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Ms() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = zs(e)) && (r && (r += " "), r += t);
  return r;
}
const wl = (e, t) => {
  const n = new Array(e.length + t.length);
  for (let r = 0; r < e.length; r++)
    n[r] = e[r];
  for (let r = 0; r < t.length; r++)
    n[e.length + r] = t[r];
  return n;
}, xl = (e, t) => ({
  classGroupId: e,
  validator: t
}), Ps = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
  nextPart: e,
  validators: t,
  classGroupId: n
}), br = "-", ya = [], kl = "arbitrary..", _l = (e) => {
  const t = Nl(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (a) => {
      if (a.startsWith("[") && a.endsWith("]"))
        return Sl(a);
      const i = a.split(br), c = i[0] === "" && i.length > 1 ? 1 : 0;
      return Ts(i, c, t);
    },
    getConflictingClassGroupIds: (a, i) => {
      if (i) {
        const c = r[a], d = n[a];
        return c ? d ? wl(d, c) : c : d || ya;
      }
      return n[a] || ya;
    }
  };
}, Ts = (e, t, n) => {
  if (e.length - t === 0)
    return n.classGroupId;
  const o = e[t], s = n.nextPart.get(o);
  if (s) {
    const d = Ts(e, t + 1, s);
    if (d) return d;
  }
  const a = n.validators;
  if (a === null)
    return;
  const i = t === 0 ? e.join(br) : e.slice(t).join(br), c = a.length;
  for (let d = 0; d < c; d++) {
    const f = a[d];
    if (f.validator(i))
      return f.classGroupId;
  }
}, Sl = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
  return r ? kl + r : void 0;
})(), Nl = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e;
  return Cl(n, t);
}, Cl = (e, t) => {
  const n = Ps();
  for (const r in e) {
    const o = e[r];
    Io(o, n, r, t);
  }
  return n;
}, Io = (e, t, n, r) => {
  const o = e.length;
  for (let s = 0; s < o; s++) {
    const a = e[s];
    Ol(a, t, n, r);
  }
}, Ol = (e, t, n, r) => {
  if (typeof e == "string") {
    Dl(e, t, n);
    return;
  }
  if (typeof e == "function") {
    El(e, t, n, r);
    return;
  }
  zl(e, t, n, r);
}, Dl = (e, t, n) => {
  const r = e === "" ? t : Is(t, e);
  r.classGroupId = n;
}, El = (e, t, n, r) => {
  if (Ml(e)) {
    Io(e(r), t, n, r);
    return;
  }
  t.validators === null && (t.validators = []), t.validators.push(xl(n, e));
}, zl = (e, t, n, r) => {
  const o = Object.entries(e), s = o.length;
  for (let a = 0; a < s; a++) {
    const [i, c] = o[a];
    Io(c, Is(t, i), n, r);
  }
}, Is = (e, t) => {
  let n = e;
  const r = t.split(br), o = r.length;
  for (let s = 0; s < o; s++) {
    const a = r[s];
    let i = n.nextPart.get(a);
    i || (i = Ps(), n.nextPart.set(a, i)), n = i;
  }
  return n;
}, Ml = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Pl = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null);
  const o = (s, a) => {
    n[s] = a, t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(s) {
      let a = n[s];
      if (a !== void 0)
        return a;
      if ((a = r[s]) !== void 0)
        return o(s, a), a;
    },
    set(s, a) {
      s in n ? n[s] = a : o(s, a);
    }
  };
}, uo = "!", wa = ":", Tl = [], xa = (e, t, n, r, o) => ({
  modifiers: e,
  hasImportantModifier: t,
  baseClassName: n,
  maybePostfixModifierPosition: r,
  isExternal: o
}), Il = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (o) => {
    const s = [];
    let a = 0, i = 0, c = 0, d;
    const f = o.length;
    for (let v = 0; v < f; v++) {
      const y = o[v];
      if (a === 0 && i === 0) {
        if (y === wa) {
          s.push(o.slice(c, v)), c = v + 1;
          continue;
        }
        if (y === "/") {
          d = v;
          continue;
        }
      }
      y === "[" ? a++ : y === "]" ? a-- : y === "(" ? i++ : y === ")" && i--;
    }
    const l = s.length === 0 ? o : o.slice(c);
    let m = l, p = !1;
    l.endsWith(uo) ? (m = l.slice(0, -1), p = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      l.startsWith(uo) && (m = l.slice(1), p = !0)
    );
    const b = d && d > c ? d - c : void 0;
    return xa(s, p, m, b);
  };
  if (t) {
    const o = t + wa, s = r;
    r = (a) => a.startsWith(o) ? s(a.slice(o.length)) : xa(Tl, !1, a, void 0, !0);
  }
  if (n) {
    const o = r;
    r = (s) => n({
      className: s,
      parseClassName: o
    });
  }
  return r;
}, Al = (e) => {
  const t = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((n, r) => {
    t.set(n, 1e6 + r);
  }), (n) => {
    const r = [];
    let o = [];
    for (let s = 0; s < n.length; s++) {
      const a = n[s], i = a[0] === "[", c = t.has(a);
      i || c ? (o.length > 0 && (o.sort(), r.push(...o), o = []), r.push(a)) : o.push(a);
    }
    return o.length > 0 && (o.sort(), r.push(...o)), r;
  };
}, $l = (e) => ({
  cache: Pl(e.cacheSize),
  parseClassName: Il(e),
  sortModifiers: Al(e),
  postfixLookupClassGroupIds: Rl(e),
  ..._l(e)
}), Rl = (e) => {
  const t = /* @__PURE__ */ Object.create(null), n = e.postfixLookupClassGroups;
  if (n)
    for (let r = 0; r < n.length; r++)
      t[n[r]] = !0;
  return t;
}, Wl = /\s+/, Fl = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o,
    sortModifiers: s,
    postfixLookupClassGroupIds: a
  } = t, i = [], c = e.trim().split(Wl);
  let d = "";
  for (let f = c.length - 1; f >= 0; f -= 1) {
    const l = c[f], {
      isExternal: m,
      modifiers: p,
      hasImportantModifier: b,
      baseClassName: v,
      maybePostfixModifierPosition: y
    } = n(l);
    if (m) {
      d = l + (d.length > 0 ? " " + d : d);
      continue;
    }
    let x = !!y, _;
    if (x) {
      const P = v.substring(0, y);
      _ = r(P);
      const O = _ && a[_] ? r(v) : void 0;
      O && O !== _ && (_ = O, x = !1);
    } else
      _ = r(v);
    if (!_) {
      if (!x) {
        d = l + (d.length > 0 ? " " + d : d);
        continue;
      }
      if (_ = r(v), !_) {
        d = l + (d.length > 0 ? " " + d : d);
        continue;
      }
      x = !1;
    }
    const S = p.length === 0 ? "" : p.length === 1 ? p[0] : s(p).join(":"), D = b ? S + uo : S, N = D + _;
    if (i.indexOf(N) > -1)
      continue;
    i.push(N);
    const k = o(_, x);
    for (let P = 0; P < k.length; ++P) {
      const O = k[P];
      i.push(D + O);
    }
    d = l + (d.length > 0 ? " " + d : d);
  }
  return d;
}, jl = (...e) => {
  let t = 0, n, r, o = "";
  for (; t < e.length; )
    (n = e[t++]) && (r = As(n)) && (o && (o += " "), o += r);
  return o;
}, As = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = As(e[r])) && (n && (n += " "), n += t);
  return n;
}, Bl = (e, ...t) => {
  let n, r, o, s;
  const a = (c) => {
    const d = t.reduce((f, l) => l(f), e());
    return n = $l(d), r = n.cache.get, o = n.cache.set, s = i, i(c);
  }, i = (c) => {
    const d = r(c);
    if (d)
      return d;
    const f = Fl(c, n);
    return o(c, f), f;
  };
  return s = a, (...c) => s(jl(...c));
}, Zl = [], xe = (e) => {
  const t = (n) => n[e] || Zl;
  return t.isThemeGetter = !0, t;
}, $s = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Rs = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Ll = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Yl = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Hl = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ul = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Vl = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Gl = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, _t = (e) => Ll.test(e), K = (e) => !!e && !Number.isNaN(Number(e)), et = (e) => !!e && Number.isInteger(Number(e)), Ur = (e) => e.endsWith("%") && K(e.slice(0, -1)), ut = (e) => Yl.test(e), Ws = () => !0, ql = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Hl.test(e) && !Ul.test(e)
), Ao = () => !1, Jl = (e) => Vl.test(e), Kl = (e) => Gl.test(e), Xl = (e) => !$(e) && !R(e), Ql = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), ed = (e) => Dt(e, Bs, Ao), $ = (e) => $s.test(e), It = (e) => Dt(e, Zs, ql), ka = (e) => Dt(e, cd, K), td = (e) => Dt(e, Ys, Ws), nd = (e) => Dt(e, Ls, Ao), _a = (e) => Dt(e, Fs, Ao), rd = (e) => Dt(e, js, Kl), er = (e) => Dt(e, Hs, Jl), R = (e) => Rs.test(e), _n = (e) => Lt(e, Zs), od = (e) => Lt(e, Ls), Sa = (e) => Lt(e, Fs), ad = (e) => Lt(e, Bs), sd = (e) => Lt(e, js), tr = (e) => Lt(e, Hs, !0), id = (e) => Lt(e, Ys, !0), Dt = (e, t, n) => {
  const r = $s.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Lt = (e, t, n = !1) => {
  const r = Rs.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, Fs = (e) => e === "position" || e === "percentage", js = (e) => e === "image" || e === "url", Bs = (e) => e === "length" || e === "size" || e === "bg-size", Zs = (e) => e === "length", cd = (e) => e === "number", Ls = (e) => e === "family-name", Ys = (e) => e === "number" || e === "weight", Hs = (e) => e === "shadow", ld = () => {
  const e = xe("color"), t = xe("font"), n = xe("text"), r = xe("font-weight"), o = xe("tracking"), s = xe("leading"), a = xe("breakpoint"), i = xe("container"), c = xe("spacing"), d = xe("radius"), f = xe("shadow"), l = xe("inset-shadow"), m = xe("text-shadow"), p = xe("drop-shadow"), b = xe("blur"), v = xe("perspective"), y = xe("aspect"), x = xe("ease"), _ = xe("animate"), S = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], D = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], N = () => [...D(), R, $], k = () => ["auto", "hidden", "clip", "visible", "scroll"], P = () => ["auto", "contain", "none"], O = () => [R, $, c], B = () => [_t, "full", "auto", ...O()], Z = () => [et, "none", "subgrid", R, $], J = () => ["auto", {
    span: ["full", et, R, $]
  }, et, R, $], Y = () => [et, "auto", R, $], Q = () => ["auto", "min", "max", "fr", R, $], re = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], ce = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], U = () => ["auto", ...O()], ne = () => [_t, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...O()], we = () => [_t, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...O()], le = () => [_t, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...O()], I = () => [e, R, $], ue = () => [...D(), Sa, _a, {
    position: [R, $]
  }], z = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], T = () => ["auto", "cover", "contain", ad, ed, {
    size: [R, $]
  }], W = () => [Ur, _n, It], M = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    d,
    R,
    $
  ], F = () => ["", K, _n, It], X = () => ["solid", "dashed", "dotted", "double"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => [K, Ur, Sa, _a], Ce = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    b,
    R,
    $
  ], Ue = () => ["none", K, R, $], We = () => ["none", K, R, $], Mt = () => [K, R, $], Qe = () => [_t, "full", ...O()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [ut],
      breakpoint: [ut],
      color: [Ws],
      container: [ut],
      "drop-shadow": [ut],
      ease: ["in", "out", "in-out"],
      font: [Xl],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [ut],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [ut],
      shadow: [ut],
      spacing: ["px", K],
      text: [ut],
      "text-shadow": [ut],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", _t, $, R, y]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Container Type
       * @see https://tailwindcss.com/docs/responsive-design#container-queries
       */
      "container-type": [{
        "@container": ["", "normal", "size", R, $]
      }],
      /**
       * Container Name
       * @see https://tailwindcss.com/docs/responsive-design#named-containers
       */
      "container-named": [Ql],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [K, $, R, i]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": S()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": S()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: N()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: k()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": k()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": k()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: P()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": P()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": P()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: B()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": B()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": B()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": B(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: B()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": B(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: B()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": B()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": B()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: B()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: B()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: B()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: B()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [et, "auto", R, $]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [_t, "full", "auto", i, ...O()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [K, _t, "auto", "initial", "none", $]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", K, R, $]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", K, R, $]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [et, "first", "last", "none", R, $]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": Z()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: J()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Y()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Y()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": Z()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: J()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Y()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Y()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": Q()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": Q()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: O()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": O()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": O()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...re(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...ce(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...ce()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...re()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...ce(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...ce(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": re()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...ce(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...ce()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: O()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: O()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: O()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: O()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: O()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: O()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: O()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: O()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: O()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: O()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: O()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: U()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: U()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: U()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: U()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: U()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: U()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: U()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: U()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: U()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: U()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: U()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": O()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": O()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: ne()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...we()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...we()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...we()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...le()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...le()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...le()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [i, "screen", ...ne()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          i,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...ne()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          i,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...ne()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...ne()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...ne()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...ne()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, _n, It]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, id, td]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Ur, $]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [od, nd, t]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [$]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, R, $]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [K, "none", R, ka]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          s,
          ...O()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", R, $]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", R, $]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: I()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: I()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...X(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [K, "from-font", "auto", R, It]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: I()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [K, "auto", R, $]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Tab Size
       * @see https://tailwindcss.com/docs/tab-size
       */
      "tab-size": [{
        tab: [et, R, $]
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", R, $]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", R, $]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: ue()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: z()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: T()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, et, R, $],
          radial: ["", R, $],
          conic: [et, R, $]
        }, sd, rd]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: I()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: W()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: W()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: W()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: I()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: I()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: I()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: M()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": M()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": M()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": M()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": M()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": M()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": M()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": M()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": M()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": M()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": M()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": M()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": M()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": M()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": M()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: F()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": F()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": F()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": F()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": F()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": F()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": F()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": F()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": F()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": F()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": F()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": F()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": F()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...X(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...X(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: I()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": I()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": I()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": I()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": I()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": I()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": I()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": I()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": I()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": I()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": I()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: I()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...X(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [K, R, $]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", K, _n, It]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: I()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          f,
          tr,
          er
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: I()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", l, tr, er]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": I()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: F()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: I()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [K, It]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": I()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": F()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": I()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", m, tr, er]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": I()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [K, R, $]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [K]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": G()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": G()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": I()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": I()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": G()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": G()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": I()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": I()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": G()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": G()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": I()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": I()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": G()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": G()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": I()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": I()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": G()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": G()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": I()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": I()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": G()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": G()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": I()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": I()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": G()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": G()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": I()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": I()
      }],
      "mask-image-radial": [{
        "mask-radial": [R, $]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": G()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": G()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": I()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": I()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": D()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [K]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": G()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": G()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": I()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": I()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: ue()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: z()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: T()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", R, $]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          R,
          $
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Ce()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [K, R, $]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [K, R, $]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          p,
          tr,
          er
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": I()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", K, R, $]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [K, R, $]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", K, R, $]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [K, R, $]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", K, R, $]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          R,
          $
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Ce()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [K, R, $]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [K, R, $]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", K, R, $]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [K, R, $]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", K, R, $]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [K, R, $]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [K, R, $]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", K, R, $]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": O()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": O()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": O()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", R, $]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [K, "initial", R, $]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", x, R, $]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [K, R, $]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", _, R, $]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [v, R, $]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": N()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: Ue()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": Ue()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": Ue()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": Ue()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: We()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": We()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": We()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": We()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: Mt()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": Mt()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": Mt()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [R, $, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: N()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Qe()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Qe()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Qe()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Qe()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      /**
       * Zoom
       * @see https://tailwindcss.com/docs/zoom
       */
      zoom: [{
        zoom: [et, R, $]
      }],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: I()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: I()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", R, $]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scrollbar Thumb Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-thumb-color": [{
        "scrollbar-thumb": I()
      }],
      /**
       * Scrollbar Track Color
       * @see https://tailwindcss.com/docs/scrollbar-color
       */
      "scrollbar-track-color": [{
        "scrollbar-track": I()
      }],
      /**
       * Scrollbar Gutter
       * @see https://tailwindcss.com/docs/scrollbar-gutter
       */
      "scrollbar-gutter": [{
        "scrollbar-gutter": ["auto", "stable", "both"]
      }],
      /**
       * Scrollbar Width
       * @see https://tailwindcss.com/docs/scrollbar-width
       */
      "scrollbar-w": [{
        scrollbar: ["auto", "thin", "none"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": O()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": O()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", R, $]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...I()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [K, _n, It, ka]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...I()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      "container-named": ["container-type"],
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    postfixLookupClassGroups: ["container-type"],
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, dd = /* @__PURE__ */ Bl(ld);
function g(...e) {
  return dd(Ms(e));
}
const Na = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ca = Ms, Yt = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return Ca(e, n?.class, n?.className);
  const { variants: o, defaultVariants: s } = t, a = Object.keys(o).map((d) => {
    const f = n?.[d], l = s?.[d];
    if (f === null) return null;
    const m = Na(f) || Na(l);
    return o[d][m];
  }), i = n && Object.entries(n).reduce((d, f) => {
    let [l, m] = f;
    return m === void 0 || (d[l] = m), d;
  }, {}), c = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((d, f) => {
    let { class: l, className: m, ...p } = f;
    return Object.entries(p).every((b) => {
      let [v, y] = b;
      return Array.isArray(y) ? y.includes({
        ...s,
        ...i
      }[v]) : {
        ...s,
        ...i
      }[v] === y;
    }) ? [
      ...d,
      l,
      m
    ] : d;
  }, []);
  return Ca(e, a, c, n?.class, n?.className);
}, Pn = Yt(
  "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-md text-sm font-medium whitespace-nowrap transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-default disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline"
      },
      color: {
        default: "",
        primary: "bg-primary text-white hover:bg-primary/80",
        complete: "bg-complete text-white hover:bg-complete/80",
        success: "bg-success text-white hover:bg-success/80",
        danger: "bg-destructive text-white hover:bg-destructive/80",
        warning: "bg-warning text-white hover:bg-warning/80",
        info: "bg-info text-white hover:bg-info/80",
        white: "bg-background text-muted-foreground border border-border hover:bg-muted/40"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        xs: "h-6 gap-1 rounded-md px-2 text-xs has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9",
        "icon-xs": "size-6 rounded-md [&_svg:not([class*='size-'])]:size-3",
        "icon-sm": "size-8",
        "icon-lg": "size-10"
      }
    },
    defaultVariants: {
      variant: "default",
      color: "default",
      size: "default"
    }
  }
);
function at({
  className: e,
  variant: t = "default",
  color: n = "default",
  size: r = "default",
  asChild: o = !1,
  ...s
}) {
  const a = o ? Or.Root : "button";
  return /* @__PURE__ */ u(
    a,
    {
      "data-slot": "button",
      "data-variant": t,
      "data-size": r,
      className: g(Pn({ variant: t, color: n, size: r, className: e })),
      ...s
    }
  );
}
const ck = $e.Root, lk = $e.Trigger, ud = $e.Portal, Us = h.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  $e.Overlay,
  {
    className: g(
      "fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t,
    ref: n
  }
));
Us.displayName = $e.Overlay.displayName;
const fd = h.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ E(ud, { children: [
  /* @__PURE__ */ u(Us, {}),
  /* @__PURE__ */ u(
    $e.Content,
    {
      ref: n,
      className: g(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 sm:rounded-lg",
        e
      ),
      ...t
    }
  )
] }));
fd.displayName = $e.Content.displayName;
function md({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      className: g("flex flex-col space-y-2 text-center sm:text-left", e),
      ...t
    }
  );
}
md.displayName = "AlertDialogHeader";
function hd({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      className: g("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
      ...t
    }
  );
}
hd.displayName = "AlertDialogFooter";
const pd = h.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  $e.Title,
  {
    ref: n,
    className: g("text-lg font-semibold", e),
    ...t
  }
));
pd.displayName = $e.Title.displayName;
const gd = h.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  $e.Description,
  {
    ref: n,
    className: g("text-sm text-muted-foreground", e),
    ...t
  }
));
gd.displayName = $e.Description.displayName;
const bd = h.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  $e.Action,
  {
    ref: n,
    className: g(Pn(), e),
    ...t
  }
));
bd.displayName = $e.Action.displayName;
const vd = h.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ u(
  $e.Cancel,
  {
    ref: n,
    className: g(Pn({ variant: "outline" }), e),
    ...t
  }
));
vd.displayName = $e.Cancel.displayName;
function yd({
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ u(
    sn.Provider,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function Vs({
  ...e
}) {
  return /* @__PURE__ */ u(sn.Root, { "data-slot": "tooltip", ...e });
}
function Gs({
  ...e
}) {
  return /* @__PURE__ */ u(sn.Trigger, { "data-slot": "tooltip-trigger", ...e });
}
function qs({
  className: e,
  sideOffset: t = 0,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ u(sn.Portal, { children: /* @__PURE__ */ E(
    sn.Content,
    {
      "data-slot": "tooltip-content",
      sideOffset: t,
      className: g(
        "z-50 w-fit origin-(--radix-tooltip-content-transform-origin) animate-in rounded-md bg-foreground px-3 py-1.5 text-xs text-balance text-background fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ u(sn.Arrow, { className: "z-50 size-2.5 translate-y-[calc(-50%-2px)] rotate-45 rounded-[2px] bg-foreground fill-foreground" })
      ]
    }
  ) });
}
const Js = Zt(null), wd = Yt(
  "inline-flex shrink-0 cursor-pointer flex-col items-center justify-center gap-1.5 rounded-sm text-center transition-all outline-none active:scale-[0.97] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "border border-border bg-background text-foreground hover:bg-muted/90 active:bg-muted",
        success: "bg-success text-white hover:bg-success-dark active:bg-success-dark/90",
        destructive: "bg-destructive text-white hover:bg-destructive-dark active:bg-destructive-dark/90 focus-visible:ring-destructive/20",
        primary: "bg-primary text-white hover:bg-primary-dark active:bg-primary-dark/90",
        complete: "bg-complete text-white hover:bg-complete/90 active:bg-complete/80",
        warning: "bg-warning text-white hover:bg-warning/90 active:bg-warning/80",
        info: "bg-info text-white hover:bg-info/90 active:bg-info/80"
      },
      size: {
        default: "h-17 w-20 px-2 py-2 text-[10px] [&_svg:not([class*='size-'])]:size-5",
        sm: "h-16 w-17 px-1.5 py-1.5 text-[9px] [&_svg:not([class*='size-'])]:size-4",
        lg: "h-24 w-28 px-4 py-3 text-xs [&_svg:not([class*='size-'])]:size-7"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function dk({
  icon: e,
  label: t,
  variant: n = "default",
  size: r,
  hidden: o = !1,
  className: s,
  ...a
}) {
  const i = it(Js), c = r ?? i ?? "default";
  return o ? null : /* @__PURE__ */ E(
    "button",
    {
      "data-slot": "action-button",
      "data-variant": n,
      "data-size": c,
      className: g(wd({ variant: n, size: c, className: s })),
      ...a,
      children: [
        /* @__PURE__ */ u("span", { "data-slot": "action-button-icon", children: e }),
        /* @__PURE__ */ u(
          "span",
          {
            "data-slot": "action-button-label",
            className: "w-full text-wrap font-bold font-montserrat uppercase leading-tight",
            children: t
          }
        )
      ]
    }
  );
}
function uk({
  size: e,
  className: t,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ u(Js.Provider, { value: e ?? null, children: /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "action-button-group",
      className: g("flex flex-wrap gap-1.5", t),
      ...r,
      children: n
    }
  ) });
}
const xd = Yt(
  "inline-flex shrink-0 cursor-pointer items-center justify-center rounded-sm transition-all outline-none active:scale-[0.97] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "border border-border bg-background text-foreground hover:bg-muted/90 active:bg-muted",
        success: "bg-success text-white hover:bg-success-dark active:bg-success-dark/90",
        destructive: "bg-destructive text-white hover:bg-destructive-dark active:bg-destructive-dark/90 focus-visible:ring-destructive/20",
        primary: "bg-primary text-white hover:bg-primary-dark active:bg-primary-dark/90",
        complete: "bg-complete text-white hover:bg-complete/90 active:bg-complete/80",
        warning: "bg-warning text-white hover:bg-warning/90 active:bg-warning/80",
        info: "bg-info text-white hover:bg-info/90 active:bg-info/80"
      },
      size: {
        default: "size-9 [&_svg:not([class*='size-'])]:size-5",
        sm: "size-7 [&_svg:not([class*='size-'])]:size-4",
        lg: "size-11 [&_svg:not([class*='size-'])]:size-6"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function fk({
  icon: e,
  label: t,
  variant: n = "default",
  size: r = "default",
  hidden: o = !1,
  className: s,
  ...a
}) {
  return o ? null : /* @__PURE__ */ E(Vs, { children: [
    /* @__PURE__ */ u(Gs, { asChild: !0, children: /* @__PURE__ */ u(
      "button",
      {
        "data-slot": "action-icon-button",
        "data-variant": n,
        "data-size": r,
        "aria-label": t,
        className: g(xd({ variant: n, size: r, className: s })),
        ...a,
        children: e
      }
    ) }),
    /* @__PURE__ */ u(qs, { children: t })
  ] });
}
const Ks = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
const kd = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const _d = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, r) => r ? r.toUpperCase() : n.toLowerCase()
);
const Oa = (e) => {
  const t = _d(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
};
var Sd = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const Nd = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
  return !1;
};
const Cd = Nr(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: s,
    iconNode: a,
    ...i
  }, c) => co(
    "svg",
    {
      ref: c,
      ...Sd,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: Ks("lucide", o),
      ...!s && !Nd(i) && { "aria-hidden": "true" },
      ...i
    },
    [
      ...a.map(([d, f]) => co(d, f)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
const ae = (e, t) => {
  const n = Nr(
    ({ className: r, ...o }, s) => co(Cd, {
      ref: s,
      iconNode: t,
      className: Ks(
        `lucide-${kd(Oa(e))}`,
        `lucide-${e}`,
        r
      ),
      ...o
    })
  );
  return n.displayName = Oa(e), n;
};
const Od = [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
], Dd = ae("arrow-left-to-line", Od);
const Ed = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
], Xs = ae("bell", Ed);
const zd = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], Qs = ae("calendar", zd);
const Md = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Er = ae("check", Md);
const Pd = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], zr = ae("chevron-down", Pd);
const Td = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], Id = ae("chevron-left", Td);
const Ad = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], Wn = ae("chevron-right", Ad);
const $d = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], Rd = ae("chevron-up", $d);
const Wd = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], ei = ae("chevrons-up-down", Wd);
const Fd = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
], jd = ae("circle-check", Fd);
const Bd = [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
], Zd = ae("circle-dashed", Bd);
const Ld = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
], Yd = ae("circle-dot", Ld);
const Hd = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
], Ud = ae("circle-user", Hd);
const Vd = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], Mr = ae("circle", Vd);
const Gd = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
], qd = ae("ellipsis", Gd);
const Jd = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], Kd = ae("grid-3x3", Jd);
const Xd = [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "r6nss1"
    }
  ]
], Qd = ae("house", Xd);
const eu = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], tu = ae("info", eu);
const nu = [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
], ru = ae("link-2", nu);
const ou = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], au = ae("loader-circle", ou);
const su = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], iu = ae("log-out", su);
const cu = [
  [
    "path",
    {
      d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
      key: "kfwtm"
    }
  ]
], lu = ae("moon", cu);
const du = [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], uu = ae("octagon-x", du);
const fu = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], mu = ae("panel-left", fu);
const hu = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], pu = ae("panel-right", hu);
const gu = [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
], bu = ae("pin", gu);
const vu = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], yu = ae("search", vu);
const wu = [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
], xu = ae("sun", wu);
const ku = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], _u = ae("triangle-alert", ku);
const Su = [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
], Da = ae("undo-2", Su);
const Nu = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], ti = ae("x", Nu);
function mk({
  ...e
}) {
  return /* @__PURE__ */ u(zn.Root, { "data-slot": "accordion", ...e });
}
function hk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    zn.Item,
    {
      "data-slot": "accordion-item",
      className: g("border-b last:border-b-0", e),
      ...t
    }
  );
}
function pk({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ u(zn.Header, { className: "flex", children: /* @__PURE__ */ E(
    zn.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: g(
        "flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ u(zr, { className: "pointer-events-none size-4 shrink-0 translate-y-0.5 text-muted-foreground transition-transform duration-200" })
      ]
    }
  ) });
}
function gk({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ u(
    zn.Content,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
      ...n,
      children: /* @__PURE__ */ u("div", { className: g("pt-0 pb-4", e), children: t })
    }
  );
}
const Cu = Yt(
  "relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-lg border px-4 py-3 text-sm has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      variant: {
        default: "bg-card text-card-foreground",
        destructive: "bg-card text-destructive *:data-[slot=alert-description]:text-destructive/90 [&>svg]:text-current"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function bk({
  className: e,
  variant: t,
  ...n
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "alert",
      role: "alert",
      className: g(Cu({ variant: t }), e),
      ...n
    }
  );
}
function vk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "alert-title",
      className: g(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        e
      ),
      ...t
    }
  );
}
function yk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "alert-description",
      className: g(
        "col-start-2 grid justify-items-start gap-1 text-sm text-muted-foreground [&_p]:leading-relaxed",
        e
      ),
      ...t
    }
  );
}
function Ea({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ u(
    Po.Root,
    {
      "data-slot": "avatar",
      "data-size": t,
      className: g(
        "group/avatar relative flex size-8 shrink-0 overflow-hidden rounded-full select-none data-[size=lg]:size-10 data-[size=sm]:size-6",
        e
      ),
      ...n
    }
  );
}
function za({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Po.Image,
    {
      "data-slot": "avatar-image",
      className: g("aspect-square size-full", e),
      ...t
    }
  );
}
function Ma({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Po.Fallback,
    {
      "data-slot": "avatar-fallback",
      className: g(
        "flex size-full items-center justify-center rounded-full bg-muted text-sm text-muted-foreground group-data-[size=sm]/avatar:text-xs",
        e
      ),
      ...t
    }
  );
}
function wk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "span",
    {
      "data-slot": "avatar-badge",
      className: g(
        "absolute right-0 bottom-0 z-10 inline-flex items-center justify-center rounded-full bg-primary text-primary-foreground ring-2 ring-background select-none",
        "group-data-[size=sm]/avatar:size-2 group-data-[size=sm]/avatar:[&>svg]:hidden",
        "group-data-[size=default]/avatar:size-2.5 group-data-[size=default]/avatar:[&>svg]:size-2",
        "group-data-[size=lg]/avatar:size-3 group-data-[size=lg]/avatar:[&>svg]:size-2",
        e
      ),
      ...t
    }
  );
}
function xk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "avatar-group",
      className: g(
        "group/avatar-group flex -space-x-2 *:data-[slot=avatar]:ring-2 *:data-[slot=avatar]:ring-background",
        e
      ),
      ...t
    }
  );
}
function kk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "avatar-group-count",
      className: g(
        "relative flex size-8 shrink-0 items-center justify-center rounded-full bg-muted text-sm text-muted-foreground ring-2 ring-background group-has-data-[size=lg]/avatar-group:size-10 group-has-data-[size=sm]/avatar-group:size-6 [&>svg]:size-4 group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 group-has-data-[size=sm]/avatar-group:[&>svg]:size-3",
        e
      ),
      ...t
    }
  );
}
const Ou = Yt(
  "inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-full border border-transparent font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
        secondary: "bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
        destructive: "bg-destructive text-white focus-visible:ring-destructive/20 dark:bg-destructive/60 dark:focus-visible:ring-destructive/40 [a&]:hover:bg-destructive/90",
        outline: "border-border text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        ghost: "[a&]:hover:bg-accent [a&]:hover:text-accent-foreground",
        link: "text-primary underline-offset-4 [a&]:hover:underline"
      },
      color: {
        default: "",
        primary: "bg-primary text-white [a&]:hover:bg-primary/80",
        complete: "bg-complete text-white [a&]:hover:bg-complete/80",
        success: "bg-success text-white [a&]:hover:bg-success/80",
        danger: "bg-destructive text-white [a&]:hover:bg-destructive/80",
        warning: "bg-warning text-white [a&]:hover:bg-warning/80",
        info: "bg-info text-white [a&]:hover:bg-info/80",
        white: "bg-background text-muted-foreground border border-border [a&]:hover:bg-muted/40"
      },
      size: {
        sm: "px-1.5 py-0 text-[10px] [&>svg]:size-2.5",
        default: "px-2 py-0.5 text-xs [&>svg]:size-3",
        lg: "px-3 py-1 text-sm [&>svg]:size-3.5"
      }
    },
    defaultVariants: {
      variant: "default",
      color: "default",
      size: "default"
    }
  }
);
function _k({
  className: e,
  variant: t = "default",
  color: n = "default",
  size: r = "default",
  asChild: o = !1,
  ...s
}) {
  const a = o ? Or.Root : "span";
  return /* @__PURE__ */ u(
    a,
    {
      "data-slot": "badge",
      "data-variant": t,
      className: g(Ou({ variant: t, color: n, size: r }), e),
      ...s
    }
  );
}
function Sk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card",
      className: g(
        "flex flex-col gap-6 rounded-xl border bg-card py-6 text-card-foreground shadow-sm",
        e
      ),
      ...t
    }
  );
}
function Nk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-header",
      className: g(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        e
      ),
      ...t
    }
  );
}
function Ck({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-title",
      className: g("leading-none font-semibold", e),
      ...t
    }
  );
}
function Ok({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-description",
      className: g("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Dk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-action",
      className: g(
        "col-start-2 row-span-2 row-start-1 self-start justify-self-end",
        e
      ),
      ...t
    }
  );
}
function Ek({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-content",
      className: g("px-6", e),
      ...t
    }
  );
}
function zk({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "card-footer",
      className: g("flex items-center px-6 [.border-t]:pt-6", e),
      ...t
    }
  );
}
function Du(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const Eu = {}, On = {};
function mt(e, t) {
  try {
    const r = (Eu[e] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format)(t).split("GMT")[1];
    return r in On ? On[r] : Pa(r, r.split(":"));
  } catch {
    if (e in On) return On[e];
    const n = e?.match(zu);
    return n ? Pa(e, n.slice(1)) : NaN;
  }
}
const zu = /([+-]\d\d):?(\d\d)?/;
function Pa(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return On[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class ot extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(mt(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), ni(this, t)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new ot(...n, t) : new ot(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new ot(+this, t);
  }
  getTimezoneOffset() {
    const t = -mt(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), vr(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new ot(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Ta = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Ta.test(e)) return;
  const t = e.replace(Ta, "$1UTC");
  ot.prototype[t] && (e.startsWith("get") ? ot.prototype[e] = function() {
    return this.internal[t]();
  } : (ot.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), Mu(this), +this;
  }, ot.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), vr(this), +this;
  }));
});
function vr(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - // Round after converting minutes to seconds to avoid fractional offset
  // precision errors from historical offsets.
  Math.round(-mt(e.timeZone, e) * 60));
}
function Mu(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), ni(e);
}
function ni(e, t) {
  const n = Array.isArray(t) ? Pu(t) : +e.internal, r = mt(e.timeZone, e), o = r > 0 ? Math.floor(r) : Math.ceil(r), s = /* @__PURE__ */ new Date(+e);
  s.setUTCHours(s.getUTCHours() - 1);
  const a = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+s)).getTimezoneOffset(), c = a - i;
  let d = a;
  if (c && a !== o) {
    const B = Date.prototype.getHours.apply(e), Z = Array.isArray(t) ? t[3] || 0 : e.internal.getUTCHours();
    if (B !== Z) {
      const J = /* @__PURE__ */ new Date(+e), Y = a - o;
      Y && J.setUTCMinutes(J.getUTCMinutes() + Y);
      const Q = mt(e.timeZone, J);
      (Q > 0 ? Math.floor(Q) : Math.ceil(Q)) === o && (d = i);
    }
  }
  const f = d - o;
  f && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + f);
  const l = /* @__PURE__ */ new Date(+e);
  l.setUTCSeconds(0);
  const m = a > 0 ? l.getSeconds() : (l.getSeconds() - 60) % 60, p = Math.round(-(mt(e.timeZone, e) * 60)) % 60;
  (p || m) && Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + p + m);
  const b = mt(e.timeZone, e), v = b > 0 ? Math.floor(b) : Math.ceil(b), x = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - v, _ = v !== o, S = x - f, D = v - o, N = n - v * 60 * 1e3, k = D > 0 && Ia(e) - n === D * 60 * 1e3 && Ia(e, N) !== n;
  if (_ && S && !k) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + S);
    const B = mt(e.timeZone, e), Z = B > 0 ? Math.floor(B) : Math.ceil(B), J = v - Z;
    J && S < 0 && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + J);
  }
  vr(e);
  const O = (t ? n : n + p * 1e3) - +e.internal;
  O && Math.abs(O) < 1800 * 1e3 && (Date.prototype.setTime.call(e, +e + O), vr(e));
}
function Pu(e) {
  return Date.UTC(e[0], e.length > 1 ? e[1] : 0, e.length > 2 ? e[2] : 1, ...e.slice(3));
}
function Ia(e, t) {
  const n = new Date(t ?? +e);
  return n.setUTCSeconds(n.getUTCSeconds() - Math.round(-mt(e.timeZone, n) * 60)), +n;
}
class ze extends ot {
  //#region static
  static tz(t, ...n) {
    return n.length ? new ze(...n, t) : new ze(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t?.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${Du(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new ze(+this, t);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](t) {
    return new ze(+new Date(t), this.timeZone);
  }
  //#endregion
}
const ri = 6048e5, Tu = 864e5, Aa = /* @__PURE__ */ Symbol.for("constructDateFrom");
function be(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Aa in e ? e[Aa](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function ie(e, t) {
  return be(t || e, e);
}
function oi(e, t, n) {
  const r = ie(e, n?.in);
  return isNaN(t) ? be(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function ai(e, t, n) {
  const r = ie(e, n?.in);
  if (isNaN(t)) return be(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), s = be(e, r.getTime());
  s.setMonth(r.getMonth() + t + 1, 0);
  const a = s.getDate();
  return o >= a ? s : (r.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    o
  ), r);
}
let Iu = {};
function Fn() {
  return Iu;
}
function un(e, t) {
  const n = Fn(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = ie(e, t?.in), s = o.getDay(), a = (s < r ? 7 : 0) + s - r;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function Tn(e, t) {
  return un(e, { ...t, weekStartsOn: 1 });
}
function si(e, t) {
  const n = ie(e, t?.in), r = n.getFullYear(), o = be(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const s = Tn(o), a = be(n, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Tn(a);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= i.getTime() ? r : r - 1;
}
function $a(e) {
  const t = ie(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function hn(e, ...t) {
  const n = be.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function In(e, t) {
  const n = ie(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function $o(e, t, n) {
  const [r, o] = hn(
    n?.in,
    e,
    t
  ), s = In(r), a = In(o), i = +s - $a(s), c = +a - $a(a);
  return Math.round((i - c) / Tu);
}
function Au(e, t) {
  const n = si(e, t), r = be(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Tn(r);
}
function $u(e, t, n) {
  return oi(e, t * 7, n);
}
function Ru(e, t, n) {
  return ai(e, t * 12, n);
}
function Wu(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = be.bind(null, o));
    const s = ie(o, r);
    (!n || n < s || isNaN(+s)) && (n = s);
  }), be(r, n || NaN);
}
function Fu(e, t) {
  let n, r = t?.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = be.bind(null, o));
    const s = ie(o, r);
    (!n || n > s || isNaN(+s)) && (n = s);
  }), be(r, n || NaN);
}
function ju(e, t, n) {
  const [r, o] = hn(
    n?.in,
    e,
    t
  );
  return +In(r) == +In(o);
}
function ii(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Bu(e) {
  return !(!ii(e) && typeof e != "number" || isNaN(+ie(e)));
}
function ci(e, t, n) {
  const [r, o] = hn(
    n?.in,
    e,
    t
  ), s = r.getFullYear() - o.getFullYear(), a = r.getMonth() - o.getMonth();
  return s * 12 + a;
}
function Zu(e, t) {
  const n = ie(e, t?.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function li(e, t) {
  const [n, r] = hn(e, t.start, t.end);
  return { start: n, end: r };
}
function Lu(e, t) {
  const { start: n, end: r } = li(t?.in, e);
  let o = +n > +r;
  const s = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setDate(1);
  let i = 1;
  const c = [];
  for (; +a <= s; )
    c.push(be(n, a)), a.setMonth(a.getMonth() + i);
  return o ? c.reverse() : c;
}
function Yu(e, t) {
  const n = ie(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Hu(e, t) {
  const n = ie(e, t?.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function di(e, t) {
  const n = ie(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Uu(e, t) {
  const { start: n, end: r } = li(t?.in, e);
  let o = +n > +r;
  const s = o ? +n : +r, a = o ? r : n;
  a.setHours(0, 0, 0, 0), a.setMonth(0, 1);
  let i = 1;
  const c = [];
  for (; +a <= s; )
    c.push(be(n, a)), a.setFullYear(a.getFullYear() + i);
  return o ? c.reverse() : c;
}
function ui(e, t) {
  const n = Fn(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = ie(e, t?.in), s = o.getDay(), a = (s < r ? -7 : 0) + 6 - (s - r);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function Vu(e, t) {
  return ui(e, { ...t, weekStartsOn: 1 });
}
const Gu = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, qu = (e, t, n) => {
  let r;
  const o = Gu[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Vr(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Ju = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ku = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Xu = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Qu = {
  date: Vr({
    formats: Ju,
    defaultWidth: "full"
  }),
  time: Vr({
    formats: Ku,
    defaultWidth: "full"
  }),
  dateTime: Vr({
    formats: Xu,
    defaultWidth: "full"
  })
}, ef = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, tf = (e, t, n, r) => ef[e];
function Sn(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, i = n?.width ? String(n.width) : a;
      o = e.formattingValues[i] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, i = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[i] || e.values[a];
    }
    const s = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[s];
  };
}
const nf = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, rf = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, of = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, af = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, sf = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, cf = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, lf = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, df = {
  ordinalNumber: lf,
  era: Sn({
    values: nf,
    defaultWidth: "wide"
  }),
  quarter: Sn({
    values: rf,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Sn({
    values: of,
    defaultWidth: "wide"
  }),
  day: Sn({
    values: af,
    defaultWidth: "wide"
  }),
  dayPeriod: Sn({
    values: sf,
    defaultWidth: "wide",
    formattingValues: cf,
    defaultFormattingWidth: "wide"
  })
};
function Nn(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], s = t.match(o);
    if (!s)
      return null;
    const a = s[0], i = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(i) ? ff(i, (l) => l.test(a)) : (
      // [TODO] -- I challenge you to fix the type
      uf(i, (l) => l.test(a))
    );
    let d;
    d = e.valueCallback ? e.valueCallback(c) : c, d = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(d)
    ) : d;
    const f = t.slice(a.length);
    return { value: d, rest: f };
  };
}
function uf(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function ff(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function mf(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], s = t.match(e.parsePattern);
    if (!s) return null;
    let a = e.valueCallback ? e.valueCallback(s[0]) : s[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    const i = t.slice(o.length);
    return { value: a, rest: i };
  };
}
const hf = /^(\d+)(th|st|nd|rd)?/i, pf = /\d+/i, gf = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, bf = {
  any: [/^b/i, /^(a|c)/i]
}, vf = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, yf = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, wf = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, xf = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, kf = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _f = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Sf = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Nf = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Cf = {
  ordinalNumber: mf({
    matchPattern: hf,
    parsePattern: pf,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Nn({
    matchPatterns: gf,
    defaultMatchWidth: "wide",
    parsePatterns: bf,
    defaultParseWidth: "any"
  }),
  quarter: Nn({
    matchPatterns: vf,
    defaultMatchWidth: "wide",
    parsePatterns: yf,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Nn({
    matchPatterns: wf,
    defaultMatchWidth: "wide",
    parsePatterns: xf,
    defaultParseWidth: "any"
  }),
  day: Nn({
    matchPatterns: kf,
    defaultMatchWidth: "wide",
    parsePatterns: _f,
    defaultParseWidth: "any"
  }),
  dayPeriod: Nn({
    matchPatterns: Sf,
    defaultMatchWidth: "any",
    parsePatterns: Nf,
    defaultParseWidth: "any"
  })
}, tn = {
  code: "en-US",
  formatDistance: qu,
  formatLong: Qu,
  formatRelative: tf,
  localize: df,
  match: Cf,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Of(e, t) {
  const n = ie(e, t?.in);
  return $o(n, di(n)) + 1;
}
function Ro(e, t) {
  const n = ie(e, t?.in), r = +Tn(n) - +Au(n);
  return Math.round(r / ri) + 1;
}
function fi(e, t) {
  const n = ie(e, t?.in), r = n.getFullYear(), o = Fn(), s = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, a = be(t?.in || e, 0);
  a.setFullYear(r + 1, 0, s), a.setHours(0, 0, 0, 0);
  const i = un(a, t), c = be(t?.in || e, 0);
  c.setFullYear(r, 0, s), c.setHours(0, 0, 0, 0);
  const d = un(c, t);
  return +n >= +i ? r + 1 : +n >= +d ? r : r - 1;
}
function Df(e, t) {
  const n = Fn(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = fi(e, t), s = be(t?.in || e, 0);
  return s.setFullYear(o, 0, r), s.setHours(0, 0, 0, 0), un(s, t);
}
function Wo(e, t) {
  const n = ie(e, t?.in), r = +un(n, t) - +Df(n, t);
  return Math.round(r / ri) + 1;
}
function se(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const St = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return se(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : se(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return se(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return se(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return se(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return se(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return se(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return se(o, t.length);
  }
}, qt = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ra = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return St.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = fi(e, r), s = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = s % 100;
      return se(a, 2);
    }
    return t === "Yo" ? n.ordinalNumber(s, { unit: "year" }) : se(s, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = si(e);
    return se(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return se(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return se(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return se(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return St.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return se(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = Wo(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : se(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = Ro(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : se(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : St.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Of(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : se(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return se(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(s, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), s = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return se(s, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return se(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = qt.noon : r === 0 ? o = qt.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = qt.evening : r >= 12 ? o = qt.afternoon : r >= 4 ? o = qt.morning : o = qt.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return St.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : St.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : se(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : se(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : St.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : St.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return St.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Fa(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return At(r);
      // Hours and minutes with `:` delimiter
      default:
        return At(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Fa(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return At(r);
      // Hours and minutes with `:` delimiter
      default:
        return At(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Wa(r, ":");
      default:
        return "GMT" + At(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Wa(r, ":");
      default:
        return "GMT" + At(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return se(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return se(+e, t.length);
  }
};
function Wa(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? n + String(o) : n + String(o) + t + se(s, 2);
}
function Fa(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + se(Math.abs(e) / 60, 2) : At(e, t);
}
function At(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = se(Math.trunc(r / 60), 2), s = se(r % 60, 2);
  return n + o + t + s;
}
const ja = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, mi = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, Ef = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return ja(e, t);
  let s;
  switch (r) {
    case "P":
      s = t.dateTime({ width: "short" });
      break;
    case "PP":
      s = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = t.dateTime({ width: "long" });
      break;
    default:
      s = t.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", ja(r, t)).replace("{{time}}", mi(o, t));
}, zf = {
  p: mi,
  P: Ef
}, Mf = /^D+$/, Pf = /^Y+$/, Tf = ["D", "DD", "YY", "YYYY"];
function If(e) {
  return Mf.test(e);
}
function Af(e) {
  return Pf.test(e);
}
function $f(e, t, n) {
  const r = Rf(e, t, n);
  if (console.warn(r), Tf.includes(e)) throw new RangeError(r);
}
function Rf(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Wf = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ff = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, jf = /^'([^]*?)'?$/, Bf = /''/g, Zf = /[a-zA-Z]/;
function ht(e, t, n) {
  const r = Fn(), o = n?.locale ?? r.locale ?? tn, s = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, a = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, i = ie(e, n?.in);
  if (!Bu(i))
    throw new RangeError("Invalid time value");
  let c = t.match(Ff).map((f) => {
    const l = f[0];
    if (l === "p" || l === "P") {
      const m = zf[l];
      return m(f, o.formatLong);
    }
    return f;
  }).join("").match(Wf).map((f) => {
    if (f === "''")
      return { isToken: !1, value: "'" };
    const l = f[0];
    if (l === "'")
      return { isToken: !1, value: Lf(f) };
    if (Ra[l])
      return { isToken: !0, value: f };
    if (l.match(Zf))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + l + "`"
      );
    return { isToken: !1, value: f };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(i, c));
  const d = {
    firstWeekContainsDate: s,
    weekStartsOn: a,
    locale: o
  };
  return c.map((f) => {
    if (!f.isToken) return f.value;
    const l = f.value;
    (!n?.useAdditionalWeekYearTokens && Af(l) || !n?.useAdditionalDayOfYearTokens && If(l)) && $f(l, t, String(e));
    const m = Ra[l[0]];
    return m(i, l, o.localize, d);
  }).join("");
}
function Lf(e) {
  const t = e.match(jf);
  return t ? t[1].replace(Bf, "'") : e;
}
function Yf(e, t) {
  const n = ie(e, t?.in), r = n.getFullYear(), o = n.getMonth(), s = be(n, 0);
  return s.setFullYear(r, o + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function Hf(e, t) {
  return ie(e, t?.in).getMonth();
}
function Uf(e, t) {
  return ie(e, t?.in).getFullYear();
}
function Vf(e, t) {
  return +ie(e) > +ie(t);
}
function Gf(e, t) {
  return +ie(e) < +ie(t);
}
function qf(e, t, n) {
  const [r, o] = hn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function Jf(e, t, n) {
  const [r, o] = hn(
    n?.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function Kf(e, t, n) {
  const r = ie(e, n?.in), o = r.getFullYear(), s = r.getDate(), a = be(e, 0);
  a.setFullYear(o, t, 15), a.setHours(0, 0, 0, 0);
  const i = Yf(a);
  return r.setMonth(t, Math.min(s, i)), r;
}
function Xf(e, t, n) {
  const r = ie(e, n?.in);
  return isNaN(+r) ? be(e, NaN) : (r.setFullYear(t), r);
}
const Ba = 5, Qf = 4;
function em(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), s = t.addDays(o, Ba * 7 - 1);
  return t.getMonth(e) === t.getMonth(s) ? Ba : Qf;
}
function hi(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
function tm(e, t) {
  const n = hi(e, t), r = em(e, t);
  return t.addDays(n, r * 7 - 1);
}
const pi = {
  ...tn,
  labels: {
    labelDayButton: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (a, i) => ht(a, i, { locale: tn, ...n });
      let s = o(e, "PPPP");
      return t.today && (s = `Today, ${s}`), t.selected && (s = `${s}, selected`), s;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (e) => `Week ${e}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, s) => ht(o, s, { locale: tn, ...t }), r(e, "LLLL yyyy");
    },
    labelGridcell: (e, t, n, r) => {
      let o;
      r && typeof r.format == "function" ? o = r.format.bind(r) : o = (a, i) => ht(a, i, { locale: tn, ...n });
      let s = o(e, "PPPP");
      return t?.today && (s = `Today, ${s}`), s;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (e, t, n) => {
      let r;
      return n && typeof n.format == "function" ? r = n.format.bind(n) : r = (o, s) => ht(o, s, { locale: tn, ...t }), r(e, "cccc");
    }
  }
};
class je {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? ze.tz(this.options.timeZone) : new this.Date(), this.newDate = (r, o, s) => this.overrides?.newDate ? this.overrides.newDate(r, o, s) : this.options.timeZone ? new ze(r, o, s, this.options.timeZone) : new Date(r, o, s), this.addDays = (r, o) => this.overrides?.addDays ? this.overrides.addDays(r, o) : oi(r, o), this.addMonths = (r, o) => this.overrides?.addMonths ? this.overrides.addMonths(r, o) : ai(r, o), this.addWeeks = (r, o) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, o) : $u(r, o), this.addYears = (r, o) => this.overrides?.addYears ? this.overrides.addYears(r, o) : Ru(r, o), this.differenceInCalendarDays = (r, o) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : $o(r, o), this.differenceInCalendarMonths = (r, o) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : ci(r, o), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : Lu(r), this.eachYearOfInterval = (r) => {
      const o = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : Uu(r), s = new Set(o.map((i) => this.getYear(i)));
      if (s.size === o.length)
        return o;
      const a = [];
      return s.forEach((i) => {
        a.push(new Date(i, 0, 1));
      }), a;
    }, this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : tm(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : Vu(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : Zu(r), this.endOfWeek = (r, o) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, o) : ui(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : Hu(r), this.format = (r, o, s) => {
      const a = this.overrides?.format ? this.overrides.format(r, o, this.options) : ht(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(a) : a;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : Ro(r), this.getMonth = (r, o) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : Hf(r, this.options), this.getYear = (r, o) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : Uf(r, this.options), this.getWeek = (r, o) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : Wo(r, this.options), this.isAfter = (r, o) => this.overrides?.isAfter ? this.overrides.isAfter(r, o) : Vf(r, o), this.isBefore = (r, o) => this.overrides?.isBefore ? this.overrides.isBefore(r, o) : Gf(r, o), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : ii(r), this.isSameDay = (r, o) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, o) : ju(r, o), this.isSameMonth = (r, o) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, o) : qf(r, o), this.isSameYear = (r, o) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, o) : Jf(r, o), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : Wu(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : Fu(r), this.setMonth = (r, o) => this.overrides?.setMonth ? this.overrides.setMonth(r, o) : Kf(r, o), this.setYear = (r, o) => this.overrides?.setYear ? this.overrides.setYear(r, o) : Xf(r, o), this.startOfBroadcastWeek = (r, o) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : hi(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : In(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Tn(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : Yu(r), this.startOfWeek = (r, o) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : un(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : di(r), this.options = { locale: pi, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const t = this.options.locale?.code;
    return t && je.yearFirstLocales.has(t) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(t) {
    const { locale: n, timeZone: r, numerals: o } = this.options, s = n?.code;
    if (s && je.yearFirstLocales.has(s))
      try {
        return new Intl.DateTimeFormat(s, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: o
        }).format(t);
      } catch {
      }
    const a = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(t, a);
  }
}
je.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const ct = new je();
class gi {
  constructor(t, n, r = ct) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r, this.isoDate = r.format(t, "yyyy-MM-dd"), this.displayMonthId = r.format(n, "yyyy-MM"), this.dateMonthId = r.format(t, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class nm {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class rm {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function om(e) {
  return w.createElement("button", { ...e });
}
function am(e) {
  return w.createElement("span", { ...e });
}
function sm(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    w.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && w.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && w.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && w.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && w.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function im(e) {
  const { day: t, modifiers: n, ...r } = e;
  return w.createElement("td", { ...r });
}
function cm(e) {
  const { day: t, modifiers: n, ...r } = e, o = w.useRef(null);
  return w.useEffect(() => {
    n.focused && o.current?.focus();
  }, [n.focused]), w.createElement("button", { ref: o, ...r });
}
var j;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(j || (j = {}));
var fe;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(fe || (fe = {}));
var Ke;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(Ke || (Ke = {}));
var Fe;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(Fe || (Fe = {}));
function lm(e) {
  const { options: t, className: n, components: r, classNames: o, ...s } = e, a = [o[j.Dropdown], n].join(" "), i = t?.find(({ value: c }) => c === s.value);
  return w.createElement(
    "span",
    { "data-disabled": s.disabled, className: o[j.DropdownRoot] },
    w.createElement(r.Select, { className: a, ...s }, t?.map(({ value: c, label: d, disabled: f }) => w.createElement(r.Option, { key: c, value: c, disabled: f }, d))),
    w.createElement(
      "span",
      { className: o[j.CaptionLabel], "aria-hidden": !0 },
      i?.label,
      w.createElement(r.Chevron, { orientation: "down", size: 18, className: o[j.Chevron] })
    )
  );
}
function dm(e) {
  return w.createElement("div", { ...e });
}
function um(e) {
  return w.createElement("div", { ...e });
}
function fm(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return w.createElement("div", { ...r }, e.children);
}
function mm(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return w.createElement("div", { ...r });
}
function hm(e) {
  return w.createElement("table", { ...e });
}
function pm(e) {
  return w.createElement("div", { ...e });
}
const bi = Zt(void 0);
function jn() {
  const e = it(bi);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function gm(e) {
  const { components: t } = jn();
  return w.createElement(t.Dropdown, { ...e });
}
function bm(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...s } = e, { components: a, classNames: i, labels: { labelPrevious: c, labelNext: d } } = jn(), f = Oe((m) => {
    o && n?.(m);
  }, [o, n]), l = Oe((m) => {
    r && t?.(m);
  }, [r, t]);
  return w.createElement(
    "nav",
    { ...s },
    w.createElement(
      a.PreviousMonthButton,
      { type: "button", className: i[j.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: l },
      w.createElement(a.Chevron, { disabled: r ? void 0 : !0, className: i[j.Chevron], orientation: "left" })
    ),
    w.createElement(
      a.NextMonthButton,
      { type: "button", className: i[j.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": d(o), onClick: f },
      w.createElement(a.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: i[j.Chevron] })
    )
  );
}
function vm(e) {
  const { components: t } = jn();
  return w.createElement(t.Button, { ...e });
}
function ym(e) {
  return w.createElement("option", { ...e });
}
function wm(e) {
  const { components: t } = jn();
  return w.createElement(t.Button, { ...e });
}
function xm(e) {
  const { rootRef: t, ...n } = e;
  return w.createElement("div", { ...n, ref: t });
}
function km(e) {
  return w.createElement("select", { ...e });
}
function _m(e) {
  const { week: t, ...n } = e;
  return w.createElement("tr", { ...n });
}
function Sm(e) {
  return w.createElement("th", { ...e });
}
function Nm(e) {
  return w.createElement(
    "thead",
    { "aria-hidden": !0 },
    w.createElement("tr", { ...e })
  );
}
function Cm(e) {
  const { week: t, ...n } = e;
  return w.createElement("th", { ...n });
}
function Om(e) {
  return w.createElement("th", { ...e });
}
function Dm(e) {
  return w.createElement("tbody", { ...e });
}
function Em(e) {
  const { components: t } = jn();
  return w.createElement(t.Dropdown, { ...e });
}
const zm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: om,
  CaptionLabel: am,
  Chevron: sm,
  Day: im,
  DayButton: cm,
  Dropdown: lm,
  DropdownNav: dm,
  Footer: um,
  Month: fm,
  MonthCaption: mm,
  MonthGrid: hm,
  Months: pm,
  MonthsDropdown: gm,
  Nav: bm,
  NextMonthButton: vm,
  Option: ym,
  PreviousMonthButton: wm,
  Root: xm,
  Select: km,
  Week: _m,
  WeekNumber: Cm,
  WeekNumberHeader: Om,
  Weekday: Sm,
  Weekdays: Nm,
  Weeks: Dm,
  YearsDropdown: Em
}, Symbol.toStringTag, { value: "Module" }));
function pt(e, t, n = !1, r = ct) {
  let { from: o, to: s } = e;
  const { differenceInCalendarDays: a, isSameDay: i } = r;
  return o && s ? (a(s, o) < 0 && ([o, s] = [s, o]), a(t, o) >= (n ? 1 : 0) && a(s, t) >= (n ? 1 : 0)) : !n && s ? i(s, t) : !n && o ? i(o, t) : !1;
}
function Fo(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Pr(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function jo(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function Bo(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function vi(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function yi(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function gt(e, t, n = ct) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: s, isAfter: a } = n;
  return r.some((i) => {
    if (typeof i == "boolean")
      return i;
    if (n.isDate(i))
      return o(e, i);
    if (yi(i, n))
      return i.some((c) => o(e, c));
    if (Pr(i))
      return pt(i, e, !1, n);
    if (vi(i))
      return Array.isArray(i.dayOfWeek) ? i.dayOfWeek.includes(e.getDay()) : i.dayOfWeek === e.getDay();
    if (Fo(i)) {
      const c = s(i.before, e), d = s(i.after, e), f = c > 0, l = d < 0;
      return a(i.before, i.after) ? l && f : f || l;
    }
    return jo(i) ? s(e, i.after) > 0 : Bo(i) ? s(i.before, e) > 0 : typeof i == "function" ? i(e) : !1;
  });
}
function Mm(e, t, n, r, o) {
  const { disabled: s, hidden: a, modifiers: i, showOutsideDays: c, broadcastCalendar: d, today: f = o.today() } = t, { isSameDay: l, isSameMonth: m, startOfMonth: p, isBefore: b, endOfMonth: v, isAfter: y } = o, x = n && p(n), _ = r && v(r), S = {
    [fe.focused]: [],
    [fe.outside]: [],
    [fe.disabled]: [],
    [fe.hidden]: [],
    [fe.today]: []
  }, D = {};
  for (const N of e) {
    const { date: k, displayMonth: P } = N, O = !!(P && !m(k, P)), B = !!(x && b(k, x)), Z = !!(_ && y(k, _)), J = !!(s && gt(k, s, o)), Y = !!(a && gt(k, a, o)) || B || Z || // Broadcast calendar will show outside days as default
    !d && !c && O || d && c === !1 && O, Q = l(k, f);
    O && S.outside.push(N), J && S.disabled.push(N), Y && S.hidden.push(N), Q && S.today.push(N), i && Object.keys(i).forEach((re) => {
      const ce = i?.[re];
      ce && gt(k, ce, o) && (D[re] ? D[re].push(N) : D[re] = [N]);
    });
  }
  return (N) => {
    const k = {
      [fe.focused]: !1,
      [fe.disabled]: !1,
      [fe.hidden]: !1,
      [fe.outside]: !1,
      [fe.today]: !1
    }, P = {};
    for (const O in S) {
      const B = S[O];
      k[O] = B.some((Z) => Z === N);
    }
    for (const O in D)
      P[O] = D[O].some((B) => B === N);
    return {
      ...k,
      // custom modifiers should override all the previous ones
      ...P
    };
  };
}
function Pm(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [s]) => (n[s] ? o.push(n[s]) : t[fe[s]] ? o.push(t[fe[s]]) : t[Ke[s]] && o.push(t[Ke[s]]), o), [t[j.Day]]);
}
function Tm(e) {
  return {
    ...zm,
    ...e
  };
}
function Im(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function Zo() {
  const e = {};
  for (const t in j)
    e[j[t]] = `rdp-${j[t]}`;
  for (const t in fe)
    e[fe[t]] = `rdp-${fe[t]}`;
  for (const t in Ke)
    e[Ke[t]] = `rdp-${Ke[t]}`;
  for (const t in Fe)
    e[Fe[t]] = `rdp-${Fe[t]}`;
  return e;
}
function wi(e, t, n) {
  return (n ?? new je(t)).formatMonthYear(e);
}
const Am = wi;
function $m(e, t, n) {
  return (n ?? new je(t)).format(e, "d");
}
function Rm(e, t = ct) {
  return t.format(e, "LLLL");
}
function Wm(e, t, n) {
  return (n ?? new je(t)).format(e, "cccccc");
}
function Fm(e, t = ct) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function jm() {
  return "";
}
function xi(e, t = ct) {
  return t.format(e, "yyyy");
}
const Bm = xi, Zm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: wi,
  formatDay: $m,
  formatMonthCaption: Am,
  formatMonthDropdown: Rm,
  formatWeekNumber: Fm,
  formatWeekNumberHeader: jm,
  formatWeekdayName: Wm,
  formatYearCaption: Bm,
  formatYearDropdown: xi
}, Symbol.toStringTag, { value: "Module" }));
function Lm(e) {
  return e?.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e?.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...Zm,
    ...e
  };
}
function Lo(e, t, n, r) {
  let o = (r ?? new je(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const Ym = Lo;
function Yo(e, t, n) {
  return (n ?? new je(t)).formatMonthYear(e);
}
const Hm = Yo;
function ki(e, t, n, r) {
  let o = (r ?? new je(n)).format(e, "PPPP");
  return t?.today && (o = `Today, ${o}`), o;
}
function _i(e) {
  return "Choose the Month";
}
function Si() {
  return "";
}
const Um = "Go to the Next Month";
function Ni(e, t) {
  return Um;
}
function Ci(e) {
  return "Go to the Previous Month";
}
function Oi(e, t, n) {
  return (n ?? new je(t)).format(e, "cccc");
}
function Di(e, t) {
  return `Week ${e}`;
}
function Ei(e) {
  return "Week Number";
}
function zi(e) {
  return "Choose the Year";
}
const Vm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Hm,
  labelDay: Ym,
  labelDayButton: Lo,
  labelGrid: Yo,
  labelGridcell: ki,
  labelMonthDropdown: _i,
  labelNav: Si,
  labelNext: Ni,
  labelPrevious: Ci,
  labelWeekNumber: Di,
  labelWeekNumberHeader: Ei,
  labelWeekday: Oi,
  labelYearDropdown: zi
}, Symbol.toStringTag, { value: "Module" })), Je = (e, t, n) => t || (n ? typeof n == "function" ? n : (...r) => n : e);
function Gm(e, t) {
  const n = t.locale?.labels ?? {};
  return {
    ...Vm,
    ...e ?? {},
    labelDayButton: Je(Lo, e?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: Je(_i, e?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: Je(Ni, e?.labelNext, n.labelNext),
    labelPrevious: Je(Ci, e?.labelPrevious, n.labelPrevious),
    labelWeekNumber: Je(Di, e?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: Je(zi, e?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: Je(Yo, e?.labelGrid, n.labelGrid),
    labelGridcell: Je(ki, e?.labelGridcell, n.labelGridcell),
    labelNav: Je(Si, e?.labelNav, n.labelNav),
    labelWeekNumberHeader: Je(Ei, e?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: Je(Oi, e?.labelWeekday, n.labelWeekday)
  };
}
function qm(e, t, n, r, o) {
  const { startOfMonth: s, startOfYear: a, endOfYear: i, eachMonthOfInterval: c, getMonth: d } = o;
  return c({
    start: a(e),
    end: i(e)
  }).map((m) => {
    const p = r.formatMonthDropdown(m, o), b = d(m), v = t && m < s(t) || n && m > s(n) || !1;
    return { value: b, label: p, disabled: v };
  });
}
function Jm(e, t = {}, n = {}) {
  let r = { ...t?.[j.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n?.[o]
    };
  }), r;
}
function Km(e, t, n, r) {
  const o = r ?? e.today(), s = n ? e.startOfBroadcastWeek(o, e) : t ? e.startOfISOWeek(o) : e.startOfWeek(o), a = [];
  for (let i = 0; i < 7; i++) {
    const c = e.addDays(s, i);
    a.push(c);
  }
  return a;
}
function Xm(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: s, endOfYear: a, eachYearOfInterval: i, getYear: c } = r, d = s(e), f = a(t), l = i({ start: d, end: f });
  return o && l.reverse(), l.map((m) => {
    const p = n.formatYearDropdown(m, r);
    return {
      value: c(m),
      label: p,
      disabled: !1
    };
  });
}
function Qm(e, t = {}) {
  const { weekStartsOn: n, locale: r } = t, o = n ?? r?.options?.weekStartsOn ?? 0, s = (i) => {
    const c = typeof i == "number" || typeof i == "string" ? new Date(i) : i;
    return new ze(c.getFullYear(), c.getMonth(), c.getDate(), 12, 0, 0, e);
  }, a = (i) => {
    const c = s(i);
    return new Date(c.getFullYear(), c.getMonth(), c.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => s(ze.tz(e)),
    newDate: (i, c, d) => new ze(i, c, d, 12, 0, 0, e),
    startOfDay: (i) => s(i),
    startOfWeek: (i, c) => {
      const d = s(i), f = c?.weekStartsOn ?? o, l = (d.getDay() - f + 7) % 7;
      return d.setDate(d.getDate() - l), d;
    },
    startOfISOWeek: (i) => {
      const c = s(i), d = (c.getDay() - 1 + 7) % 7;
      return c.setDate(c.getDate() - d), c;
    },
    startOfMonth: (i) => {
      const c = s(i);
      return c.setDate(1), c;
    },
    startOfYear: (i) => {
      const c = s(i);
      return c.setMonth(0, 1), c;
    },
    endOfWeek: (i, c) => {
      const d = s(i), m = (((c?.weekStartsOn ?? o) + 6) % 7 - d.getDay() + 7) % 7;
      return d.setDate(d.getDate() + m), d;
    },
    endOfISOWeek: (i) => {
      const c = s(i), d = (7 - c.getDay()) % 7;
      return c.setDate(c.getDate() + d), c;
    },
    endOfMonth: (i) => {
      const c = s(i);
      return c.setMonth(c.getMonth() + 1, 0), c;
    },
    endOfYear: (i) => {
      const c = s(i);
      return c.setMonth(11, 31), c;
    },
    eachMonthOfInterval: (i) => {
      const c = s(i.start), d = s(i.end), f = [], l = new ze(c.getFullYear(), c.getMonth(), 1, 12, 0, 0, e), m = d.getFullYear() * 12 + d.getMonth();
      for (; l.getFullYear() * 12 + l.getMonth() <= m; )
        f.push(new ze(l, e)), l.setMonth(l.getMonth() + 1, 1);
      return f;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (i, c) => {
      const d = s(i);
      return d.setDate(d.getDate() + c), d;
    },
    addWeeks: (i, c) => {
      const d = s(i);
      return d.setDate(d.getDate() + c * 7), d;
    },
    addMonths: (i, c) => {
      const d = s(i);
      return d.setMonth(d.getMonth() + c), d;
    },
    addYears: (i, c) => {
      const d = s(i);
      return d.setFullYear(d.getFullYear() + c), d;
    },
    eachYearOfInterval: (i) => {
      const c = s(i.start), d = s(i.end), f = [], l = new ze(c.getFullYear(), 0, 1, 12, 0, 0, e);
      for (; l.getFullYear() <= d.getFullYear(); )
        f.push(new ze(l, e)), l.setFullYear(l.getFullYear() + 1, 0, 1);
      return f;
    },
    getWeek: (i, c) => {
      const d = a(i);
      return Wo(d, {
        weekStartsOn: c?.weekStartsOn ?? o,
        firstWeekContainsDate: c?.firstWeekContainsDate ?? r?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (i) => {
      const c = a(i);
      return Ro(c);
    },
    differenceInCalendarDays: (i, c) => {
      const d = a(i), f = a(c);
      return $o(d, f);
    },
    differenceInCalendarMonths: (i, c) => {
      const d = a(i), f = a(c);
      return ci(d, f);
    }
  };
}
const Bn = (e) => e instanceof HTMLElement ? e : null, Gr = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], eh = (e) => Bn(e.querySelector("[data-animated-month]")), qr = (e) => Bn(e.querySelector("[data-animated-caption]")), Jr = (e) => Bn(e.querySelector("[data-animated-weeks]")), th = (e) => Bn(e.querySelector("[data-animated-nav]")), nh = (e) => Bn(e.querySelector("[data-animated-weekdays]"));
function rh(e, t, { classNames: n, months: r, focused: o, dateLib: s }) {
  const a = Nt(null), i = Nt(r), c = Nt(!1);
  hl(() => {
    const d = i.current;
    if (i.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || d.length === 0 || r.length !== d.length)
      return;
    const f = s.isSameMonth(r[0].date, d[0].date), l = s.isAfter(r[0].date, d[0].date), m = l ? n[Fe.caption_after_enter] : n[Fe.caption_before_enter], p = l ? n[Fe.weeks_after_enter] : n[Fe.weeks_before_enter], b = a.current, v = e.current.cloneNode(!0);
    if (v instanceof HTMLElement ? (Gr(v).forEach((S) => {
      if (!(S instanceof HTMLElement))
        return;
      const D = eh(S);
      D && S.contains(D) && S.removeChild(D);
      const N = qr(S);
      N && N.classList.remove(m);
      const k = Jr(S);
      k && k.classList.remove(p);
    }), a.current = v) : a.current = null, c.current || f || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const y = b instanceof HTMLElement ? Gr(b) : [], x = Gr(e.current);
    if (x?.every((_) => _ instanceof HTMLElement) && y && y.every((_) => _ instanceof HTMLElement)) {
      c.current = !0, e.current.style.isolation = "isolate";
      const _ = th(e.current);
      _ && (_.style.zIndex = "1"), x.forEach((S, D) => {
        const N = y[D];
        if (!N)
          return;
        S.style.position = "relative", S.style.overflow = "hidden";
        const k = qr(S);
        k && k.classList.add(m);
        const P = Jr(S);
        P && P.classList.add(p);
        const O = () => {
          c.current = !1, e.current && (e.current.style.isolation = ""), _ && (_.style.zIndex = ""), k && k.classList.remove(m), P && P.classList.remove(p), S.style.position = "", S.style.overflow = "", S.contains(N) && S.removeChild(N);
        };
        N.style.pointerEvents = "none", N.style.position = "absolute", N.style.overflow = "hidden", N.setAttribute("aria-hidden", "true");
        const B = nh(N);
        B && (B.style.opacity = "0");
        const Z = qr(N);
        Z && (Z.classList.add(l ? n[Fe.caption_before_exit] : n[Fe.caption_after_exit]), Z.addEventListener("animationend", O));
        const J = Jr(N);
        J && J.classList.add(l ? n[Fe.weeks_before_exit] : n[Fe.weeks_after_exit]), S.insertBefore(N, S.firstChild);
      });
    }
  });
}
function oh(e, t, n, r) {
  const o = e[0], s = e[e.length - 1], { ISOWeek: a, fixedWeeks: i, broadcastCalendar: c } = n ?? {}, { addDays: d, differenceInCalendarDays: f, differenceInCalendarMonths: l, endOfBroadcastWeek: m, endOfISOWeek: p, endOfMonth: b, endOfWeek: v, isAfter: y, startOfBroadcastWeek: x, startOfISOWeek: _, startOfWeek: S } = r, D = c ? x(o, r) : a ? _(o) : S(o), N = c ? m(s) : a ? p(b(s)) : v(b(s)), k = t && (c ? m(t) : a ? p(t) : v(t)), P = k && y(N, k) ? k : N, O = f(P, D), B = l(s, o) + 1, Z = [];
  for (let Q = 0; Q <= O; Q++) {
    const re = d(D, Q);
    Z.push(re);
  }
  const Y = (c ? 35 : 42) * B;
  if (i && Z.length < Y) {
    const Q = Y - Z.length;
    for (let re = 0; re < Q; re++) {
      const ce = d(Z[Z.length - 1], 1);
      Z.push(ce);
    }
  }
  return Z;
}
function ah(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((s, a) => s.concat(a.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function sh(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, s = [];
  for (let a = 0; a < o; a++) {
    const i = r.addMonths(e, a);
    if (t && i > t)
      break;
    s.push(i);
  }
  return s;
}
function Za(e, t, n, r) {
  const { month: o, defaultMonth: s, today: a = r.today(), numberOfMonths: i = 1 } = e;
  let c = o || s || a;
  const { differenceInCalendarMonths: d, addMonths: f, startOfMonth: l } = r;
  if (n && d(n, c) < i - 1) {
    const m = -1 * (i - 1);
    c = f(n, m);
  }
  return t && d(c, t) < 0 && (c = t), l(c);
}
function ih(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: s, endOfISOWeek: a, endOfMonth: i, endOfWeek: c, getISOWeek: d, getWeek: f, startOfBroadcastWeek: l, startOfISOWeek: m, startOfWeek: p } = r, b = e.reduce((v, y) => {
    const x = n.broadcastCalendar ? l(y, r) : n.ISOWeek ? m(y) : p(y), _ = n.broadcastCalendar ? s(y) : n.ISOWeek ? a(i(y)) : c(i(y)), S = t.filter((P) => P >= x && P <= _), D = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && S.length < D) {
      const P = t.filter((O) => {
        const B = D - S.length;
        return O > _ && O <= o(_, B);
      });
      S.push(...P);
    }
    const N = S.reduce((P, O) => {
      const B = n.ISOWeek ? d(O) : f(O), Z = P.find((Y) => Y.weekNumber === B), J = new gi(O, y, r);
      return Z ? Z.days.push(J) : P.push(new rm(B, [J])), P;
    }, []), k = new nm(y, N);
    return v.push(k), v;
  }, []);
  return n.reverseMonths ? b.reverse() : b;
}
function ch(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: s, startOfMonth: a, endOfMonth: i, addYears: c, endOfYear: d, newDate: f, today: l } = t, { fromYear: m, toYear: p, fromMonth: b, toMonth: v } = e;
  !n && b && (n = b), !n && m && (n = t.newDate(m, 0, 1)), !r && v && (r = v), !r && p && (r = f(p, 11, 31));
  const y = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = a(n) : m ? n = f(m, 0, 1) : !n && y && (n = o(c(e.today ?? l(), -100))), r ? r = i(r) : p ? r = f(p, 11, 31) : !r && y && (r = d(e.today ?? l())), [
    n && s(n),
    r && s(r)
  ];
}
function lh(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s = 1 } = n, { startOfMonth: a, addMonths: i, differenceInCalendarMonths: c } = r, d = o ? s : 1, f = a(e);
  if (!t)
    return i(f, d);
  if (!(c(t, e) < s))
    return i(f, d);
}
function dh(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: s } = n, { startOfMonth: a, addMonths: i, differenceInCalendarMonths: c } = r, d = o ? s ?? 1 : 1, f = a(e);
  if (!t)
    return i(f, -d);
  if (!(c(f, t) <= 0))
    return i(f, -d);
}
function uh(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function Tr(e, t) {
  const [n, r] = he(e);
  return [t === void 0 ? n : t, r];
}
function fh(e, t) {
  const [n, r] = ch(e, t), { startOfMonth: o, endOfMonth: s } = t, a = Za(e, n, r, t), [i, c] = Tr(
    a,
    // initialMonth is always computed from props.month if provided
    e.month ? a : void 0
  );
  Ct(() => {
    const D = Za(e, n, r, t);
    c(D);
  }, [e.timeZone]);
  const { months: d, weeks: f, days: l, previousMonth: m, nextMonth: p } = bt(() => {
    const D = sh(i, r, { numberOfMonths: e.numberOfMonths }, t), N = oh(D, e.endMonth ? s(e.endMonth) : void 0, {
      ISOWeek: e.ISOWeek,
      fixedWeeks: e.fixedWeeks,
      broadcastCalendar: e.broadcastCalendar
    }, t), k = ih(D, N, {
      broadcastCalendar: e.broadcastCalendar,
      fixedWeeks: e.fixedWeeks,
      ISOWeek: e.ISOWeek,
      reverseMonths: e.reverseMonths
    }, t), P = uh(k), O = ah(k), B = dh(i, n, e, t), Z = lh(i, r, e, t);
    return {
      months: k,
      weeks: P,
      days: O,
      previousMonth: B,
      nextMonth: Z
    };
  }, [
    t,
    i.getTime(),
    r?.getTime(),
    n?.getTime(),
    e.disableNavigation,
    e.broadcastCalendar,
    e.endMonth?.getTime(),
    e.fixedWeeks,
    e.ISOWeek,
    e.numberOfMonths,
    e.pagedNavigation,
    e.reverseMonths
  ]), { disableNavigation: b, onMonthChange: v } = e, y = (D) => f.some((N) => N.days.some((k) => k.isEqualTo(D))), x = (D) => {
    if (b)
      return;
    let N = o(D);
    n && N < o(n) && (N = o(n)), r && N > o(r) && (N = o(r)), c(N), v?.(N);
  };
  return {
    months: d,
    weeks: f,
    days: l,
    navStart: n,
    navEnd: r,
    previousMonth: m,
    nextMonth: p,
    goToMonth: x,
    goToDay: (D) => {
      y(D) || x(D.date);
    }
  };
}
var nt;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(nt || (nt = {}));
function La(e) {
  return !e[fe.disabled] && !e[fe.hidden] && !e[fe.outside];
}
function mh(e, t, n, r) {
  let o, s = -1;
  for (const a of e) {
    const i = t(a);
    La(i) && (i[fe.focused] && s < nt.FocusedModifier ? (o = a, s = nt.FocusedModifier) : r?.isEqualTo(a) && s < nt.LastFocused ? (o = a, s = nt.LastFocused) : n(a.date) && s < nt.Selected ? (o = a, s = nt.Selected) : i[fe.today] && s < nt.Today && (o = a, s = nt.Today));
  }
  return o || (o = e.find((a) => La(t(a)))), o;
}
function hh(e, t, n, r, o, s, a) {
  const { ISOWeek: i, broadcastCalendar: c } = s, { addDays: d, addMonths: f, addWeeks: l, addYears: m, endOfBroadcastWeek: p, endOfISOWeek: b, endOfWeek: v, max: y, min: x, startOfBroadcastWeek: _, startOfISOWeek: S, startOfWeek: D } = a;
  let k = {
    day: d,
    week: l,
    month: f,
    year: m,
    startOfWeek: (P) => c ? _(P, a) : i ? S(P) : D(P),
    endOfWeek: (P) => c ? p(P) : i ? b(P) : v(P)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? k = y([r, k]) : t === "after" && o && (k = x([o, k])), k;
}
function Mi(e, t, n, r, o, s, a, i = 0) {
  if (i > 365)
    return;
  const c = hh(e, t, n.date, r, o, s, a), d = !!(s.disabled && gt(c, s.disabled, a)), f = !!(s.hidden && gt(c, s.hidden, a)), l = c, m = new gi(c, l, a);
  return !d && !f ? m : Mi(e, t, m, r, o, s, a, i + 1);
}
function ph(e, t, n, r, o) {
  const { autoFocus: s } = e, [a, i] = he(), c = mh(t.days, n, r || (() => !1), a), [d, f] = he(s ? c : void 0);
  return {
    isFocusTarget: (v) => !!c?.isEqualTo(v),
    setFocused: f,
    focused: d,
    blur: () => {
      i(d), f(void 0);
    },
    moveFocus: (v, y) => {
      if (!d)
        return;
      const x = Mi(v, y, d, t.navStart, t.navEnd, e, o);
      x && (e.disableNavigation && !t.days.some((S) => S.isEqualTo(x)) || (t.goToDay(x), f(x)));
    }
  };
}
function gh(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, a] = Tr(n, o ? n : void 0), i = o ? n : s, { isSameDay: c } = t, d = (p) => i?.some((b) => c(b, p)) ?? !1, { min: f, max: l } = e;
  return {
    selected: i,
    select: (p, b, v) => {
      let y = [...i ?? []];
      if (d(p)) {
        if (i?.length === f || r && i?.length === 1)
          return;
        y = i?.filter((x) => !c(x, p));
      } else
        i?.length === l ? y = [p] : y = [...y, p];
      return o || a(y), o?.(y, p, b, v), y;
    },
    isSelected: d
  };
}
function bh(e, t, n = 0, r = 0, o = !1, s = ct) {
  const { from: a, to: i } = t || {}, { isSameDay: c, isAfter: d, isBefore: f } = s;
  let l;
  if (!a && !i)
    l = { from: e, to: n > 0 ? void 0 : e };
  else if (a && !i)
    c(a, e) ? n === 0 ? l = { from: a, to: e } : o ? l = { from: a, to: void 0 } : l = void 0 : f(e, a) ? l = { from: e, to: a } : l = { from: a, to: e };
  else if (a && i)
    if (c(a, e) && c(i, e))
      o ? l = { from: a, to: i } : l = void 0;
    else if (c(a, e))
      l = { from: a, to: n > 0 ? void 0 : e };
    else if (c(i, e))
      l = { from: e, to: n > 0 ? void 0 : e };
    else if (f(e, a))
      l = { from: e, to: i };
    else if (d(e, a))
      l = { from: a, to: e };
    else if (d(e, i))
      l = { from: a, to: e };
    else
      throw new Error("Invalid range");
  if (l?.from && l?.to) {
    const m = s.differenceInCalendarDays(l.to, l.from);
    r > 0 && m > r ? l = { from: e, to: void 0 } : n > 1 && m < n && (l = { from: e, to: void 0 });
  }
  return l;
}
function vh(e, t, n = ct) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const s = n.differenceInCalendarDays(e.to, e.from), a = Math.min(s, 6);
  for (let i = 0; i <= a; i++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Ya(e, t, n = ct) {
  return pt(e, t.from, !1, n) || pt(e, t.to, !1, n) || pt(t, e.from, !1, n) || pt(t, e.to, !1, n);
}
function yh(e, t, n = ct) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((i) => typeof i != "function").some((i) => typeof i == "boolean" ? i : n.isDate(i) ? pt(e, i, !1, n) : yi(i, n) ? i.some((c) => pt(e, c, !1, n)) : Pr(i) ? i.from && i.to ? Ya(e, { from: i.from, to: i.to }, n) : !1 : vi(i) ? vh(e, i.dayOfWeek, n) : Fo(i) ? n.isAfter(i.before, i.after) ? Ya(e, {
    from: n.addDays(i.after, 1),
    to: n.addDays(i.before, -1)
  }, n) : gt(e.from, i, n) || gt(e.to, i, n) : jo(i) || Bo(i) ? gt(e.from, i, n) || gt(e.to, i, n) : !1))
    return !0;
  const a = r.filter((i) => typeof i == "function");
  if (a.length) {
    let i = e.from;
    const c = n.differenceInCalendarDays(e.to, e.from);
    for (let d = 0; d <= c; d++) {
      if (a.some((f) => f(i)))
        return !0;
      i = n.addDays(i, 1);
    }
  }
  return !1;
}
function wh(e, t) {
  const { disabled: n, excludeDisabled: r, resetOnSelect: o, selected: s, required: a, onSelect: i } = e, [c, d] = Tr(s, i ? s : void 0), f = i ? s : c;
  return {
    selected: f,
    select: (p, b, v) => {
      const { min: y, max: x } = e;
      let _;
      if (p) {
        const S = f?.from, D = f?.to, N = !!S && !!D, k = !!S && !!D && t.isSameDay(S, D) && t.isSameDay(p, S);
        o && (N || !f?.from) ? !a && k ? _ = void 0 : _ = { from: p, to: void 0 } : _ = bh(p, f, y, x, a, t);
      }
      return r && n && _?.from && _.to && yh({ from: _.from, to: _.to }, n, t) && (_.from = p, _.to = void 0), i || d(_), i?.(_, p, b, v), _;
    },
    isSelected: (p) => f && pt(f, p, !1, t)
  };
}
function xh(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [s, a] = Tr(n, o ? n : void 0), i = o ? n : s, { isSameDay: c } = t;
  return {
    selected: i,
    select: (l, m, p) => {
      let b = l;
      return !r && i && i && c(l, i) && (b = void 0), o || a(b), o?.(b, l, m, p), b;
    },
    isSelected: (l) => i ? c(i, l) : !1
  };
}
function kh(e, t) {
  const n = xh(e, t), r = gh(e, t), o = wh(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function Ze(e, t) {
  return e instanceof ze && e.timeZone === t ? e : new ze(e, t);
}
function Jt(e, t, n) {
  return Ze(e, t);
}
function Ha(e, t, n) {
  return typeof e == "boolean" || typeof e == "function" ? e : e instanceof Date ? Jt(e, t) : Array.isArray(e) ? e.map((r) => r instanceof Date ? Jt(r, t) : r) : Pr(e) ? {
    ...e,
    from: e.from ? Ze(e.from, t) : e.from,
    to: e.to ? Ze(e.to, t) : e.to
  } : Fo(e) ? {
    before: Jt(e.before, t),
    after: Jt(e.after, t)
  } : jo(e) ? {
    after: Jt(e.after, t)
  } : Bo(e) ? {
    before: Jt(e.before, t)
  } : e;
}
function Kr(e, t, n) {
  return e && (Array.isArray(e) ? e.map((r) => Ha(r, t)) : Ha(e, t));
}
function _h(e) {
  let t = e;
  const n = t.timeZone;
  if (n && (t = {
    ...e,
    timeZone: n
  }, t.today && (t.today = Ze(t.today, n)), t.month && (t.month = Ze(t.month, n)), t.defaultMonth && (t.defaultMonth = Ze(t.defaultMonth, n)), t.startMonth && (t.startMonth = Ze(t.startMonth, n)), t.endMonth && (t.endMonth = Ze(t.endMonth, n)), t.mode === "single" && t.selected ? t.selected = Ze(t.selected, n) : t.mode === "multiple" && t.selected ? t.selected = t.selected?.map((L) => Ze(L, n)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? Ze(t.selected.from, n) : t.selected.from,
    to: t.selected.to ? Ze(t.selected.to, n) : t.selected.to
  }), t.disabled !== void 0 && (t.disabled = Kr(t.disabled, n)), t.hidden !== void 0 && (t.hidden = Kr(t.hidden, n)), t.modifiers)) {
    const L = {};
    Object.keys(t.modifiers).forEach((oe) => {
      L[oe] = Kr(t.modifiers?.[oe], n);
    }), t.modifiers = L;
  }
  const { components: r, formatters: o, labels: s, dateLib: a, locale: i, classNames: c } = bt(() => {
    const L = { ...pi, ...t.locale }, oe = t.broadcastCalendar ? 1 : t.weekStartsOn, H = t.noonSafe && t.timeZone ? Qm(t.timeZone, {
      weekStartsOn: oe,
      locale: L
    }) : void 0, ee = t.dateLib && H ? { ...H, ...t.dateLib } : t.dateLib ?? H, Ee = new je({
      locale: L,
      weekStartsOn: oe,
      firstWeekContainsDate: t.firstWeekContainsDate,
      useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
      timeZone: t.timeZone,
      numerals: t.numerals
    }, ee);
    return {
      dateLib: Ee,
      components: Tm(t.components),
      formatters: Lm(t.formatters),
      labels: Gm(t.labels, Ee.options),
      locale: L,
      classNames: { ...Zo(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.noonSafe,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]);
  t.today || (t = { ...t, today: a.today() });
  const { captionLayout: d, mode: f, navLayout: l, numberOfMonths: m = 1, onDayBlur: p, onDayClick: b, onDayFocus: v, onDayKeyDown: y, onDayMouseEnter: x, onDayMouseLeave: _, onNextClick: S, onPrevClick: D, showWeekNumber: N, styles: k } = t, { formatCaption: P, formatDay: O, formatMonthDropdown: B, formatWeekNumber: Z, formatWeekNumberHeader: J, formatWeekdayName: Y, formatYearDropdown: Q } = o, re = fh(t, a), { days: ce, months: U, navStart: ne, navEnd: we, previousMonth: le, nextMonth: I, goToMonth: ue } = re, z = Mm(ce, t, ne, we, a), { isSelected: T, select: W, selected: M } = kh(t, a) ?? {}, { blur: F, focused: X, isFocusTarget: q, moveFocus: G, setFocused: Ce } = ph(t, re, z, T ?? (() => !1), a), { labelDayButton: Ue, labelGridcell: We, labelGrid: Mt, labelMonthDropdown: Qe, labelNav: Yn, labelPrevious: Hn, labelNext: Pt, labelWeekday: Un, labelWeekNumber: Ve, labelWeekNumberHeader: Br, labelYearDropdown: Zr } = s, Me = bt(() => Km(a, t.ISOWeek, t.broadcastCalendar, t.today), [a, t.ISOWeek, t.broadcastCalendar, t.today]), dt = f !== void 0 || b !== void 0, yn = Oe(() => {
    le && (ue(le), D?.(le));
  }, [le, ue, D]), wn = Oe(() => {
    I && (ue(I), S?.(I));
  }, [ue, I, S]), Gt = Oe((L, oe) => (H) => {
    H.preventDefault(), H.stopPropagation(), Ce(L), !oe.disabled && (W?.(L.date, oe, H), b?.(L.date, oe, H));
  }, [W, b, Ce]), Lr = Oe((L, oe) => (H) => {
    Ce(L), v?.(L.date, oe, H);
  }, [v, Ce]), Vn = Oe((L, oe) => (H) => {
    F(), p?.(L.date, oe, H);
  }, [F, p]), xn = Oe((L, oe) => (H) => {
    const ee = {
      ArrowLeft: [
        H.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        H.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [H.shiftKey ? "year" : "week", "after"],
      ArrowUp: [H.shiftKey ? "year" : "week", "before"],
      PageUp: [H.shiftKey ? "year" : "month", "before"],
      PageDown: [H.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (ee[H.key]) {
      H.preventDefault(), H.stopPropagation();
      const [Ee, A] = ee[H.key];
      G(Ee, A);
    }
    y?.(L.date, oe, H);
  }, [G, y, t.dir]), wt = Oe((L, oe) => (H) => {
    x?.(L.date, oe, H);
  }, [x]), Gn = Oe((L, oe) => (H) => {
    _?.(L.date, oe, H);
  }, [_]), xt = Oe((L) => (oe) => {
    const H = Number(oe.target.value), ee = a.setMonth(a.startOfMonth(L), H);
    ue(ee);
  }, [a, ue]), Yr = Oe((L) => (oe) => {
    const H = Number(oe.target.value), ee = a.setYear(a.startOfMonth(L), H);
    ue(ee);
  }, [a, ue]), { className: Hr, style: qn } = bt(() => ({
    className: [c[j.Root], t.className].filter(Boolean).join(" "),
    style: { ...k?.[j.Root], ...t.style }
  }), [c, t.className, t.style, k]), Jn = Im(t), Kn = Nt(null);
  rh(Kn, !!t.animate, {
    classNames: c,
    months: U,
    focused: X,
    dateLib: a
  });
  const kn = {
    dayPickerProps: t,
    selected: M,
    select: W,
    isSelected: T,
    months: U,
    nextMonth: I,
    previousMonth: le,
    goToMonth: ue,
    getModifiers: z,
    components: r,
    classNames: c,
    styles: k,
    labels: s,
    formatters: o
  };
  return w.createElement(
    bi.Provider,
    { value: kn },
    w.createElement(
      r.Root,
      { rootRef: t.animate ? Kn : void 0, className: Hr, style: qn, dir: t.dir, id: t.id, lang: t.lang ?? i.code, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], "aria-labelledby": t["aria-labelledby"], ...Jn },
      w.createElement(
        r.Months,
        { className: c[j.Months], style: k?.[j.Months] },
        !t.hideNavigation && !l && w.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[j.Nav], style: k?.[j.Nav], "aria-label": Yn(), onPreviousClick: yn, onNextClick: wn, previousMonth: le, nextMonth: I }),
        U.map((L, oe) => w.createElement(
          r.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: c[j.Month],
            style: k?.[j.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: oe,
            displayIndex: oe,
            calendarMonth: L
          },
          l === "around" && !t.hideNavigation && oe === 0 && w.createElement(
            r.PreviousMonthButton,
            { type: "button", className: c[j.PreviousMonthButton], tabIndex: le ? void 0 : -1, "aria-disabled": le ? void 0 : !0, "aria-label": Hn(le), onClick: yn, "data-animated-button": t.animate ? "true" : void 0 },
            w.createElement(r.Chevron, { disabled: le ? void 0 : !0, className: c[j.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          w.createElement(r.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: c[j.MonthCaption], style: k?.[j.MonthCaption], calendarMonth: L, displayIndex: oe }, d?.startsWith("dropdown") ? w.createElement(
            r.DropdownNav,
            { className: c[j.Dropdowns], style: k?.[j.Dropdowns] },
            (() => {
              const H = d === "dropdown" || d === "dropdown-months" ? w.createElement(r.MonthsDropdown, { key: "month", className: c[j.MonthsDropdown], "aria-label": Qe(), classNames: c, components: r, disabled: !!t.disableNavigation, onChange: xt(L.date), options: qm(L.date, ne, we, o, a), style: k?.[j.Dropdown], value: a.getMonth(L.date) }) : w.createElement("span", { key: "month" }, B(L.date, a)), ee = d === "dropdown" || d === "dropdown-years" ? w.createElement(r.YearsDropdown, { key: "year", className: c[j.YearsDropdown], "aria-label": Zr(a.options), classNames: c, components: r, disabled: !!t.disableNavigation, onChange: Yr(L.date), options: Xm(ne, we, o, a, !!t.reverseYears), style: k?.[j.Dropdown], value: a.getYear(L.date) }) : w.createElement("span", { key: "year" }, Q(L.date, a));
              return a.getMonthYearOrder() === "year-first" ? [ee, H] : [H, ee];
            })(),
            w.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, P(L.date, a.options, a))
          ) : w.createElement(r.CaptionLabel, { className: c[j.CaptionLabel], role: "status", "aria-live": "polite" }, P(L.date, a.options, a))),
          l === "around" && !t.hideNavigation && oe === m - 1 && w.createElement(
            r.NextMonthButton,
            { type: "button", className: c[j.NextMonthButton], tabIndex: I ? void 0 : -1, "aria-disabled": I ? void 0 : !0, "aria-label": Pt(I), onClick: wn, "data-animated-button": t.animate ? "true" : void 0 },
            w.createElement(r.Chevron, { disabled: I ? void 0 : !0, className: c[j.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          oe === m - 1 && l === "after" && !t.hideNavigation && w.createElement(r.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: c[j.Nav], style: k?.[j.Nav], "aria-label": Yn(), onPreviousClick: yn, onNextClick: wn, previousMonth: le, nextMonth: I }),
          w.createElement(
            r.MonthGrid,
            { role: "grid", "aria-multiselectable": f === "multiple" || f === "range", "aria-label": Mt(L.date, a.options, a) || void 0, className: c[j.MonthGrid], style: k?.[j.MonthGrid] },
            !t.hideWeekdays && w.createElement(
              r.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: c[j.Weekdays], style: k?.[j.Weekdays] },
              N && w.createElement(r.WeekNumberHeader, { "aria-label": Br(a.options), className: c[j.WeekNumberHeader], style: k?.[j.WeekNumberHeader], scope: "col" }, J()),
              Me.map((H) => w.createElement(r.Weekday, { "aria-label": Un(H, a.options, a), className: c[j.Weekday], key: String(H), style: k?.[j.Weekday], scope: "col" }, Y(H, a.options, a)))
            ),
            w.createElement(r.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: c[j.Weeks], style: k?.[j.Weeks] }, L.weeks.map((H) => w.createElement(
              r.Week,
              { className: c[j.Week], key: H.weekNumber, style: k?.[j.Week], week: H },
              N && w.createElement(r.WeekNumber, { week: H, style: k?.[j.WeekNumber], "aria-label": Ve(H.weekNumber, {
                locale: i
              }), className: c[j.WeekNumber], scope: "row", role: "rowheader" }, Z(H.weekNumber, a)),
              H.days.map((ee) => {
                const { date: Ee } = ee, A = z(ee);
                if (A[fe.focused] = !A.hidden && !!X?.isEqualTo(ee), A[Ke.selected] = T?.(Ee) || A.selected, Pr(M)) {
                  const { from: kt, to: pe } = M;
                  A[Ke.range_start] = !!(kt && pe && a.isSameDay(Ee, kt)), A[Ke.range_end] = !!(kt && pe && a.isSameDay(Ee, pe)), A[Ke.range_middle] = pt(M, Ee, !0, a);
                }
                const ge = Jm(A, k, t.modifiersStyles), _e = Pm(A, c, t.modifiersClassNames), Pe = !dt && !A.hidden ? We(Ee, A, a.options, a) : void 0;
                return w.createElement(r.Day, { key: `${ee.isoDate}_${ee.displayMonthId}`, day: ee, modifiers: A, className: _e.join(" "), style: ge, role: "gridcell", "aria-selected": A.selected || void 0, "aria-label": Pe, "data-day": ee.isoDate, "data-month": ee.outside ? ee.dateMonthId : void 0, "data-selected": A.selected || void 0, "data-disabled": A.disabled || void 0, "data-hidden": A.hidden || void 0, "data-outside": ee.outside || void 0, "data-focused": A.focused || void 0, "data-today": A.today || void 0 }, !A.hidden && dt ? w.createElement(r.DayButton, { className: c[j.DayButton], style: k?.[j.DayButton], type: "button", day: ee, modifiers: A, disabled: !A.focused && A.disabled || void 0, "aria-disabled": A.focused && A.disabled || void 0, tabIndex: q(ee) ? 0 : -1, "aria-label": Ue(Ee, A, a.options, a), onClick: Gt(ee, A), onBlur: Vn(ee, A), onFocus: Lr(ee, A), onKeyDown: xn(ee, A), onMouseEnter: wt(ee, A), onMouseLeave: Gn(ee, A) }, O(Ee, a.options, a)) : !A.hidden && O(ee.date, a.options, a));
              })
            )))
          )
        ))
      ),
      t.footer && w.createElement(r.Footer, { className: c[j.Footer], style: k?.[j.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function Pi({
  className: e,
  classNames: t,
  showOutsideDays: n = !0,
  captionLayout: r = "label",
  buttonVariant: o = "ghost",
  formatters: s,
  components: a,
  ...i
}) {
  const c = Zo();
  return /* @__PURE__ */ u(
    _h,
    {
      showOutsideDays: n,
      className: g(
        "group/calendar bg-background p-3 [--cell-size:--spacing(8)] [[data-slot=card-content]_&]:bg-transparent [[data-slot=popover-content]_&]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        e
      ),
      captionLayout: r,
      formatters: {
        formatMonthDropdown: (d) => d.toLocaleString("default", { month: "short" }),
        ...s
      },
      classNames: {
        root: g("w-fit", c.root),
        months: g(
          "relative flex flex-col gap-4 md:flex-row",
          c.months
        ),
        month: g("flex w-full flex-col gap-4", c.month),
        nav: g(
          "absolute inset-x-0 top-0 flex w-full items-center justify-between gap-1",
          c.nav
        ),
        button_previous: g(
          Pn({ variant: o }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          c.button_previous
        ),
        button_next: g(
          Pn({ variant: o }),
          "size-(--cell-size) p-0 select-none aria-disabled:opacity-50",
          c.button_next
        ),
        month_caption: g(
          "flex h-(--cell-size) w-full items-center justify-center px-(--cell-size)",
          c.month_caption
        ),
        dropdowns: g(
          "flex h-(--cell-size) w-full items-center justify-center gap-1.5 text-sm font-medium",
          c.dropdowns
        ),
        dropdown_root: g(
          "relative rounded-md border border-input shadow-xs has-focus:border-ring has-focus:ring-[3px] has-focus:ring-ring/50",
          c.dropdown_root
        ),
        dropdown: g(
          "absolute inset-0 bg-popover opacity-0",
          c.dropdown
        ),
        caption_label: g(
          "font-medium select-none",
          r === "label" ? "text-sm" : "flex h-8 items-center gap-1 rounded-md pr-1 pl-2 text-sm [&>svg]:size-3.5 [&>svg]:text-muted-foreground",
          c.caption_label
        ),
        table: "w-full border-collapse",
        weekdays: g("flex", c.weekdays),
        weekday: g(
          "flex-1 rounded-md text-[0.8rem] font-normal text-muted-foreground select-none",
          c.weekday
        ),
        week: g("mt-2 flex w-full", c.week),
        week_number_header: g(
          "w-(--cell-size) select-none",
          c.week_number_header
        ),
        week_number: g(
          "text-[0.8rem] text-muted-foreground select-none",
          c.week_number
        ),
        day: g(
          "group/day relative aspect-square h-full w-full p-0 text-center select-none [&:last-child[data-selected=true]_button]:rounded-r-md",
          i.showWeekNumber ? "[&:nth-child(2)[data-selected=true]_button]:rounded-l-md" : "[&:first-child[data-selected=true]_button]:rounded-l-md",
          c.day
        ),
        range_start: g(
          "rounded-l-md bg-accent",
          c.range_start
        ),
        range_middle: g("rounded-none", c.range_middle),
        range_end: g("rounded-r-md bg-accent", c.range_end),
        today: g(
          "rounded-md bg-accent text-accent-foreground data-[selected=true]:rounded-none",
          c.today
        ),
        outside: g(
          "text-muted-foreground aria-selected:text-muted-foreground",
          c.outside
        ),
        disabled: g(
          "text-muted-foreground opacity-50",
          c.disabled
        ),
        hidden: g("invisible", c.hidden),
        ...t
      },
      components: {
        Root: ({ className: d, rootRef: f, ...l }) => /* @__PURE__ */ u(
          "div",
          {
            "data-slot": "calendar",
            ref: f,
            className: g(d),
            ...l
          }
        ),
        Chevron: ({ className: d, orientation: f, ...l }) => f === "left" ? /* @__PURE__ */ u(Id, { className: g("size-4", d), ...l }) : f === "right" ? /* @__PURE__ */ u(
          Wn,
          {
            className: g("size-4", d),
            ...l
          }
        ) : /* @__PURE__ */ u(zr, { className: g("size-4", d), ...l }),
        DayButton: Sh,
        WeekNumber: ({ children: d, ...f }) => /* @__PURE__ */ u("td", { ...f, children: /* @__PURE__ */ u("div", { className: "flex size-(--cell-size) items-center justify-center text-center", children: d }) }),
        ...a
      },
      ...i
    }
  );
}
function Sh({
  className: e,
  day: t,
  modifiers: n,
  ...r
}) {
  const o = Zo(), s = Nt(null);
  Ct(() => {
    n.focused && s.current?.focus();
  }, [n.focused]);
  const { color: a, ...i } = r;
  return /* @__PURE__ */ u(
    at,
    {
      ref: s,
      variant: "ghost",
      size: "icon",
      "data-day": t.date.toLocaleDateString(),
      "data-selected-single": n.selected && !n.range_start && !n.range_end && !n.range_middle,
      "data-range-start": n.range_start,
      "data-range-end": n.range_end,
      "data-range-middle": n.range_middle,
      className: g(
        "flex aspect-square size-auto w-full min-w-(--cell-size) flex-col gap-1 leading-none font-normal group-data-[focused=true]/day:relative group-data-[focused=true]/day:z-10 group-data-[focused=true]/day:border-ring group-data-[focused=true]/day:ring-[3px] group-data-[focused=true]/day:ring-ring/50 data-[range-end=true]:rounded-md data-[range-end=true]:rounded-r-md data-[range-end=true]:bg-primary data-[range-end=true]:text-primary-foreground data-[range-middle=true]:rounded-none data-[range-middle=true]:bg-accent data-[range-middle=true]:text-accent-foreground data-[range-start=true]:rounded-md data-[range-start=true]:rounded-l-md data-[range-start=true]:bg-primary data-[range-start=true]:text-primary-foreground data-[selected-single=true]:bg-primary data-[selected-single=true]:text-primary-foreground dark:hover:text-accent-foreground [&>span]:text-xs [&>span]:opacity-70",
        o.day,
        e
      ),
      ...i
    }
  );
}
function Nh({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ga.Root,
    {
      "data-slot": "checkbox",
      className: g(
        "peer size-4 shrink-0 rounded-sm border border-input shadow-xs transition-shadow outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:aria-invalid:ring-destructive/40 dark:data-[state=checked]:bg-primary",
        e
      ),
      ...t,
      children: /* @__PURE__ */ u(
        ga.Indicator,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none",
          children: /* @__PURE__ */ u(Er, { className: "size-3.5" })
        }
      )
    }
  );
}
function Ch({
  ...e
}) {
  return /* @__PURE__ */ u(To.Root, { "data-slot": "collapsible", ...e });
}
function Oh({
  ...e
}) {
  return /* @__PURE__ */ u(
    To.CollapsibleTrigger,
    {
      "data-slot": "collapsible-trigger",
      ...e
    }
  );
}
function Dh({
  ...e
}) {
  return /* @__PURE__ */ u(
    To.CollapsibleContent,
    {
      "data-slot": "collapsible-content",
      ...e
    }
  );
}
function Ho({
  ...e
}) {
  return /* @__PURE__ */ u(Mn.Root, { "data-slot": "popover", ...e });
}
function Uo({
  ...e
}) {
  return /* @__PURE__ */ u(Mn.Trigger, { "data-slot": "popover-trigger", ...e });
}
function Vo({
  className: e,
  align: t = "center",
  sideOffset: n = 4,
  ...r
}) {
  return /* @__PURE__ */ u(Mn.Portal, { children: /* @__PURE__ */ u(
    Mn.Content,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: n,
      className: g(
        "z-50 w-72 origin-(--radix-popover-content-transform-origin) rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-hidden data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...r
    }
  ) });
}
function Mk({
  ...e
}) {
  return /* @__PURE__ */ u(Mn.Anchor, { "data-slot": "popover-anchor", ...e });
}
var Ua = 1, Eh = 0.9, zh = 0.8, Mh = 0.17, Xr = 0.1, Qr = 0.999, Ph = 0.9999, Th = 0.99, Ih = /[\\\/_+.#"@\[\(\{&]/, Ah = /[\\\/_+.#"@\[\(\{&]/g, $h = /[\s-]/, Ti = /[\s-]/g;
function fo(e, t, n, r, o, s, a) {
  if (s === t.length) return o === e.length ? Ua : Th;
  var i = `${o},${s}`;
  if (a[i] !== void 0) return a[i];
  for (var c = r.charAt(s), d = n.indexOf(c, o), f = 0, l, m, p, b; d >= 0; ) l = fo(e, t, n, r, d + 1, s + 1, a), l > f && (d === o ? l *= Ua : Ih.test(e.charAt(d - 1)) ? (l *= zh, p = e.slice(o, d - 1).match(Ah), p && o > 0 && (l *= Math.pow(Qr, p.length))) : $h.test(e.charAt(d - 1)) ? (l *= Eh, b = e.slice(o, d - 1).match(Ti), b && o > 0 && (l *= Math.pow(Qr, b.length))) : (l *= Mh, o > 0 && (l *= Math.pow(Qr, d - o))), e.charAt(d) !== t.charAt(s) && (l *= Ph)), (l < Xr && n.charAt(d - 1) === r.charAt(s + 1) || r.charAt(s + 1) === r.charAt(s) && n.charAt(d - 1) !== r.charAt(s)) && (m = fo(e, t, n, r, d + 1, s + 2, a), m * Xr > l && (l = m * Xr)), l > f && (f = l), d = n.indexOf(c, d + 1);
  return a[i] = f, f;
}
function Va(e) {
  return e.toLowerCase().replace(Ti, " ");
}
function Rh(e, t, n) {
  return e = n && n.length > 0 ? `${e + " " + n.join(" ")}` : e, fo(e, t, Va(e), Va(t), 0, 0, {});
}
var Wh = Object.defineProperty, pn = (e, t) => Wh(e, "name", { value: t, configurable: !0 }), Ii = !!(typeof window < "u" && window.document && window.document.createElement);
function Rt(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return /* @__PURE__ */ pn(function(o) {
    if (e?.(o), n === !1 || !o || !o.defaultPrevented)
      return t?.(o);
  }, "handleEvent");
}
pn(Rt, "composeEventHandlers");
function Fh(e) {
  if (!Ii)
    throw new Error("Cannot access window outside of the DOM");
  return e?.ownerDocument?.defaultView ?? window;
}
pn(Fh, "getOwnerWindow");
function mo(e) {
  if (!Ii)
    throw new Error("Cannot access document outside of the DOM");
  return e?.ownerDocument ?? document;
}
pn(mo, "getOwnerDocument");
function Ai(e, t = !1) {
  const { activeElement: n } = mo(e);
  if (!n?.nodeName)
    return null;
  if ($i(n) && n.contentDocument)
    return Ai(n.contentDocument.body, t);
  if (t) {
    const r = n.getAttribute("aria-activedescendant");
    if (r) {
      const o = mo(n).getElementById(r);
      if (o)
        return o;
    }
  }
  return n;
}
pn(Ai, "getActiveElement");
function $i(e) {
  return e.tagName === "IFRAME";
}
pn($i, "isFrame");
var jh = Object.defineProperty, Go = (e, t) => jh(e, "name", { value: t, configurable: !0 });
function ho(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
Go(ho, "setRef");
function Wt(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const s = ho(o, t);
      return !n && typeof s == "function" && (n = !0), s;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const s = r[o];
          typeof s == "function" ? s() : ho(e[o], null);
        }
      };
  };
}
Go(Wt, "composeRefs");
function gn(...e) {
  return h.useCallback(Wt(...e), e);
}
Go(gn, "useComposedRefs");
var Bh = Object.defineProperty, Le = (e, t) => Bh(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function Zh(e, t) {
  const n = h.createContext(t);
  n.displayName = e + "Context";
  const r = /* @__PURE__ */ Le((s) => {
    const { children: a, ...i } = s, c = h.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ u(n.Provider, { value: c, children: a });
  }, "Provider");
  r.displayName = e + "Provider";
  function o(s, a = {}) {
    const { optional: i = !1 } = a, c = h.useContext(n);
    if (c) return c;
    if (t !== void 0) return t;
    if (!i)
      throw new Error(`\`${s}\` must be used within \`${e}\``);
  }
  return Le(o, "useContext"), [r, o];
}
Le(Zh, "createContext");
// @__NO_SIDE_EFFECTS__
function Ri(e, t = []) {
  let n = [];
  function r(s, a) {
    const i = h.createContext(a);
    i.displayName = s + "Context";
    const c = n.length;
    n = [...n, a];
    const d = /* @__PURE__ */ Le((l) => {
      const { scope: m, children: p, ...b } = l, v = m?.[e]?.[c] || i, y = h.useMemo(() => b, Object.values(b));
      return /* @__PURE__ */ u(v.Provider, { value: y, children: p });
    }, "Provider");
    d.displayName = s + "Provider";
    function f(l, m, p = {}) {
      const { optional: b = !1 } = p, v = m?.[e]?.[c] || i, y = h.useContext(v);
      if (y) return y;
      if (a !== void 0) return a;
      if (!b)
        throw new Error(`\`${l}\` must be used within \`${s}\``);
    }
    return Le(f, "useContext"), [d, f];
  }
  Le(r, "createContext");
  const o = /* @__PURE__ */ Le(() => {
    const s = n.map((a) => h.createContext(a));
    return /* @__PURE__ */ Le(function(i) {
      const c = i?.[e] || s;
      return h.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: c } }),
        [i, c]
      );
    }, "useScope");
  }, "createScope");
  return o.scopeName = e, [r, Wi(o, ...t)];
}
Le(Ri, "createContextScope");
function Wi(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = /* @__PURE__ */ Le(() => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return /* @__PURE__ */ Le(function(s) {
      const a = r.reduce((i, { useScope: c, scopeName: d }) => {
        const l = c(s)[`__scope${d}`];
        return { ...i, ...l };
      }, {});
      return h.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    }, "useComposedScopes");
  }, "createScope");
  return n.scopeName = t.scopeName, n;
}
Le(Wi, "composeContextScopes");
var fn = globalThis?.document ? h.useLayoutEffect : () => {
}, Lh = Object.defineProperty, Yh = (e, t) => Lh(e, "name", { value: t, configurable: !0 }), Hh = h[" useId ".trim().toString()] || (() => {
}), Uh = 0;
function st(e) {
  const [t, n] = h.useState(Hh());
  return fn(() => {
    e || n((r) => r ?? String(Uh++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
Yh(st, "useId");
var Vh = Object.defineProperty, Gh = (e, t) => Vh(e, "name", { value: t, configurable: !0 }), Ga = h[" useEffectEvent ".trim().toString()], qa = h[" useInsertionEffect ".trim().toString()];
function Fi(e) {
  if (typeof Ga == "function")
    return Ga(e);
  const t = h.useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return typeof qa == "function" ? qa(() => {
    t.current = e;
  }) : fn(() => {
    t.current = e;
  }), h.useMemo(() => ((...n) => t.current?.(...n)), []);
}
Gh(Fi, "useEffectEvent");
var qh = Object.defineProperty, Zn = (e, t) => qh(e, "name", { value: t, configurable: !0 }), Jh = h[" useInsertionEffect ".trim().toString()] || fn;
function ji({
  prop: e,
  defaultProp: t,
  onChange: n = /* @__PURE__ */ Zn(() => {
  }, "onChange"),
  caller: r
}) {
  const [o, s, a] = Bi({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, c = i ? e : o, d = h.useCallback(
    (f) => {
      if (i) {
        const l = Zi(f) ? f(e) : f;
        l !== e && a.current?.(l);
      } else
        s(f);
    },
    [i, e, s, a]
  );
  return [c, d];
}
Zn(ji, "useControllableState");
function Bi({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = h.useState(e), o = h.useRef(n), s = h.useRef(t);
  return Jh(() => {
    s.current = t;
  }, [t]), h.useEffect(() => {
    o.current !== n && (s.current?.(n), o.current = n);
  }, [n, o]), [n, r, s];
}
Zn(Bi, "useUncontrolledState");
function Zi(e) {
  return typeof e == "function";
}
Zn(Zi, "isFunction");
var Ja = /* @__PURE__ */ Symbol("RADIX:SYNC_STATE");
function Kh(e, t, n, r) {
  const { prop: o, defaultProp: s, onChange: a, caller: i } = t, c = o !== void 0, d = Fi(a), f = [{ ...n, state: s }];
  r && f.push(r);
  const [l, m] = h.useReducer(
    (y, x) => {
      if (x.type === Ja)
        return { ...y, state: x.state };
      const _ = e(y, x);
      return c && !Object.is(_.state, y.state) && d(_.state), _;
    },
    ...f
  ), p = l.state, b = h.useRef(p);
  h.useEffect(() => {
    b.current !== p && (b.current = p, c || d(p));
  }, [p, b, c]);
  const v = h.useMemo(() => o !== void 0 ? { ...l, state: o } : l, [l, o]);
  return h.useEffect(() => {
    c && !Object.is(o, l.state) && m({ type: Ja, state: o });
  }, [o, l.state, c]), [v, m];
}
Zn(Kh, "useControllableStateReducer");
var Xh = Object.defineProperty, Xe = (e, t) => Xh(e, "name", { value: t, configurable: !0 });
// @__NO_SIDE_EFFECTS__
function qo(e) {
  const t = h.forwardRef((n, r) => {
    let { children: o, ...s } = n, a = null, i = !1;
    const c = [];
    po(o) && typeof nr == "function" && (o = nr(o._payload)), h.Children.forEach(o, (m) => {
      if (Ui(m)) {
        i = !0;
        const p = m;
        let b = "child" in p.props ? p.props.child : p.props.children;
        po(b) && typeof nr == "function" && (b = nr(b._payload)), a = ep(p, b), c.push(a?.props?.children);
      } else
        c.push(m);
    }), a ? a = h.cloneElement(a, void 0, c) : (
      // A `Slottable` was found but it didn't resolve to a single element (e.g.
      // it wrapped multiple elements, text, or a render-prop `child` that
      // wasn't an element). Don't fall back to treating the `Slottable` wrapper
      // itself as the slot target — throw a descriptive error below instead.
      !i && h.Children.count(o) === 1 && h.isValidElement(o) && (a = o)
    );
    const d = a ? Hi(a) : void 0, f = gn(r, d);
    if (!a) {
      if (o || o === 0)
        throw new Error(
          i ? rp(e) : np(e)
        );
      return o;
    }
    const l = Yi(s, a.props ?? {});
    return a.type !== h.Fragment && (l.ref = r ? f : d), h.cloneElement(a, l);
  });
  return t.displayName = `${e}.Slot`, t;
}
Xe(qo, "createSlot");
var Li = /* @__PURE__ */ Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Qh(e) {
  const t = /* @__PURE__ */ Xe((n) => "child" in n ? n.children(n.child) : n.children, "Slottable");
  return t.displayName = `${e}.Slottable`, t.__radixId = Li, t;
}
Xe(Qh, "createSlottable");
var ep = /* @__PURE__ */ Xe((e, t) => {
  if ("child" in e.props) {
    const n = e.props.child;
    return h.isValidElement(n) ? h.cloneElement(n, void 0, e.props.children(n.props.children)) : null;
  }
  return h.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Yi(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], s = t[r];
    /^on[A-Z]/.test(r) ? o && s ? n[r] = (...i) => {
      const c = s(...i);
      return o(...i), c;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...s } : r === "className" && (n[r] = [o, s].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
Xe(Yi, "mergeProps");
function Hi(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Xe(Hi, "getElementRef");
function Ui(e) {
  return h.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Li;
}
Xe(Ui, "isSlottable");
var tp = /* @__PURE__ */ Symbol.for("react.lazy");
function po(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === tp && "_payload" in e && Vi(e._payload);
}
Xe(po, "isLazyComponent");
function Vi(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
Xe(Vi, "isPromiseLike");
var np = /* @__PURE__ */ Xe((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), rp = /* @__PURE__ */ Xe((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), nr = h[" use ".trim().toString()], op = Object.defineProperty, ap = (e, t) => op(e, "name", { value: t, configurable: !0 }), sp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ye = sp.reduce((e, t) => {
  const n = /* @__PURE__ */ qo(`Primitive.${t}`), r = h.forwardRef((o, s) => {
    const { asChild: a, ...i } = o, c = a ? n : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ u(c, { ...i, ref: s });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Gi(e, t) {
  e && Es.flushSync(() => e.dispatchEvent(t));
}
ap(Gi, "dispatchDiscreteCustomEvent");
var ip = Object.defineProperty, cp = (e, t) => ip(e, "name", { value: t, configurable: !0 });
function mn(e) {
  const t = h.useRef(e);
  return h.useEffect(() => {
    t.current = e;
  }), h.useMemo(() => ((...n) => t.current?.(...n)), []);
}
cp(mn, "useCallbackRef");
var lp = Object.defineProperty, Se = (e, t) => lp(e, "name", { value: t, configurable: !0 }), go = "dismissableLayer.update", dp = "dismissableLayer.pointerDownOutside", up = "dismissableLayer.focusOutside", Ka, qi = h.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set(),
  // Outside elements that belong to a layer's own dismiss affordance (eg, a
  // dialog overlay). Pressing them should dismiss the layer regardless of
  // whether or not they stop propagation.
  //
  // See https://github.com/radix-ui/primitives/issues/3346
  dismissableSurfaces: /* @__PURE__ */ new Set()
}), fp = /* @__PURE__ */ h.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ Se(function(t, n) {
    const {
      disableOutsidePointerEvents: r = !1,
      deferPointerDownOutside: o = !1,
      onEscapeKeyDown: s,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: c,
      onDismiss: d,
      ...f
    } = t, l = h.useContext(qi), [m, p] = h.useState(null), b = m?.ownerDocument ?? globalThis?.document, [, v] = h.useState({}), y = gn(n, p), x = Array.from(l.layers), [_] = [
      ...l.layersWithOutsidePointerEventsDisabled
    ].slice(-1), S = _ ? x.indexOf(_) : -1, D = m ? x.indexOf(m) : -1, N = l.layersWithOutsidePointerEventsDisabled.size > 0, k = D >= S, P = h.useRef(!1), O = Ki(
      (Y) => {
        a?.(Y), c?.(Y), Y.defaultPrevented || d?.();
      },
      {
        ownerDocument: b,
        deferPointerDownOutside: o,
        isDeferredPointerDownOutsideRef: P,
        dismissableSurfaces: l.dismissableSurfaces,
        shouldHandlePointerDownOutside: h.useCallback(
          (Y) => {
            if (!(Y instanceof Node))
              return !1;
            const Q = [...l.branches].some(
              (re) => re.contains(Y)
            );
            return k && !Q;
          },
          [l.branches, k]
        )
      }
    ), B = Xi((Y) => {
      if (o && P.current)
        return;
      const Q = Y.target;
      [...l.branches].some((ce) => ce.contains(Q)) || (i?.(Y), c?.(Y), Y.defaultPrevented || d?.());
    }, b), Z = m ? D === x.length - 1 : !1, J = mn((Y) => {
      Y.key === "Escape" && (s?.(Y), !Y.defaultPrevented && d && (Y.preventDefault(), d()));
    });
    return h.useEffect(() => {
      if (Z)
        return b.addEventListener("keydown", J, { capture: !0 }), () => b.removeEventListener("keydown", J, { capture: !0 });
    }, [b, Z, J]), h.useEffect(() => {
      if (m)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Ka = b.body.style.pointerEvents, b.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(m)), l.layers.add(m), bo(), () => {
          r && (l.layersWithOutsidePointerEventsDisabled.delete(m), l.layersWithOutsidePointerEventsDisabled.size === 0 && (b.body.style.pointerEvents = Ka));
        };
    }, [m, b, r, l]), h.useEffect(() => () => {
      m && (l.layers.delete(m), l.layersWithOutsidePointerEventsDisabled.delete(m), bo());
    }, [m, l]), h.useEffect(() => {
      const Y = /* @__PURE__ */ Se(() => v({}), "handleUpdate");
      return document.addEventListener(go, Y), () => document.removeEventListener(go, Y);
    }, []), /* @__PURE__ */ u(
      Ye.div,
      {
        ...f,
        ref: y,
        style: {
          pointerEvents: N ? k ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: Rt(t.onFocusCapture, B.onFocusCapture),
        onBlurCapture: Rt(t.onBlurCapture, B.onBlurCapture),
        onPointerDownCapture: Rt(
          t.onPointerDownCapture,
          O.onPointerDownCapture
        )
      }
    );
  }, "DismissableLayer")
);
function Ji() {
  const e = h.useContext(qi), [t, n] = h.useState(null);
  return h.useEffect(() => {
    if (t)
      return e.dismissableSurfaces.add(t), () => {
        e.dismissableSurfaces.delete(t);
      };
  }, [t, e.dismissableSurfaces]), n;
}
Se(Ji, "useDismissableLayerSurface");
var mp = /* @__PURE__ */ Se(() => !0, "IS_TRUE");
function Ki(e, t) {
  const {
    ownerDocument: n = globalThis?.document,
    deferPointerDownOutside: r = !1,
    isDeferredPointerDownOutsideRef: o,
    dismissableSurfaces: s,
    shouldHandlePointerDownOutside: a = mp
  } = t, i = mn(e), c = h.useRef(!1), d = h.useRef(!1), f = h.useRef(/* @__PURE__ */ new Map()), l = h.useRef(() => {
  });
  return h.useEffect(() => {
    function m() {
      d.current = !1, o.current = !1, f.current.clear();
    }
    Se(m, "resetOutsideInteraction");
    function p() {
      return Array.from(f.current.values()).some(Boolean);
    }
    Se(p, "isOutsideInteractionIntercepted");
    function b(S) {
      if (!d.current)
        return;
      const D = S.target;
      D instanceof Node && [...s].some((k) => k.contains(D)) || f.current.set(S.type, !0), S.type === "click" && window.setTimeout(() => {
        d.current && l.current();
      }, 0);
    }
    Se(b, "handleInteractionCapture");
    function v(S) {
      d.current && f.current.set(S.type, !1);
    }
    Se(v, "handleInteractionBubble");
    const y = /* @__PURE__ */ Se((S) => {
      if (S.target && !c.current) {
        let D = function() {
          n.removeEventListener("click", l.current);
          const k = p();
          m(), k || Jo(
            dp,
            i,
            N,
            { discrete: !0 }
          );
        };
        if (Se(D, "handleAndDispatchPointerDownOutsideEvent"), !a(S.target)) {
          n.removeEventListener("click", l.current), m(), c.current = !1;
          return;
        }
        const N = { originalEvent: S };
        d.current = !0, o.current = r && S.button === 0, f.current.clear(), !r || S.button !== 0 ? D() : (n.removeEventListener("click", l.current), l.current = D, n.addEventListener("click", l.current, { once: !0 }));
      } else
        n.removeEventListener("click", l.current), m();
      c.current = !1;
    }, "handlePointerDown"), x = [
      "pointerup",
      "mousedown",
      "mouseup",
      "touchstart",
      "touchend",
      "click"
    ];
    for (const S of x)
      n.addEventListener(S, b, !0), n.addEventListener(S, v);
    const _ = window.setTimeout(() => {
      n.addEventListener("pointerdown", y);
    }, 0);
    return () => {
      window.clearTimeout(_), n.removeEventListener("pointerdown", y), n.removeEventListener("click", l.current);
      for (const S of x)
        n.removeEventListener(S, b, !0), n.removeEventListener(S, v);
    };
  }, [
    n,
    i,
    r,
    o,
    s,
    a
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: /* @__PURE__ */ Se(() => c.current = !0, "onPointerDownCapture")
  };
}
Se(Ki, "usePointerDownOutside");
function Xi(e, t = globalThis?.document) {
  const n = mn(e), r = h.useRef(!1);
  return h.useEffect(() => {
    const o = /* @__PURE__ */ Se((s) => {
      s.target && !r.current && Jo(up, n, { originalEvent: s }, {
        discrete: !1
      });
    }, "handleFocus");
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: /* @__PURE__ */ Se(() => r.current = !0, "onFocusCapture"),
    onBlurCapture: /* @__PURE__ */ Se(() => r.current = !1, "onBlurCapture")
  };
}
Se(Xi, "useFocusOutside");
function bo() {
  const e = new CustomEvent(go);
  document.dispatchEvent(e);
}
Se(bo, "dispatchUpdate");
function Jo(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, s = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Gi(o, s) : o.dispatchEvent(s);
}
Se(Jo, "handleAndDispatchCustomEvent");
var hp = Object.defineProperty, Ie = (e, t) => hp(e, "name", { value: t, configurable: !0 }), eo = "focusScope.autoFocusOnMount", to = "focusScope.autoFocusOnUnmount", Xa = { bubbles: !1, cancelable: !0 }, pp = /* @__PURE__ */ h.forwardRef(
  /* @__PURE__ */ Ie(function(t, n) {
    const {
      loop: r = !1,
      trapped: o = !1,
      onMountAutoFocus: s,
      onUnmountAutoFocus: a,
      ...i
    } = t, [c, d] = h.useState(null), f = mn(s), l = mn(a), m = h.useRef(null), p = gn(n, d), b = h.useRef({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }).current;
    h.useEffect(() => {
      if (o) {
        let y = function(D) {
          if (b.paused || !c) return;
          const N = D.target;
          c.contains(N) ? m.current = N : ft(m.current, { select: !0 });
        }, x = function(D) {
          if (b.paused || !c) return;
          const N = D.relatedTarget;
          N !== null && (c.contains(N) || ft(m.current, { select: !0 }));
        }, _ = function(D) {
          if (document.activeElement === document.body)
            for (const k of D)
              k.removedNodes.length > 0 && ft(c);
        };
        Ie(y, "handleFocusIn"), Ie(x, "handleFocusOut"), Ie(_, "handleMutations"), document.addEventListener("focusin", y), document.addEventListener("focusout", x);
        const S = new MutationObserver(_);
        return c && S.observe(c, { childList: !0, subtree: !0 }), () => {
          document.removeEventListener("focusin", y), document.removeEventListener("focusout", x), S.disconnect();
        };
      }
    }, [o, c, b.paused]), h.useEffect(() => {
      if (c) {
        Qa.add(b);
        const y = document.activeElement;
        if (!c.contains(y)) {
          const _ = new CustomEvent(eo, Xa);
          c.addEventListener(eo, f), c.dispatchEvent(_), _.defaultPrevented || (Qi(oc(Ko(c)), { select: !0 }), document.activeElement === y && ft(c));
        }
        return () => {
          c.removeEventListener(eo, f), setTimeout(() => {
            const _ = new CustomEvent(to, Xa);
            c.addEventListener(to, l), c.dispatchEvent(_), _.defaultPrevented || ft(y ?? document.body, { select: !0 }), c.removeEventListener(to, l), Qa.remove(b);
          }, 0);
        };
      }
    }, [c, f, l, b]);
    const v = h.useCallback(
      (y) => {
        if (!r && !o || b.paused) return;
        const x = y.key === "Tab" && !y.altKey && !y.ctrlKey && !y.metaKey, _ = document.activeElement;
        if (x && _) {
          const S = y.currentTarget, [D, N] = ec(S);
          D && N ? !y.shiftKey && _ === N ? (y.preventDefault(), r && ft(D, { select: !0 })) : y.shiftKey && _ === D && (y.preventDefault(), r && ft(N, { select: !0 })) : _ === S && y.preventDefault();
        }
      },
      [r, o, b.paused]
    );
    return /* @__PURE__ */ u(Ye.div, { tabIndex: -1, ...i, ref: p, onKeyDown: v });
  }, "FocusScope")
);
function Qi(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (ft(r, { select: t }), document.activeElement !== n) return;
}
Ie(Qi, "focusFirst");
function ec(e) {
  const t = Ko(e), n = vo(t, e), r = vo(t.reverse(), e);
  return [n, r];
}
Ie(ec, "getTabbableEdges");
function Ko(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: /* @__PURE__ */ Ie((r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }, "acceptNode")
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
Ie(Ko, "getTabbableCandidates");
function vo(e, t) {
  const n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
  for (const r of e)
    if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : tc(r, { upTo: t })))
      return r;
}
Ie(vo, "findVisible");
function tc(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
Ie(tc, "isHidden");
function nc(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
Ie(nc, "isSelectableInput");
function ft(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && nc(e) && t && e.select();
  }
}
Ie(ft, "focus");
var Qa = rc();
function rc() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && n?.pause(), e = yo(e, t), e.unshift(t);
    },
    remove(t) {
      e = yo(e, t), e[0]?.resume();
    }
  };
}
Ie(rc, "createFocusScopesStack");
function yo(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
Ie(yo, "arrayRemove");
function oc(e) {
  return e.filter((t) => t.tagName !== "A");
}
Ie(oc, "removeLinks");
var gp = Object.defineProperty, bp = (e, t) => gp(e, "name", { value: t, configurable: !0 }), vp = /* @__PURE__ */ h.forwardRef(
  /* @__PURE__ */ bp(function(t, n) {
    const { container: r, ...o } = t, [s, a] = h.useState(!1);
    fn(() => a(!0), []);
    const i = r || s && globalThis?.document?.body;
    return i ? Es.createPortal(/* @__PURE__ */ u(Ye.div, { ...o, ref: n }), i) : null;
  }, "Portal")
), yp = Object.defineProperty, vt = (e, t) => yp(e, "name", { value: t, configurable: !0 });
function ac(e, t) {
  return h.useReducer((n, r) => t[n][r] ?? n, e);
}
vt(ac, "useStateMachine");
var Xo = /* @__PURE__ */ vt((e) => {
  const { present: t, children: n } = e, r = sc(t), o = typeof n == "function" ? n({ present: r.isPresent }) : h.Children.only(n), s = ic(r.ref, cc(o));
  return typeof n == "function" || r.isPresent ? h.cloneElement(o, { ref: s }) : null;
}, "Presence");
function sc(e) {
  const [t, n] = h.useState(), r = h.useRef(null), o = h.useRef(e), s = h.useRef("none"), a = h.useRef(void 0), i = e ? "mounted" : "unmounted", [c, d] = ac(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return h.useEffect(() => {
    c === "mounted" ? (s.current = a.current ?? nn(r.current), a.current = void 0) : s.current = "none";
  }, [c]), fn(() => {
    const f = r.current, l = o.current;
    if (l !== e) {
      const p = s.current, b = nn(f);
      e ? (a.current = b, d("MOUNT")) : b === "none" || f?.display === "none" ? d("UNMOUNT") : d(l && p !== b ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, d]), fn(() => {
    if (t) {
      let f;
      const l = t.ownerDocument.defaultView ?? window, m = /* @__PURE__ */ vt((b) => {
        const y = nn(r.current).includes(CSS.escape(b.animationName));
        if (b.target === t && y && (d("ANIMATION_END"), !o.current)) {
          const x = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", f = l.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = x);
          });
        }
      }, "handleAnimationEnd"), p = /* @__PURE__ */ vt((b) => {
        b.target === t && (s.current = nn(r.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", p), t.addEventListener("animationcancel", m), t.addEventListener("animationend", m), () => {
        l.clearTimeout(f), t.removeEventListener("animationstart", p), t.removeEventListener("animationcancel", m), t.removeEventListener("animationend", m);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: h.useCallback((f) => {
      if (f) {
        const l = getComputedStyle(f);
        r.current = l, a.current = nn(l);
      } else
        r.current = null;
      n(f);
    }, [])
  };
}
vt(sc, "usePresence");
function wo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
vt(wo, "setRef");
function ic(...e) {
  const t = h.useRef(e);
  return t.current = e, h.useCallback((n) => {
    const r = t.current;
    let o = !1;
    const s = r.map((a) => {
      const i = wo(a, n);
      return !o && typeof i == "function" && (o = !0), i;
    });
    if (o)
      return () => {
        for (let a = 0; a < s.length; a++) {
          const i = s[a];
          typeof i == "function" ? i() : wo(r[a], null);
        }
      };
  }, []);
}
vt(ic, "useStableComposedRefs");
function nn(e) {
  return e?.animationName || "none";
}
vt(nn, "getAnimationName");
function cc(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
vt(cc, "getElementRef");
var wp = Object.defineProperty, Qo = (e, t) => wp(e, "name", { value: t, configurable: !0 }), rr = 0, Kt = null;
function xp(e) {
  return ea(), e.children;
}
Qo(xp, "FocusGuards");
function ea() {
  h.useEffect(() => {
    Kt || (Kt = { start: xo(), end: xo() });
    const { start: e, end: t } = Kt;
    return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), rr++, () => {
      rr === 1 && (Kt?.start.remove(), Kt?.end.remove(), Kt = null), rr = Math.max(0, rr - 1);
    };
  }, []);
}
Qo(ea, "useFocusGuards");
function xo() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Qo(xo, "createFocusGuard");
var rt = function() {
  return rt = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var s in n) Object.prototype.hasOwnProperty.call(n, s) && (t[s] = n[s]);
    }
    return t;
  }, rt.apply(this, arguments);
};
function lc(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function kp(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, s; r < o; r++)
    (s || !(r in t)) && (s || (s = Array.prototype.slice.call(t, 0, r)), s[r] = t[r]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var pr = "right-scroll-bar-position", gr = "width-before-scroll-bar", _p = "with-scroll-bars-hidden", Sp = "--removed-body-scroll-bar-size";
function no(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Np(e, t) {
  var n = he(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Cp = typeof window < "u" ? h.useLayoutEffect : h.useEffect, es = /* @__PURE__ */ new WeakMap();
function Op(e, t) {
  var n = Np(null, function(r) {
    return e.forEach(function(o) {
      return no(o, r);
    });
  });
  return Cp(function() {
    var r = es.get(n);
    if (r) {
      var o = new Set(r), s = new Set(e), a = n.current;
      o.forEach(function(i) {
        s.has(i) || no(i, null);
      }), s.forEach(function(i) {
        o.has(i) || no(i, a);
      });
    }
    es.set(n, e);
  }, [e]), n;
}
function Dp(e) {
  return e;
}
function Ep(e, t) {
  t === void 0 && (t = Dp);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(s) {
      var a = t(s, r);
      return n.push(a), function() {
        n = n.filter(function(i) {
          return i !== a;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(s);
      }
      n = {
        push: function(i) {
          return s(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var a = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(s), a = n;
      }
      var c = function() {
        var f = a;
        a = [], f.forEach(s);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), n = {
        push: function(f) {
          a.push(f), d();
        },
        filter: function(f) {
          return a = a.filter(f), n;
        }
      };
    }
  };
  return o;
}
function zp(e) {
  e === void 0 && (e = {});
  var t = Ep(null);
  return t.options = rt({ async: !0, ssr: !1 }, e), t;
}
var dc = function(e) {
  var t = e.sideCar, n = lc(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return h.createElement(r, rt({}, n));
};
dc.isSideCarExport = !0;
function Mp(e, t) {
  return e.useMedium(t), dc;
}
var uc = zp(), ro = function() {
}, Ir = h.forwardRef(function(e, t) {
  var n = h.useRef(null), r = h.useState({
    onScrollCapture: ro,
    onWheelCapture: ro,
    onTouchMoveCapture: ro
  }), o = r[0], s = r[1], a = e.forwardProps, i = e.children, c = e.className, d = e.removeScrollBar, f = e.enabled, l = e.shards, m = e.sideCar, p = e.noRelative, b = e.noIsolation, v = e.inert, y = e.allowPinchZoom, x = e.as, _ = x === void 0 ? "div" : x, S = e.gapMode, D = lc(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), N = m, k = Op([n, t]), P = rt(rt({}, D), o);
  return h.createElement(
    h.Fragment,
    null,
    f && h.createElement(N, { sideCar: uc, removeScrollBar: d, shards: l, noRelative: p, noIsolation: b, inert: v, setCallbacks: s, allowPinchZoom: !!y, lockRef: n, gapMode: S }),
    a ? h.cloneElement(h.Children.only(i), rt(rt({}, P), { ref: k })) : h.createElement(_, rt({}, P, { className: c, ref: k }), i)
  );
});
Ir.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ir.classNames = {
  fullWidth: gr,
  zeroRight: pr
};
var Pp = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Tp() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Pp();
  return t && e.setAttribute("nonce", t), e;
}
function Ip(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Ap(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var $p = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Tp()) && (Ip(t, n), Ap(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Rp = function() {
  var e = $p();
  return function(t, n) {
    h.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, fc = function() {
  var e = Rp(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Wp = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, oo = function(e) {
  return parseInt(e || "", 10) || 0;
}, Fp = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [oo(n), oo(r), oo(o)];
}, jp = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Wp;
  var t = Fp(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Bp = fc(), cn = "data-scroll-locked", Zp = function(e, t, n, r) {
  var o = e.left, s = e.top, a = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(_p, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(cn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(pr, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(gr, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(pr, " .").concat(pr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(gr, " .").concat(gr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(cn, `] {
    `).concat(Sp, ": ").concat(i, `px;
  }
`);
}, ts = function() {
  var e = parseInt(document.body.getAttribute(cn) || "0", 10);
  return isFinite(e) ? e : 0;
}, Lp = function() {
  h.useEffect(function() {
    return document.body.setAttribute(cn, (ts() + 1).toString()), function() {
      var e = ts() - 1;
      e <= 0 ? document.body.removeAttribute(cn) : document.body.setAttribute(cn, e.toString());
    };
  }, []);
}, Yp = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Lp();
  var s = h.useMemo(function() {
    return jp(o);
  }, [o]);
  return h.createElement(Bp, { styles: Zp(s, !t, o, n ? "" : "!important") });
}, ko = !1;
if (typeof window < "u")
  try {
    var or = Object.defineProperty({}, "passive", {
      get: function() {
        return ko = !0, !0;
      }
    });
    window.addEventListener("test", or, or), window.removeEventListener("test", or, or);
  } catch {
    ko = !1;
  }
var Xt = ko ? { passive: !1 } : !1, Hp = function(e) {
  return e.tagName === "TEXTAREA";
}, mc = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Hp(e) && n[t] === "visible")
  );
}, Up = function(e) {
  return mc(e, "overflowY");
}, Vp = function(e) {
  return mc(e, "overflowX");
}, ns = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = hc(e, r);
    if (o) {
      var s = pc(e, r), a = s[1], i = s[2];
      if (a > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Gp = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, qp = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, hc = function(e, t) {
  return e === "v" ? Up(t) : Vp(t);
}, pc = function(e, t) {
  return e === "v" ? Gp(t) : qp(t);
}, Jp = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Kp = function(e, t, n, r, o) {
  var s = Jp(e, window.getComputedStyle(t).direction), a = s * r, i = n.target, c = t.contains(i), d = !1, f = a > 0, l = 0, m = 0;
  do {
    if (!i)
      break;
    var p = pc(e, i), b = p[0], v = p[1], y = p[2], x = v - y - s * b;
    (b || x) && hc(e, i) && (l += x, m += b);
    var _ = i.parentNode;
    i = _ && _.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? _.host : _;
  } while (
    // portaled content
    !c && i !== document.body || // self content
    c && (t.contains(i) || t === i)
  );
  return (f && Math.abs(l) < 1 || !f && Math.abs(m) < 1) && (d = !0), d;
}, ar = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, rs = function(e) {
  return [e.deltaX, e.deltaY];
}, os = function(e) {
  return e && "current" in e ? e.current : e;
}, Xp = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Qp = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, eg = 0, Qt = [];
function tg(e) {
  var t = h.useRef([]), n = h.useRef([0, 0]), r = h.useRef(), o = h.useState(eg++)[0], s = h.useState(fc)[0], a = h.useRef(e);
  h.useEffect(function() {
    a.current = e;
  }, [e]), h.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = kp([e.lockRef.current], (e.shards || []).map(os), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = h.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !a.current.allowPinchZoom;
    var x = ar(v), _ = n.current, S = "deltaX" in v ? v.deltaX : _[0] - x[0], D = "deltaY" in v ? v.deltaY : _[1] - x[1], N, k = v.target, P = Math.abs(S) > Math.abs(D) ? "h" : "v";
    if ("touches" in v && P === "h" && k.type === "range")
      return !1;
    var O = window.getSelection(), B = O && O.anchorNode, Z = B ? B === k || B.contains(k) : !1;
    if (Z)
      return !1;
    var J = ns(P, k);
    if (!J)
      return !0;
    if (J ? N = P : (N = P === "v" ? "h" : "v", J = ns(P, k)), !J)
      return !1;
    if (!r.current && "changedTouches" in v && (S || D) && (r.current = N), !N)
      return !0;
    var Y = r.current || N;
    return Kp(Y, y, v, Y === "h" ? S : D);
  }, []), c = h.useCallback(function(v) {
    var y = v;
    if (!(!Qt.length || Qt[Qt.length - 1] !== s)) {
      var x = "deltaY" in y ? rs(y) : ar(y), _ = t.current.filter(function(N) {
        return N.name === y.type && (N.target === y.target || y.target === N.shadowParent) && Xp(N.delta, x);
      })[0];
      if (_ && _.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!_) {
        var S = (a.current.shards || []).map(os).filter(Boolean).filter(function(N) {
          return N.contains(y.target);
        }), D = S.length > 0 ? i(y, S[0]) : !a.current.noIsolation;
        D && y.cancelable && y.preventDefault();
      }
    }
  }, []), d = h.useCallback(function(v, y, x, _) {
    var S = { name: v, delta: y, target: x, should: _, shadowParent: ng(x) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(D) {
        return D !== S;
      });
    }, 1);
  }, []), f = h.useCallback(function(v) {
    n.current = ar(v), r.current = void 0;
  }, []), l = h.useCallback(function(v) {
    d(v.type, rs(v), v.target, i(v, e.lockRef.current));
  }, []), m = h.useCallback(function(v) {
    d(v.type, ar(v), v.target, i(v, e.lockRef.current));
  }, []);
  h.useEffect(function() {
    return Qt.push(s), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", c, Xt), document.addEventListener("touchmove", c, Xt), document.addEventListener("touchstart", f, Xt), function() {
      Qt = Qt.filter(function(v) {
        return v !== s;
      }), document.removeEventListener("wheel", c, Xt), document.removeEventListener("touchmove", c, Xt), document.removeEventListener("touchstart", f, Xt);
    };
  }, []);
  var p = e.removeScrollBar, b = e.inert;
  return h.createElement(
    h.Fragment,
    null,
    b ? h.createElement(s, { styles: Qp(o) }) : null,
    p ? h.createElement(Yp, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function ng(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const rg = Mp(uc, tg);
var gc = h.forwardRef(function(e, t) {
  return h.createElement(Ir, rt({}, e, { ref: t, sideCar: rg }));
});
gc.classNames = Ir.classNames;
var og = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, en = /* @__PURE__ */ new WeakMap(), sr = /* @__PURE__ */ new WeakMap(), ir = {}, ao = 0, bc = function(e) {
  return e && (e.host || bc(e.parentNode));
}, ag = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = bc(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, sg = function(e, t, n, r) {
  var o = ag(t, Array.isArray(e) ? e : [e]);
  ir[n] || (ir[n] = /* @__PURE__ */ new WeakMap());
  var s = ir[n], a = [], i = /* @__PURE__ */ new Set(), c = new Set(o), d = function(l) {
    !l || i.has(l) || (i.add(l), d(l.parentNode));
  };
  o.forEach(d);
  var f = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(m) {
      if (i.has(m))
        f(m);
      else
        try {
          var p = m.getAttribute(r), b = p !== null && p !== "false", v = (en.get(m) || 0) + 1, y = (s.get(m) || 0) + 1;
          en.set(m, v), s.set(m, y), a.push(m), v === 1 && b && sr.set(m, !0), y === 1 && m.setAttribute(n, "true"), b || m.setAttribute(r, "true");
        } catch (x) {
          console.error("aria-hidden: cannot operate on ", m, x);
        }
    });
  };
  return f(t), i.clear(), ao++, function() {
    a.forEach(function(l) {
      var m = en.get(l) - 1, p = s.get(l) - 1;
      en.set(l, m), s.set(l, p), m || (sr.has(l) || l.removeAttribute(r), sr.delete(l)), p || l.removeAttribute(n);
    }), ao--, ao || (en = /* @__PURE__ */ new WeakMap(), en = /* @__PURE__ */ new WeakMap(), sr = /* @__PURE__ */ new WeakMap(), ir = {});
  };
}, ig = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = og(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), sg(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, cg = Object.defineProperty, yt = (e, t) => cg(e, "name", { value: t, configurable: !0 }), ta = "Dialog", [vc, Pk] = /* @__PURE__ */ Ri(ta), [lg, Ht] = vc(ta), dg = /* @__PURE__ */ yt((e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: s,
    modal: a = !0
  } = e, i = h.useRef(null), c = h.useRef(null), [d, f] = ji({
    prop: r,
    defaultProp: o ?? !1,
    onChange: s,
    caller: ta
  }), [l, m] = h.useState(0), [p, b] = h.useState(0);
  return /* @__PURE__ */ u(
    lg,
    {
      scope: t,
      triggerRef: i,
      contentRef: c,
      contentId: st(),
      titleId: st(),
      descriptionId: st(),
      titlePresent: l > 0,
      descriptionPresent: p > 0,
      setTitleCount: m,
      setDescriptionCount: b,
      open: d,
      onOpenChange: f,
      onOpenToggle: h.useCallback(() => f((v) => !v), [f]),
      modal: a,
      children: n
    }
  );
}, "Dialog"), yc = "DialogPortal", [ug, wc] = vc(yc, {
  forceMount: void 0
}), fg = /* @__PURE__ */ yt((e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, s = Ht(yc, t);
  return /* @__PURE__ */ u(ug, { scope: t, forceMount: n, children: h.Children.map(r, (a) => /* @__PURE__ */ u(Xo, { present: n || s.open, children: /* @__PURE__ */ u(vp, { asChild: !0, container: o, children: a }) })) });
}, "DialogPortal"), _o = "DialogOverlay", mg = /* @__PURE__ */ h.forwardRef(
  /* @__PURE__ */ yt(function(t, n) {
    const r = wc(_o, t.__scopeDialog), { forceMount: o = r.forceMount, ...s } = t, a = Ht(_o, t.__scopeDialog);
    return a.modal ? /* @__PURE__ */ u(Xo, { present: o || a.open, children: /* @__PURE__ */ u(pg, { ...s, ref: n }) }) : null;
  }, "DialogOverlay")
), hg = /* @__PURE__ */ qo("DialogOverlay.RemoveScroll"), pg = /* @__PURE__ */ h.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ yt(function(t, n) {
    const { __scopeDialog: r, ...o } = t, s = Ht(_o, r), a = Ji(), i = gn(n, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ u(gc, { as: hg, allowPinchZoom: !0, shards: [s.contentRef], children: /* @__PURE__ */ u(
        Ye.div,
        {
          "data-state": na(s.open),
          ...o,
          ref: i,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }, "DialogOverlayImpl")
), An = "DialogContent", gg = /* @__PURE__ */ h.forwardRef(
  /* @__PURE__ */ yt(function(t, n) {
    const r = wc(An, t.__scopeDialog), { forceMount: o = r.forceMount, ...s } = t, a = Ht(An, t.__scopeDialog);
    return /* @__PURE__ */ u(Xo, { present: o || a.open, children: a.modal ? /* @__PURE__ */ u(bg, { ...s, ref: n }) : /* @__PURE__ */ u(vg, { ...s, ref: n }) });
  }, "DialogContent")
), bg = /* @__PURE__ */ h.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ yt(function(t, n) {
    const r = Ht(An, t.__scopeDialog), o = h.useRef(null), s = gn(n, r.contentRef, o);
    return h.useEffect(() => {
      const a = o.current;
      if (a) return ig(a);
    }, []), /* @__PURE__ */ u(
      xc,
      {
        ...t,
        ref: s,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        onCloseAutoFocus: Rt(t.onCloseAutoFocus, (a) => {
          a.preventDefault(), r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Rt(t.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, c = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || c) && a.preventDefault();
        }),
        onFocusOutside: Rt(
          t.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }, "DialogContentModal")
), vg = /* @__PURE__ */ h.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ yt(function(t, n) {
    const r = Ht(An, t.__scopeDialog), o = h.useRef(!1), s = h.useRef(!1);
    return /* @__PURE__ */ u(
      xc,
      {
        ...t,
        ref: n,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          t.onCloseAutoFocus?.(a), a.defaultPrevented || (o.current || r.triggerRef.current?.focus(), a.preventDefault()), o.current = !1, s.current = !1;
        },
        onInteractOutside: (a) => {
          t.onInteractOutside?.(a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (s.current = !0));
          const i = a.target;
          r.triggerRef.current?.contains(i) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && s.current && a.preventDefault();
        }
      }
    );
  }, "DialogContentNonModal")
), xc = /* @__PURE__ */ h.forwardRef(
  // blank line to reduce diff noise
  /* @__PURE__ */ yt(function(t, n) {
    const { __scopeDialog: r, trapFocus: o, onOpenAutoFocus: s, onCloseAutoFocus: a, ...i } = t, c = Ht(An, r);
    return ea(), /* @__PURE__ */ u(dn, { children: /* @__PURE__ */ u(
      pp,
      {
        asChild: !0,
        loop: !0,
        trapped: o,
        onMountAutoFocus: s,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ u(
          fp,
          {
            role: "dialog",
            id: c.contentId,
            "aria-describedby": c.descriptionPresent ? c.descriptionId : void 0,
            "aria-labelledby": c.titlePresent ? c.titleId : void 0,
            "data-state": na(c.open),
            ...i,
            ref: n,
            deferPointerDownOutside: !0,
            onDismiss: () => c.onOpenChange(!1)
          }
        )
      }
    ) });
  }, "DialogContentImpl")
);
function na(e) {
  return e ? "open" : "closed";
}
yt(na, "getState");
var Cn = '[cmdk-group=""]', so = '[cmdk-group-items=""]', yg = '[cmdk-group-heading=""]', kc = '[cmdk-item=""]', as = `${kc}:not([aria-disabled="true"])`, So = "cmdk-item-select", rn = "data-value", wg = (e, t, n) => Rh(e, t, n), _c = h.createContext(void 0), Ln = () => h.useContext(_c), Sc = h.createContext(void 0), ra = () => h.useContext(Sc), Nc = h.createContext(void 0), Cc = h.forwardRef((e, t) => {
  let n = on(() => {
    var z, T;
    return { search: "", value: (T = (z = e.value) != null ? z : e.defaultValue) != null ? T : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = on(() => /* @__PURE__ */ new Set()), o = on(() => /* @__PURE__ */ new Map()), s = on(() => /* @__PURE__ */ new Map()), a = on(() => /* @__PURE__ */ new Set()), i = Oc(e), { label: c, children: d, value: f, onValueChange: l, filter: m, shouldFilter: p, loop: b, disablePointerSelection: v = !1, vimBindings: y = !0, ...x } = e, _ = st(), S = st(), D = st(), N = h.useRef(null), k = Mg();
  Ft(() => {
    if (f !== void 0) {
      let z = f.trim();
      n.current.value = z, P.emit();
    }
  }, [f]), Ft(() => {
    k(6, Q);
  }, []);
  let P = h.useMemo(() => ({ subscribe: (z) => (a.current.add(z), () => a.current.delete(z)), snapshot: () => n.current, setState: (z, T, W) => {
    var M, F, X, q;
    if (!Object.is(n.current[z], T)) {
      if (n.current[z] = T, z === "search") Y(), Z(), k(1, J);
      else if (z === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let G = document.getElementById(D);
          G ? G.focus() : (M = document.getElementById(_)) == null || M.focus();
        }
        if (k(7, () => {
          var G;
          n.current.selectedItemId = (G = re()) == null ? void 0 : G.id, P.emit();
        }), W || k(5, Q), ((F = i.current) == null ? void 0 : F.value) !== void 0) {
          let G = T ?? "";
          (q = (X = i.current).onValueChange) == null || q.call(X, G);
          return;
        }
      }
      P.emit();
    }
  }, emit: () => {
    a.current.forEach((z) => z());
  } }), []), O = h.useMemo(() => ({ value: (z, T, W) => {
    var M;
    T !== ((M = s.current.get(z)) == null ? void 0 : M.value) && (s.current.set(z, { value: T, keywords: W }), n.current.filtered.items.set(z, B(T, W)), k(2, () => {
      Z(), P.emit();
    }));
  }, item: (z, T) => (r.current.add(z), T && (o.current.has(T) ? o.current.get(T).add(z) : o.current.set(T, /* @__PURE__ */ new Set([z]))), k(3, () => {
    Y(), Z(), n.current.value || J(), P.emit();
  }), () => {
    s.current.delete(z), r.current.delete(z), n.current.filtered.items.delete(z);
    let W = re();
    k(4, () => {
      Y(), W?.getAttribute("id") === z && J(), P.emit();
    });
  }), group: (z) => (o.current.has(z) || o.current.set(z, /* @__PURE__ */ new Set()), () => {
    s.current.delete(z), o.current.delete(z);
  }), filter: () => i.current.shouldFilter, label: c || e["aria-label"], getDisablePointerSelection: () => i.current.disablePointerSelection, listId: _, inputId: D, labelId: S, listInnerRef: N }), []);
  function B(z, T) {
    var W, M;
    let F = (M = (W = i.current) == null ? void 0 : W.filter) != null ? M : wg;
    return z ? F(z, n.current.search, T) : 0;
  }
  function Z() {
    if (!n.current.search || i.current.shouldFilter === !1) return;
    let z = n.current.filtered.items, T = [];
    n.current.filtered.groups.forEach((M) => {
      let F = o.current.get(M), X = 0;
      F.forEach((q) => {
        let G = z.get(q);
        X = Math.max(G, X);
      }), T.push([M, X]);
    });
    let W = N.current;
    ce().sort((M, F) => {
      var X, q;
      let G = M.getAttribute("id"), Ce = F.getAttribute("id");
      return ((X = z.get(Ce)) != null ? X : 0) - ((q = z.get(G)) != null ? q : 0);
    }).forEach((M) => {
      let F = M.closest(so);
      F ? F.appendChild(M.parentElement === F ? M : M.closest(`${so} > *`)) : W.appendChild(M.parentElement === W ? M : M.closest(`${so} > *`));
    }), T.sort((M, F) => F[1] - M[1]).forEach((M) => {
      var F;
      let X = (F = N.current) == null ? void 0 : F.querySelector(`${Cn}[${rn}="${encodeURIComponent(M[0])}"]`);
      X?.parentElement.appendChild(X);
    });
  }
  function J() {
    let z = ce().find((W) => W.getAttribute("aria-disabled") !== "true"), T = z?.getAttribute(rn);
    P.setState("value", T || void 0);
  }
  function Y() {
    var z, T, W, M;
    if (!n.current.search || i.current.shouldFilter === !1) {
      n.current.filtered.count = r.current.size;
      return;
    }
    n.current.filtered.groups = /* @__PURE__ */ new Set();
    let F = 0;
    for (let X of r.current) {
      let q = (T = (z = s.current.get(X)) == null ? void 0 : z.value) != null ? T : "", G = (M = (W = s.current.get(X)) == null ? void 0 : W.keywords) != null ? M : [], Ce = B(q, G);
      n.current.filtered.items.set(X, Ce), Ce > 0 && F++;
    }
    for (let [X, q] of o.current) for (let G of q) if (n.current.filtered.items.get(G) > 0) {
      n.current.filtered.groups.add(X);
      break;
    }
    n.current.filtered.count = F;
  }
  function Q() {
    var z, T, W;
    let M = re();
    M && (((z = M.parentElement) == null ? void 0 : z.firstChild) === M && ((W = (T = M.closest(Cn)) == null ? void 0 : T.querySelector(yg)) == null || W.scrollIntoView({ block: "nearest" })), M.scrollIntoView({ block: "nearest" }));
  }
  function re() {
    var z;
    return (z = N.current) == null ? void 0 : z.querySelector(`${kc}[aria-selected="true"]`);
  }
  function ce() {
    var z;
    return Array.from(((z = N.current) == null ? void 0 : z.querySelectorAll(as)) || []);
  }
  function U(z) {
    let T = ce()[z];
    T && P.setState("value", T.getAttribute(rn));
  }
  function ne(z) {
    var T;
    let W = re(), M = ce(), F = M.findIndex((q) => q === W), X = M[F + z];
    (T = i.current) != null && T.loop && (X = F + z < 0 ? M[M.length - 1] : F + z === M.length ? M[0] : M[F + z]), X && P.setState("value", X.getAttribute(rn));
  }
  function we(z) {
    let T = re(), W = T?.closest(Cn), M;
    for (; W && !M; ) W = z > 0 ? Eg(W, Cn) : zg(W, Cn), M = W?.querySelector(as);
    M ? P.setState("value", M.getAttribute(rn)) : ne(z);
  }
  let le = () => U(ce().length - 1), I = (z) => {
    z.preventDefault(), z.metaKey ? le() : z.altKey ? we(1) : ne(1);
  }, ue = (z) => {
    z.preventDefault(), z.metaKey ? U(0) : z.altKey ? we(-1) : ne(-1);
  };
  return h.createElement(Ye.div, { ref: t, tabIndex: -1, ...x, "cmdk-root": "", onKeyDown: (z) => {
    var T;
    (T = x.onKeyDown) == null || T.call(x, z);
    let W = z.nativeEvent.isComposing || z.keyCode === 229;
    if (!(z.defaultPrevented || W)) switch (z.key) {
      case "n":
      case "j": {
        y && z.ctrlKey && I(z);
        break;
      }
      case "ArrowDown": {
        I(z);
        break;
      }
      case "p":
      case "k": {
        y && z.ctrlKey && ue(z);
        break;
      }
      case "ArrowUp": {
        ue(z);
        break;
      }
      case "Home": {
        z.preventDefault(), U(0);
        break;
      }
      case "End": {
        z.preventDefault(), le();
        break;
      }
      case "Enter": {
        z.preventDefault();
        let M = re();
        if (M) {
          let F = new Event(So);
          M.dispatchEvent(F);
        }
      }
    }
  } }, h.createElement("label", { "cmdk-label": "", htmlFor: O.inputId, id: O.labelId, style: Tg }, c), Ar(e, (z) => h.createElement(Sc.Provider, { value: P }, h.createElement(_c.Provider, { value: O }, z))));
}), xg = h.forwardRef((e, t) => {
  var n, r;
  let o = st(), s = h.useRef(null), a = h.useContext(Nc), i = Ln(), c = Oc(e), d = (r = (n = c.current) == null ? void 0 : n.forceMount) != null ? r : a?.forceMount;
  Ft(() => {
    if (!d) return i.item(o, a?.id);
  }, [d]);
  let f = Dc(o, s, [e.value, e.children, s], e.keywords), l = ra(), m = Ot((k) => k.value && k.value === f.current), p = Ot((k) => d || i.filter() === !1 ? !0 : k.search ? k.filtered.items.get(o) > 0 : !0);
  h.useEffect(() => {
    let k = s.current;
    if (!(!k || e.disabled)) return k.addEventListener(So, b), () => k.removeEventListener(So, b);
  }, [p, e.onSelect, e.disabled]);
  function b() {
    var k, P;
    v(), (P = (k = c.current).onSelect) == null || P.call(k, f.current);
  }
  function v() {
    l.setState("value", f.current, !0);
  }
  if (!p) return null;
  let { disabled: y, value: x, onSelect: _, forceMount: S, keywords: D, ...N } = e;
  return h.createElement(Ye.div, { ref: Wt(s, t), ...N, id: o, "cmdk-item": "", role: "option", "aria-disabled": !!y, "aria-selected": !!m, "data-disabled": !!y, "data-selected": !!m, onPointerMove: y || i.getDisablePointerSelection() ? void 0 : v, onClick: y ? void 0 : b }, e.children);
}), kg = h.forwardRef((e, t) => {
  let { heading: n, children: r, forceMount: o, ...s } = e, a = st(), i = h.useRef(null), c = h.useRef(null), d = st(), f = Ln(), l = Ot((p) => o || f.filter() === !1 ? !0 : p.search ? p.filtered.groups.has(a) : !0);
  Ft(() => f.group(a), []), Dc(a, i, [e.value, e.heading, c]);
  let m = h.useMemo(() => ({ id: a, forceMount: o }), [o]);
  return h.createElement(Ye.div, { ref: Wt(i, t), ...s, "cmdk-group": "", role: "presentation", hidden: l ? void 0 : !0 }, n && h.createElement("div", { ref: c, "cmdk-group-heading": "", "aria-hidden": !0, id: d }, n), Ar(e, (p) => h.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": n ? d : void 0 }, h.createElement(Nc.Provider, { value: m }, p))));
}), _g = h.forwardRef((e, t) => {
  let { alwaysRender: n, ...r } = e, o = h.useRef(null), s = Ot((a) => !a.search);
  return !n && !s ? null : h.createElement(Ye.div, { ref: Wt(o, t), ...r, "cmdk-separator": "", role: "separator" });
}), Sg = h.forwardRef((e, t) => {
  let { onValueChange: n, ...r } = e, o = e.value != null, s = ra(), a = Ot((d) => d.search), i = Ot((d) => d.selectedItemId), c = Ln();
  return h.useEffect(() => {
    e.value != null && s.setState("search", e.value);
  }, [e.value]), h.createElement(Ye.input, { ref: t, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": c.listId, "aria-labelledby": c.labelId, "aria-activedescendant": i, id: c.inputId, type: "text", value: o ? e.value : a, onChange: (d) => {
    o || s.setState("search", d.target.value), n?.(d.target.value);
  } });
}), Ng = h.forwardRef((e, t) => {
  let { children: n, label: r = "Suggestions", ...o } = e, s = h.useRef(null), a = h.useRef(null), i = Ot((d) => d.selectedItemId), c = Ln();
  return h.useEffect(() => {
    if (a.current && s.current) {
      let d = a.current, f = s.current, l, m = new ResizeObserver(() => {
        l = requestAnimationFrame(() => {
          let p = d.offsetHeight;
          f.style.setProperty("--cmdk-list-height", p.toFixed(1) + "px");
        });
      });
      return m.observe(d), () => {
        cancelAnimationFrame(l), m.unobserve(d);
      };
    }
  }, []), h.createElement(Ye.div, { ref: Wt(s, t), ...o, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": i, "aria-label": r, id: c.listId }, Ar(e, (d) => h.createElement("div", { ref: Wt(a, c.listInnerRef), "cmdk-list-sizer": "" }, d)));
}), Cg = h.forwardRef((e, t) => {
  let { open: n, onOpenChange: r, overlayClassName: o, contentClassName: s, container: a, ...i } = e;
  return h.createElement(dg, { open: n, onOpenChange: r }, h.createElement(fg, { container: a }, h.createElement(mg, { "cmdk-overlay": "", className: o }), h.createElement(gg, { "aria-label": e.label, "cmdk-dialog": "", className: s }, h.createElement(Cc, { ref: t, ...i }))));
}), Og = h.forwardRef((e, t) => Ot((n) => n.filtered.count === 0) ? h.createElement(Ye.div, { ref: t, ...e, "cmdk-empty": "", role: "presentation" }) : null), Dg = h.forwardRef((e, t) => {
  let { progress: n, children: r, label: o = "Loading...", ...s } = e;
  return h.createElement(Ye.div, { ref: t, ...s, "cmdk-loading": "", role: "progressbar", "aria-valuenow": n, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": o }, Ar(e, (a) => h.createElement("div", { "aria-hidden": !0 }, a)));
}), Ut = Object.assign(Cc, { List: Ng, Item: xg, Input: Sg, Group: kg, Separator: _g, Dialog: Cg, Empty: Og, Loading: Dg });
function Eg(e, t) {
  let n = e.nextElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.nextElementSibling;
  }
}
function zg(e, t) {
  let n = e.previousElementSibling;
  for (; n; ) {
    if (n.matches(t)) return n;
    n = n.previousElementSibling;
  }
}
function Oc(e) {
  let t = h.useRef(e);
  return Ft(() => {
    t.current = e;
  }), t;
}
var Ft = typeof window > "u" ? h.useEffect : h.useLayoutEffect;
function on(e) {
  let t = h.useRef();
  return t.current === void 0 && (t.current = e()), t;
}
function Ot(e) {
  let t = ra(), n = () => e(t.snapshot());
  return h.useSyncExternalStore(t.subscribe, n, n);
}
function Dc(e, t, n, r = []) {
  let o = h.useRef(), s = Ln();
  return Ft(() => {
    var a;
    let i = (() => {
      var d;
      for (let f of n) {
        if (typeof f == "string") return f.trim();
        if (typeof f == "object" && "current" in f) return f.current ? (d = f.current.textContent) == null ? void 0 : d.trim() : o.current;
      }
    })(), c = r.map((d) => d.trim());
    s.value(e, i, c), (a = t.current) == null || a.setAttribute(rn, i), o.current = i;
  }), o;
}
var Mg = () => {
  let [e, t] = h.useState(), n = on(() => /* @__PURE__ */ new Map());
  return Ft(() => {
    n.current.forEach((r) => r()), n.current = /* @__PURE__ */ new Map();
  }, [e]), (r, o) => {
    n.current.set(r, o), t({});
  };
};
function Pg(e) {
  let t = e.type;
  return typeof t == "function" ? t(e.props) : "render" in t ? t.render(e.props) : e;
}
function Ar({ asChild: e, children: t }, n) {
  return e && h.isValidElement(t) ? h.cloneElement(Pg(t), { ref: t.ref }, n(t.props.children)) : n(t);
}
var Tg = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
function Ig({
  ...e
}) {
  return /* @__PURE__ */ u(ke.Root, { "data-slot": "dialog", ...e });
}
function Tk({
  ...e
}) {
  return /* @__PURE__ */ u(ke.Trigger, { "data-slot": "dialog-trigger", ...e });
}
function Ag({
  ...e
}) {
  return /* @__PURE__ */ u(ke.Portal, { "data-slot": "dialog-portal", ...e });
}
function Ik({
  ...e
}) {
  return /* @__PURE__ */ u(ke.Close, { "data-slot": "dialog-close", ...e });
}
function $g({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ke.Overlay,
    {
      "data-slot": "dialog-overlay",
      className: g(
        "fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function Rg({
  className: e,
  children: t,
  showCloseButton: n = !0,
  ...r
}) {
  return /* @__PURE__ */ E(Ag, { "data-slot": "dialog-portal", children: [
    /* @__PURE__ */ u($g, {}),
    /* @__PURE__ */ E(
      ke.Content,
      {
        "data-slot": "dialog-content",
        className: g(
          "fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border bg-background p-6 shadow-lg duration-200 outline-none data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:max-w-lg",
          e
        ),
        ...r,
        children: [
          t,
          n && /* @__PURE__ */ E(
            ke.Close,
            {
              "data-slot": "dialog-close",
              className: "absolute top-4 right-4 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
              children: [
                /* @__PURE__ */ u(ti, {}),
                /* @__PURE__ */ u("span", { className: "sr-only", children: "Close" })
              ]
            }
          )
        ]
      }
    )
  ] });
}
function Wg({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "dialog-header",
      className: g("flex flex-col gap-2 text-center sm:text-left", e),
      ...t
    }
  );
}
function Ak({
  className: e,
  showCloseButton: t = !1,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "dialog-footer",
      className: g(
        "flex flex-col-reverse gap-2 sm:flex-row sm:justify-end",
        e
      ),
      ...r,
      children: [
        n,
        t && /* @__PURE__ */ u(ke.Close, { asChild: !0, children: /* @__PURE__ */ u(at, { variant: "outline", children: "Close" }) })
      ]
    }
  );
}
function Fg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ke.Title,
    {
      "data-slot": "dialog-title",
      className: g("text-lg leading-none font-semibold", e),
      ...t
    }
  );
}
function jg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ke.Description,
    {
      "data-slot": "dialog-description",
      className: g("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Ec({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ut,
    {
      "data-slot": "command",
      className: g(
        "flex h-full w-full flex-col overflow-hidden rounded-md bg-popover text-popover-foreground",
        e
      ),
      ...t
    }
  );
}
function $k({
  title: e = "Command Palette",
  description: t = "Search for a command to run...",
  children: n,
  className: r,
  showCloseButton: o = !0,
  ...s
}) {
  return /* @__PURE__ */ E(Ig, { ...s, children: [
    /* @__PURE__ */ E(Wg, { className: "sr-only", children: [
      /* @__PURE__ */ u(Fg, { children: e }),
      /* @__PURE__ */ u(jg, { children: t })
    ] }),
    /* @__PURE__ */ u(
      Rg,
      {
        className: g("overflow-hidden p-0", r),
        showCloseButton: o,
        children: /* @__PURE__ */ u(Ec, { className: "**:data-[slot=command-input-wrapper]:h-12 **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground **:[[cmdk-group]]:px-2 [&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 **:[[cmdk-input-wrapper]_svg]:h-5 **:[[cmdk-input-wrapper]_svg]:w-5 **:[[cmdk-input]]:h-12 **:[[cmdk-item]]:px-2 **:[[cmdk-item]]:py-3 **:[[cmdk-item]_svg]:h-5 **:[[cmdk-item]_svg]:w-5", children: n })
      }
    )
  ] });
}
function Bg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "command-input-wrapper",
      className: "flex h-9 items-center gap-2 border-b px-3",
      children: [
        /* @__PURE__ */ u(yu, { className: "size-4 shrink-0 opacity-50" }),
        /* @__PURE__ */ u(
          Ut.Input,
          {
            "data-slot": "command-input",
            className: g(
              "flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50",
              e
            ),
            ...t
          }
        )
      ]
    }
  );
}
function Zg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ut.List,
    {
      "data-slot": "command-list",
      className: g(
        "max-h-75 scroll-py-1 overflow-x-hidden overflow-y-auto",
        e
      ),
      ...t
    }
  );
}
function Lg({
  ...e
}) {
  return /* @__PURE__ */ u(
    Ut.Empty,
    {
      "data-slot": "command-empty",
      className: "py-6 text-center text-sm",
      ...e
    }
  );
}
function Yg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ut.Group,
    {
      "data-slot": "command-group",
      className: g(
        "overflow-hidden p-1 text-foreground **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function Rk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ut.Separator,
    {
      "data-slot": "command-separator",
      className: g("-mx-1 h-px bg-border", e),
      ...t
    }
  );
}
function Hg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ut.Item,
    {
      "data-slot": "command-item",
      className: g(
        "relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled=true]:pointer-events-none data-[disabled=true]:opacity-50 data-[selected=true]:bg-accent data-[selected=true]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function Wk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "span",
    {
      "data-slot": "command-shortcut",
      className: g(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function Fk({
  items: e,
  value: t,
  onSelect: n,
  placeholder: r = "Select...",
  searchPlaceholder: o = "Search...",
  emptyMessage: s = "No results found.",
  className: a,
  icon: i,
  listClassName: c,
  renderItem: d
}) {
  const [f, l] = he(!1), m = e.find((p) => p.value === t);
  return /* @__PURE__ */ E(Ho, { open: f, onOpenChange: l, children: [
    /* @__PURE__ */ u(Uo, { asChild: !0, children: /* @__PURE__ */ E(
      at,
      {
        variant: "outline",
        role: "combobox",
        "aria-expanded": f,
        className: g("w-full justify-start", a),
        children: [
          i,
          m ? m.label : r,
          /* @__PURE__ */ u(ei, { className: "ml-auto h-4 w-4 shrink-0 opacity-50" })
        ]
      }
    ) }),
    /* @__PURE__ */ u(Vo, { className: "w-(--radix-popover-trigger-width) p-0", children: /* @__PURE__ */ E(Ec, { children: [
      /* @__PURE__ */ u(Bg, { placeholder: o }),
      /* @__PURE__ */ E(Zg, { className: g("max-h-60", c), children: [
        /* @__PURE__ */ u(Lg, { children: s }),
        /* @__PURE__ */ u(Yg, { children: e.map((p) => {
          const b = p.value === t;
          return /* @__PURE__ */ u(
            Hg,
            {
              value: p.label,
              onSelect: () => {
                n?.(p.value), l(!1);
              },
              children: d ? d(p, b) : /* @__PURE__ */ E(dn, { children: [
                /* @__PURE__ */ u(
                  Er,
                  {
                    className: g(
                      "mr-2 h-4 w-4",
                      b ? "opacity-100" : "opacity-0"
                    )
                  }
                ),
                p.label
              ] })
            },
            p.value
          );
        }) })
      ] })
    ] }) })
  ] });
}
function ss({ className: e, type: t, ...n }) {
  return /* @__PURE__ */ u(
    "input",
    {
      type: t,
      "data-slot": "input",
      className: g(
        "h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30",
        "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50",
        "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...n
    }
  );
}
function Ug({
  value: e,
  onValueChange: t,
  disabled: n = !1,
  placeholder: r = "Pick a date",
  className: o,
  ...s
}) {
  return /* @__PURE__ */ E(Ho, { children: [
    /* @__PURE__ */ u(Uo, { asChild: !0, children: /* @__PURE__ */ E(
      at,
      {
        variant: "outline",
        disabled: n,
        "data-empty": !e,
        className: g(
          "w-full justify-start text-left font-normal data-[empty=true]:text-muted-foreground",
          o
        ),
        children: [
          /* @__PURE__ */ u(Qs, { className: "size-4" }),
          e ? ht(e, "PPP") : /* @__PURE__ */ u("span", { children: r })
        ]
      }
    ) }),
    /* @__PURE__ */ u(Vo, { className: "w-auto p-0", align: "start", children: /* @__PURE__ */ u(
      Pi,
      {
        mode: "single",
        selected: e,
        onSelect: t,
        ...s
      }
    ) })
  ] });
}
function jk({
  value: e,
  onValueChange: t,
  disabled: n = !1,
  placeholder: r = "Pick a date and time",
  className: o,
  ...s
}) {
  const [a, i] = he(!1), c = e ? ht(e, "HH") : "", d = e ? ht(e, "mm") : "";
  function f(m) {
    if (!m) {
      t?.(void 0);
      return;
    }
    const p = new Date(m);
    e && p.setHours(e.getHours(), e.getMinutes()), t?.(p);
  }
  function l(m, p) {
    const b = parseInt(p, 10);
    if (isNaN(b)) return;
    const v = e ? new Date(e) : /* @__PURE__ */ new Date();
    if (e || v.setHours(0, 0, 0, 0), m === "hours" && b >= 0 && b <= 23)
      v.setHours(b);
    else if (m === "minutes" && b >= 0 && b <= 59)
      v.setMinutes(b);
    else
      return;
    t?.(v);
  }
  return /* @__PURE__ */ E(Ho, { open: a, onOpenChange: i, children: [
    /* @__PURE__ */ u(Uo, { asChild: !0, children: /* @__PURE__ */ E(
      at,
      {
        variant: "outline",
        disabled: n,
        "data-empty": !e,
        className: g(
          "w-full justify-start text-left font-normal data-[empty=true]:text-muted-foreground",
          o
        ),
        children: [
          /* @__PURE__ */ u(Qs, { className: "size-4" }),
          e ? ht(e, "PPP p") : /* @__PURE__ */ u("span", { children: r })
        ]
      }
    ) }),
    /* @__PURE__ */ E(Vo, { className: "w-auto p-0", align: "start", children: [
      /* @__PURE__ */ u(
        Pi,
        {
          mode: "single",
          selected: e,
          onSelect: f,
          ...s
        }
      ),
      /* @__PURE__ */ E(
        "div",
        {
          "data-slot": "date-time-picker-time",
          className: "flex items-center gap-2 border-t px-3 py-3",
          children: [
            /* @__PURE__ */ u("span", { className: "text-sm text-muted-foreground", children: "Time:" }),
            /* @__PURE__ */ u(
              ss,
              {
                type: "number",
                min: 0,
                max: 23,
                placeholder: "HH",
                value: c,
                onChange: (m) => l("hours", m.target.value),
                className: "h-8 w-16 text-center"
              }
            ),
            /* @__PURE__ */ u("span", { className: "text-sm text-muted-foreground", children: ":" }),
            /* @__PURE__ */ u(
              ss,
              {
                type: "number",
                min: 0,
                max: 59,
                placeholder: "MM",
                value: d,
                onChange: (m) => l("minutes", m.target.value),
                className: "h-8 w-16 text-center"
              }
            )
          ]
        }
      )
    ] })
  ] });
}
function Vg({
  ...e
}) {
  return /* @__PURE__ */ u(De.Root, { "data-slot": "dropdown-menu", ...e });
}
function Bk({
  ...e
}) {
  return /* @__PURE__ */ u(De.Portal, { "data-slot": "dropdown-menu-portal", ...e });
}
function Gg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    De.Trigger,
    {
      "data-slot": "dropdown-menu-trigger",
      className: g("cursor-pointer disabled:cursor-default", e),
      ...t
    }
  );
}
function qg({
  className: e,
  sideOffset: t = 4,
  ...n
}) {
  return /* @__PURE__ */ u(De.Portal, { children: /* @__PURE__ */ u(
    De.Content,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: t,
      className: g(
        "z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-32 origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...n
    }
  ) });
}
function Zk({
  ...e
}) {
  return /* @__PURE__ */ u(De.Group, { "data-slot": "dropdown-menu-group", ...e });
}
function cr({
  className: e,
  inset: t,
  variant: n = "default",
  ...r
}) {
  return /* @__PURE__ */ u(
    De.Item,
    {
      "data-slot": "dropdown-menu-item",
      "data-inset": t,
      "data-variant": n,
      className: g(
        "relative flex cursor-pointer data-disabled:cursor-default data-disabled:pointer-events-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-disabled:opacity-50 data-inset:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground data-[variant=destructive]:*:[svg]:text-destructive!",
        e
      ),
      ...r
    }
  );
}
function Lk({
  className: e,
  children: t,
  checked: n,
  ...r
}) {
  return /* @__PURE__ */ E(
    De.CheckboxItem,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      className: g(
        "relative flex cursor-pointer data-disabled:cursor-default data-disabled:pointer-events-none items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      checked: n,
      ...r,
      children: [
        /* @__PURE__ */ u("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ u(De.ItemIndicator, { children: /* @__PURE__ */ u(Er, { className: "size-4" }) }) }),
        t
      ]
    }
  );
}
function Yk({
  ...e
}) {
  return /* @__PURE__ */ u(
    De.RadioGroup,
    {
      "data-slot": "dropdown-menu-radio-group",
      ...e
    }
  );
}
function Hk({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ E(
    De.RadioItem,
    {
      "data-slot": "dropdown-menu-radio-item",
      className: g(
        "relative flex cursor-pointer data-disabled:cursor-default data-disabled:pointer-events-none items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ u("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ u(De.ItemIndicator, { children: /* @__PURE__ */ u(Mr, { className: "size-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function Jg({
  className: e,
  inset: t,
  ...n
}) {
  return /* @__PURE__ */ u(
    De.Label,
    {
      "data-slot": "dropdown-menu-label",
      "data-inset": t,
      className: g(
        "px-2 py-1.5 text-sm font-medium data-inset:pl-8",
        e
      ),
      ...n
    }
  );
}
function lr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    De.Separator,
    {
      "data-slot": "dropdown-menu-separator",
      className: g("-mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function Uk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "span",
    {
      "data-slot": "dropdown-menu-shortcut",
      className: g(
        "ml-auto text-xs tracking-widest text-muted-foreground",
        e
      ),
      ...t
    }
  );
}
function Vk({
  ...e
}) {
  return /* @__PURE__ */ u(De.Sub, { "data-slot": "dropdown-menu-sub", ...e });
}
function Gk({
  className: e,
  inset: t,
  children: n,
  ...r
}) {
  return /* @__PURE__ */ E(
    De.SubTrigger,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      "data-inset": t,
      className: g(
        "flex cursor-pointer data-disabled:cursor-default data-disabled:pointer-events-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-inset:pl-8 data-[state=open]:bg-accent data-[state=open]:text-accent-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ u(Wn, { className: "ml-auto size-4" })
      ]
    }
  );
}
function qk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    De.SubContent,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: g(
        "z-50 min-w-32 origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        e
      ),
      ...t
    }
  );
}
function Kg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    bl.Root,
    {
      "data-slot": "label",
      className: g(
        "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
        e
      ),
      ...t
    }
  );
}
const Xg = {
  default: "bg-primary",
  primary: "bg-primary",
  complete: "bg-complete",
  success: "bg-success",
  danger: "bg-destructive",
  warning: "bg-warning",
  info: "bg-info"
};
function Jk({
  className: e,
  value: t,
  color: n = "default",
  ...r
}) {
  return /* @__PURE__ */ u(
    ba.Root,
    {
      "data-slot": "progress",
      className: g(
        "relative h-2 w-full overflow-hidden rounded-full bg-primary/20",
        e
      ),
      ...r,
      children: /* @__PURE__ */ u(
        ba.Indicator,
        {
          "data-slot": "progress-indicator",
          className: g("h-full w-full flex-1 transition-all", Xg[n]),
          style: { transform: `translateX(-${100 - (t || 0)}%)` }
        }
      )
    }
  );
}
function Qg({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    lo.Root,
    {
      "data-slot": "radio-group",
      className: g("grid gap-3", e),
      ...t
    }
  );
}
function eb({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    lo.Item,
    {
      "data-slot": "radio-group-item",
      className: g(
        "aspect-square size-4 shrink-0 rounded-full border border-input text-primary shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:bg-input/30 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...t,
      children: /* @__PURE__ */ u(
        lo.Indicator,
        {
          "data-slot": "radio-group-indicator",
          className: "relative flex items-center justify-center",
          children: /* @__PURE__ */ u(Mr, { className: "absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 fill-primary" })
        }
      )
    }
  );
}
function zc({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ E(
    En.Root,
    {
      "data-slot": "scroll-area",
      className: g("relative", e),
      ...n,
      children: [
        /* @__PURE__ */ u(
          En.Viewport,
          {
            "data-slot": "scroll-area-viewport",
            className: "size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1",
            children: t
          }
        ),
        /* @__PURE__ */ u(tb, {}),
        /* @__PURE__ */ u(En.Corner, {})
      ]
    }
  );
}
function tb({
  className: e,
  orientation: t = "vertical",
  ...n
}) {
  return /* @__PURE__ */ u(
    En.ScrollAreaScrollbar,
    {
      "data-slot": "scroll-area-scrollbar",
      orientation: t,
      className: g(
        "flex touch-none p-px transition-colors select-none",
        t === "vertical" && "h-full w-2.5 border-l border-l-transparent",
        t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent",
        e
      ),
      ...n,
      children: /* @__PURE__ */ u(
        En.ScrollAreaThumb,
        {
          "data-slot": "scroll-area-thumb",
          className: "relative flex-1 rounded-full bg-border"
        }
      )
    }
  );
}
function nb({
  ...e
}) {
  return /* @__PURE__ */ u(Ae.Root, { "data-slot": "select", ...e });
}
function Kk({
  ...e
}) {
  return /* @__PURE__ */ u(Ae.Group, { "data-slot": "select-group", ...e });
}
function rb({
  ...e
}) {
  return /* @__PURE__ */ u(Ae.Value, { "data-slot": "select-value", ...e });
}
function ob({
  className: e,
  size: t = "default",
  children: n,
  ...r
}) {
  return /* @__PURE__ */ E(
    Ae.Trigger,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: g(
        "flex w-fit items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 data-placeholder:text-muted-foreground data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 dark:bg-input/30 dark:hover:bg-input/50 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground",
        e
      ),
      ...r,
      children: [
        n,
        /* @__PURE__ */ u(Ae.Icon, { asChild: !0, children: /* @__PURE__ */ u(zr, { className: "size-4 opacity-50" }) })
      ]
    }
  );
}
function ab({
  className: e,
  children: t,
  position: n = "item-aligned",
  align: r = "center",
  ...o
}) {
  return /* @__PURE__ */ u(Ae.Portal, { children: /* @__PURE__ */ E(
    Ae.Content,
    {
      "data-slot": "select-content",
      className: g(
        "relative z-50 max-h-(--radix-select-content-available-height) min-w-32 origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border bg-popover text-popover-foreground shadow-md data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95",
        n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: n,
      align: r,
      ...o,
      children: [
        /* @__PURE__ */ u(ib, {}),
        /* @__PURE__ */ u(
          Ae.Viewport,
          {
            className: g(
              "p-1",
              n === "popper" && "h-(--radix-select-trigger-height) w-full min-w-(--radix-select-trigger-width) scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ u(cb, {})
      ]
    }
  ) });
}
function Xk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ae.Label,
    {
      "data-slot": "select-label",
      className: g("px-2 py-1.5 text-xs text-muted-foreground", e),
      ...t
    }
  );
}
function sb({
  className: e,
  children: t,
  ...n
}) {
  return /* @__PURE__ */ E(
    Ae.Item,
    {
      "data-slot": "select-item",
      className: g(
        "relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2",
        e
      ),
      ...n,
      children: [
        /* @__PURE__ */ u(
          "span",
          {
            "data-slot": "select-item-indicator",
            className: "absolute right-2 flex size-3.5 items-center justify-center",
            children: /* @__PURE__ */ u(Ae.ItemIndicator, { children: /* @__PURE__ */ u(Er, { className: "size-4" }) })
          }
        ),
        /* @__PURE__ */ u(Ae.ItemText, { children: t })
      ]
    }
  );
}
function Qk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ae.Separator,
    {
      "data-slot": "select-separator",
      className: g("pointer-events-none -mx-1 my-1 h-px bg-border", e),
      ...t
    }
  );
}
function ib({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ae.ScrollUpButton,
    {
      "data-slot": "select-scroll-up-button",
      className: g(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ u(Rd, { className: "size-4" })
    }
  );
}
function cb({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Ae.ScrollDownButton,
    {
      "data-slot": "select-scroll-down-button",
      className: g(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ u(zr, { className: "size-4" })
    }
  );
}
function e1({
  className: e,
  orientation: t = "horizontal",
  decorative: n = !0,
  ...r
}) {
  return /* @__PURE__ */ u(
    vl.Root,
    {
      "data-slot": "separator",
      decorative: n,
      orientation: t,
      className: g(
        "shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
        e
      ),
      ...r
    }
  );
}
function Mc({ ...e }) {
  return /* @__PURE__ */ u(ke.Root, { "data-slot": "sheet", ...e });
}
function t1({
  ...e
}) {
  return /* @__PURE__ */ u(ke.Trigger, { "data-slot": "sheet-trigger", ...e });
}
function n1({
  ...e
}) {
  return /* @__PURE__ */ u(ke.Close, { "data-slot": "sheet-close", ...e });
}
function lb({
  ...e
}) {
  return /* @__PURE__ */ u(ke.Portal, { "data-slot": "sheet-portal", ...e });
}
function db({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ke.Overlay,
    {
      "data-slot": "sheet-overlay",
      className: g(
        "fixed inset-0 z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function Pc({
  className: e,
  children: t,
  side: n = "right",
  showCloseButton: r = !0,
  overlayClassName: o,
  ...s
}) {
  return /* @__PURE__ */ E(lb, { children: [
    /* @__PURE__ */ u(db, { className: o }),
    /* @__PURE__ */ E(
      ke.Content,
      {
        "data-slot": "sheet-content",
        className: g(
          "fixed z-50 flex flex-col gap-4 bg-background shadow-lg transition ease-in-out data-[state=closed]:animate-out data-[state=closed]:duration-300 data-[state=open]:animate-in data-[state=open]:duration-500",
          n === "right" && "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm",
          n === "left" && "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
          n === "top" && "inset-x-0 top-0 h-auto border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
          n === "bottom" && "inset-x-0 bottom-0 h-auto border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
          e
        ),
        ...s,
        children: [
          t,
          r && /* @__PURE__ */ E(ke.Close, { className: "absolute top-4 right-4 rounded-xs opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none data-[state=open]:bg-secondary", children: [
            /* @__PURE__ */ u(ti, { className: "size-4" }),
            /* @__PURE__ */ u("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function Tc({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sheet-header",
      className: g("flex flex-col gap-1.5 p-4", e),
      ...t
    }
  );
}
function r1({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sheet-footer",
      className: g("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function Ic({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ke.Title,
    {
      "data-slot": "sheet-title",
      className: g("font-semibold text-foreground", e),
      ...t
    }
  );
}
function Ac({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    ke.Description,
    {
      "data-slot": "sheet-description",
      className: g("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function o1({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "skeleton",
      className: g("animate-pulse rounded-md bg-accent", e),
      ...t
    }
  );
}
function a1({
  className: e,
  defaultValue: t,
  value: n,
  min: r = 0,
  max: o = 100,
  ...s
}) {
  const a = bt(
    () => Array.isArray(n) ? n : Array.isArray(t) ? t : [r, o],
    [n, t, r, o]
  );
  return /* @__PURE__ */ E(
    Qn.Root,
    {
      "data-slot": "slider",
      defaultValue: t,
      value: n,
      min: r,
      max: o,
      className: g(
        "relative flex w-full touch-none items-center select-none data-disabled:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        e
      ),
      ...s,
      children: [
        /* @__PURE__ */ u(
          Qn.Track,
          {
            "data-slot": "slider-track",
            className: g(
              "relative grow overflow-hidden rounded-full bg-muted data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
            ),
            children: /* @__PURE__ */ u(
              Qn.Range,
              {
                "data-slot": "slider-range",
                className: g(
                  "absolute bg-primary data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
                )
              }
            )
          }
        ),
        Array.from({ length: a.length }, (i, c) => /* @__PURE__ */ u(
          Qn.Thumb,
          {
            "data-slot": "slider-thumb",
            className: "block size-4 shrink-0 rounded-full border border-primary bg-white shadow-sm ring-ring/50 transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
          },
          c
        ))
      ]
    }
  );
}
function ub(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const fb = (e) => {
  switch (e) {
    case "success":
      return pb;
    case "info":
      return bb;
    case "warning":
      return gb;
    case "error":
      return vb;
    default:
      return null;
  }
}, mb = Array(12).fill(0), hb = ({ visible: e, className: t }) => /* @__PURE__ */ w.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    t
  ].filter(Boolean).join(" "),
  "data-visible": e
}, /* @__PURE__ */ w.createElement("div", {
  className: "sonner-spinner"
}, mb.map((n, r) => /* @__PURE__ */ w.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${r}`
})))), pb = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), gb = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), bb = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), vb = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), yb = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ w.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ w.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), wb = () => {
  const [e, t] = w.useState(document.hidden);
  return w.useEffect(() => {
    const n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
};
let No = 1;
class xb {
  constructor() {
    this.subscribe = (t) => (this.subscribers.push(t), () => {
      const n = this.subscribers.indexOf(t);
      this.subscribers.splice(n, 1);
    }), this.publish = (t) => {
      this.subscribers.forEach((n) => n(t));
    }, this.addToast = (t) => {
      this.publish(t), this.toasts = [
        ...this.toasts,
        t
      ];
    }, this.create = (t) => {
      var n;
      const { message: r, ...o } = t, s = typeof t?.id == "number" || ((n = t.id) == null ? void 0 : n.length) > 0 ? t.id : No++, a = this.toasts.find((c) => c.id === s), i = t.dismissible === void 0 ? !0 : t.dismissible;
      return this.dismissedToasts.has(s) && this.dismissedToasts.delete(s), a ? this.toasts = this.toasts.map((c) => c.id === s ? (this.publish({
        ...c,
        ...t,
        id: s,
        title: r
      }), {
        ...c,
        ...t,
        id: s,
        dismissible: i,
        title: r
      }) : c) : this.addToast({
        title: r,
        ...o,
        dismissible: i,
        id: s
      }), s;
    }, this.dismiss = (t) => (t ? (this.dismissedToasts.add(t), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: t,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((r) => r({
        id: n.id,
        dismiss: !0
      }));
    }), t), this.message = (t, n) => this.create({
      ...n,
      message: t
    }), this.error = (t, n) => this.create({
      ...n,
      message: t,
      type: "error"
    }), this.success = (t, n) => this.create({
      ...n,
      type: "success",
      message: t
    }), this.info = (t, n) => this.create({
      ...n,
      type: "info",
      message: t
    }), this.warning = (t, n) => this.create({
      ...n,
      type: "warning",
      message: t
    }), this.loading = (t, n) => this.create({
      ...n,
      type: "loading",
      message: t
    }), this.promise = (t, n) => {
      if (!n)
        return;
      let r;
      n.loading !== void 0 && (r = this.create({
        ...n,
        promise: t,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const o = Promise.resolve(t instanceof Function ? t() : t);
      let s = r !== void 0, a;
      const i = o.then(async (d) => {
        if (a = [
          "resolve",
          d
        ], w.isValidElement(d))
          s = !1, this.create({
            id: r,
            type: "default",
            message: d
          });
        else if (_b(d) && !d.ok) {
          s = !1;
          const l = typeof n.error == "function" ? await n.error(`HTTP error! status: ${d.status}`) : n.error, m = typeof n.description == "function" ? await n.description(`HTTP error! status: ${d.status}`) : n.description, b = typeof l == "object" && !w.isValidElement(l) ? l : {
            message: l
          };
          this.create({
            id: r,
            type: "error",
            description: m,
            ...b
          });
        } else if (d instanceof Error) {
          s = !1;
          const l = typeof n.error == "function" ? await n.error(d) : n.error, m = typeof n.description == "function" ? await n.description(d) : n.description, b = typeof l == "object" && !w.isValidElement(l) ? l : {
            message: l
          };
          this.create({
            id: r,
            type: "error",
            description: m,
            ...b
          });
        } else if (n.success !== void 0) {
          s = !1;
          const l = typeof n.success == "function" ? await n.success(d) : n.success, m = typeof n.description == "function" ? await n.description(d) : n.description, b = typeof l == "object" && !w.isValidElement(l) ? l : {
            message: l
          };
          this.create({
            id: r,
            type: "success",
            description: m,
            ...b
          });
        }
      }).catch(async (d) => {
        if (a = [
          "reject",
          d
        ], n.error !== void 0) {
          s = !1;
          const f = typeof n.error == "function" ? await n.error(d) : n.error, l = typeof n.description == "function" ? await n.description(d) : n.description, p = typeof f == "object" && !w.isValidElement(f) ? f : {
            message: f
          };
          this.create({
            id: r,
            type: "error",
            description: l,
            ...p
          });
        }
      }).finally(() => {
        s && (this.dismiss(r), r = void 0), n.finally == null || n.finally.call(n);
      }), c = () => new Promise((d, f) => i.then(() => a[0] === "reject" ? f(a[1]) : d(a[1])).catch(f));
      return typeof r != "string" && typeof r != "number" ? {
        unwrap: c
      } : Object.assign(r, {
        unwrap: c
      });
    }, this.custom = (t, n) => {
      const r = n?.id || No++;
      return this.create({
        jsx: t(r),
        id: r,
        ...n
      }), r;
    }, this.getActiveToasts = () => this.toasts.filter((t) => !this.dismissedToasts.has(t.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const Re = new xb(), kb = (e, t) => {
  const n = t?.id || No++;
  return Re.addToast({
    title: e,
    ...t,
    id: n
  }), n;
}, _b = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", Sb = kb, Nb = () => Re.toasts, Cb = () => Re.getActiveToasts();
Object.assign(Sb, {
  success: Re.success,
  info: Re.info,
  warning: Re.warning,
  error: Re.error,
  custom: Re.custom,
  message: Re.message,
  promise: Re.promise,
  dismiss: Re.dismiss,
  loading: Re.loading
}, {
  getHistory: Nb,
  getToasts: Cb
});
ub("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function dr(e) {
  return e.label !== void 0;
}
const Ob = 3, Db = "24px", Eb = "16px", is = 4e3, zb = 356, Mb = 14, Pb = 45, Tb = 200;
function tt(...e) {
  return e.filter(Boolean).join(" ");
}
function Ib(e) {
  const [t, n] = e.split("-"), r = [];
  return t && r.push(t), n && r.push(n), r;
}
const Ab = (e) => {
  var t, n, r, o, s, a, i, c, d;
  const { invert: f, toast: l, unstyled: m, interacting: p, setHeights: b, visibleToasts: v, heights: y, index: x, toasts: _, expanded: S, removeToast: D, defaultRichColors: N, closeButton: k, style: P, cancelButtonStyle: O, actionButtonStyle: B, className: Z = "", descriptionClassName: J = "", duration: Y, position: Q, gap: re, expandByDefault: ce, classNames: U, icons: ne, closeButtonAriaLabel: we = "Close toast" } = e, [le, I] = w.useState(null), [ue, z] = w.useState(null), [T, W] = w.useState(!1), [M, F] = w.useState(!1), [X, q] = w.useState(!1), [G, Ce] = w.useState(!1), [Ue, We] = w.useState(!1), [Mt, Qe] = w.useState(0), [Yn, Hn] = w.useState(0), Pt = w.useRef(l.duration || Y || is), Un = w.useRef(null), Ve = w.useRef(null), Br = x === 0, Zr = x + 1 <= v, Me = l.type, dt = l.dismissible !== !1, yn = l.className || "", wn = l.descriptionClassName || "", Gt = w.useMemo(() => y.findIndex((A) => A.toastId === l.id) || 0, [
    y,
    l.id
  ]), Lr = w.useMemo(() => {
    var A;
    return (A = l.closeButton) != null ? A : k;
  }, [
    l.closeButton,
    k
  ]), Vn = w.useMemo(() => l.duration || Y || is, [
    l.duration,
    Y
  ]), xn = w.useRef(0), wt = w.useRef(0), Gn = w.useRef(0), xt = w.useRef(null), [Yr, Hr] = Q.split("-"), qn = w.useMemo(() => y.reduce((A, ge, _e) => _e >= Gt ? A : A + ge.height, 0), [
    y,
    Gt
  ]), Jn = wb(), Kn = l.invert || f, kn = Me === "loading";
  wt.current = w.useMemo(() => Gt * re + qn, [
    Gt,
    qn
  ]), w.useEffect(() => {
    Pt.current = Vn;
  }, [
    Vn
  ]), w.useEffect(() => {
    W(!0);
  }, []), w.useEffect(() => {
    const A = Ve.current;
    if (A) {
      const ge = A.getBoundingClientRect().height;
      return Hn(ge), b((_e) => [
        {
          toastId: l.id,
          height: ge,
          position: l.position
        },
        ..._e
      ]), () => b((_e) => _e.filter((Pe) => Pe.toastId !== l.id));
    }
  }, [
    b,
    l.id
  ]), w.useLayoutEffect(() => {
    if (!T) return;
    const A = Ve.current, ge = A.style.height;
    A.style.height = "auto";
    const _e = A.getBoundingClientRect().height;
    A.style.height = ge, Hn(_e), b((Pe) => Pe.find((pe) => pe.toastId === l.id) ? Pe.map((pe) => pe.toastId === l.id ? {
      ...pe,
      height: _e
    } : pe) : [
      {
        toastId: l.id,
        height: _e,
        position: l.position
      },
      ...Pe
    ]);
  }, [
    T,
    l.title,
    l.description,
    b,
    l.id,
    l.jsx,
    l.action,
    l.cancel
  ]);
  const L = w.useCallback(() => {
    F(!0), Qe(wt.current), b((A) => A.filter((ge) => ge.toastId !== l.id)), setTimeout(() => {
      D(l);
    }, Tb);
  }, [
    l,
    D,
    b,
    wt
  ]);
  w.useEffect(() => {
    if (l.promise && Me === "loading" || l.duration === 1 / 0 || l.type === "loading") return;
    let A;
    return S || p || Jn ? (() => {
      if (Gn.current < xn.current) {
        const Pe = (/* @__PURE__ */ new Date()).getTime() - xn.current;
        Pt.current = Pt.current - Pe;
      }
      Gn.current = (/* @__PURE__ */ new Date()).getTime();
    })() : Pt.current !== 1 / 0 && (xn.current = (/* @__PURE__ */ new Date()).getTime(), A = setTimeout(() => {
      l.onAutoClose == null || l.onAutoClose.call(l, l), L();
    }, Pt.current)), () => clearTimeout(A);
  }, [
    S,
    p,
    l,
    Me,
    Jn,
    L
  ]), w.useEffect(() => {
    l.delete && (L(), l.onDismiss == null || l.onDismiss.call(l, l));
  }, [
    L,
    l.delete
  ]);
  function oe() {
    var A;
    if (ne?.loading) {
      var ge;
      return /* @__PURE__ */ w.createElement("div", {
        className: tt(U?.loader, l == null || (ge = l.classNames) == null ? void 0 : ge.loader, "sonner-loader"),
        "data-visible": Me === "loading"
      }, ne.loading);
    }
    return /* @__PURE__ */ w.createElement(hb, {
      className: tt(U?.loader, l == null || (A = l.classNames) == null ? void 0 : A.loader),
      visible: Me === "loading"
    });
  }
  const H = l.icon || ne?.[Me] || fb(Me);
  var ee, Ee;
  return /* @__PURE__ */ w.createElement("li", {
    tabIndex: 0,
    ref: Ve,
    className: tt(Z, yn, U?.toast, l == null || (t = l.classNames) == null ? void 0 : t.toast, U?.default, U?.[Me], l == null || (n = l.classNames) == null ? void 0 : n[Me]),
    "data-sonner-toast": "",
    "data-rich-colors": (ee = l.richColors) != null ? ee : N,
    "data-styled": !(l.jsx || l.unstyled || m),
    "data-mounted": T,
    "data-promise": !!l.promise,
    "data-swiped": Ue,
    "data-removed": M,
    "data-visible": Zr,
    "data-y-position": Yr,
    "data-x-position": Hr,
    "data-index": x,
    "data-front": Br,
    "data-swiping": X,
    "data-dismissible": dt,
    "data-type": Me,
    "data-invert": Kn,
    "data-swipe-out": G,
    "data-swipe-direction": ue,
    "data-expanded": !!(S || ce && T),
    "data-testid": l.testId,
    style: {
      "--index": x,
      "--toasts-before": x,
      "--z-index": _.length - x,
      "--offset": `${M ? Mt : wt.current}px`,
      "--initial-height": ce ? "auto" : `${Yn}px`,
      ...P,
      ...l.style
    },
    onDragEnd: () => {
      q(!1), I(null), xt.current = null;
    },
    onPointerDown: (A) => {
      A.button !== 2 && (kn || !dt || (Un.current = /* @__PURE__ */ new Date(), Qe(wt.current), A.target.setPointerCapture(A.pointerId), A.target.tagName !== "BUTTON" && (q(!0), xt.current = {
        x: A.clientX,
        y: A.clientY
      })));
    },
    onPointerUp: () => {
      var A, ge, _e;
      if (G || !dt) return;
      xt.current = null;
      const Pe = Number(((A = Ve.current) == null ? void 0 : A.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), kt = Number(((ge = Ve.current) == null ? void 0 : ge.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), pe = (/* @__PURE__ */ new Date()).getTime() - ((_e = Un.current) == null ? void 0 : _e.getTime()), Be = le === "x" ? Pe : kt, Xn = Math.abs(Be) / pe;
      if (Math.abs(Be) >= Pb || Xn > 0.11) {
        Qe(wt.current), l.onDismiss == null || l.onDismiss.call(l, l), z(le === "x" ? Pe > 0 ? "right" : "left" : kt > 0 ? "down" : "up"), L(), Ce(!0);
        return;
      } else {
        var Ge, qe;
        (Ge = Ve.current) == null || Ge.style.setProperty("--swipe-amount-x", "0px"), (qe = Ve.current) == null || qe.style.setProperty("--swipe-amount-y", "0px");
      }
      We(!1), q(!1), I(null);
    },
    onPointerMove: (A) => {
      var ge, _e, Pe;
      if (!xt.current || !dt || ((ge = window.getSelection()) == null ? void 0 : ge.toString().length) > 0) return;
      const pe = A.clientY - xt.current.y, Be = A.clientX - xt.current.x;
      var Xn;
      const Ge = (Xn = e.swipeDirections) != null ? Xn : Ib(Q);
      !le && (Math.abs(Be) > 1 || Math.abs(pe) > 1) && I(Math.abs(Be) > Math.abs(pe) ? "x" : "y");
      let qe = {
        x: 0,
        y: 0
      };
      const pa = (Tt) => 1 / (1.5 + Math.abs(Tt) / 20);
      if (le === "y") {
        if (Ge.includes("top") || Ge.includes("bottom"))
          if (Ge.includes("top") && pe < 0 || Ge.includes("bottom") && pe > 0)
            qe.y = pe;
          else {
            const Tt = pe * pa(pe);
            qe.y = Math.abs(Tt) < Math.abs(pe) ? Tt : pe;
          }
      } else if (le === "x" && (Ge.includes("left") || Ge.includes("right")))
        if (Ge.includes("left") && Be < 0 || Ge.includes("right") && Be > 0)
          qe.x = Be;
        else {
          const Tt = Be * pa(Be);
          qe.x = Math.abs(Tt) < Math.abs(Be) ? Tt : Be;
        }
      (Math.abs(qe.x) > 0 || Math.abs(qe.y) > 0) && We(!0), (_e = Ve.current) == null || _e.style.setProperty("--swipe-amount-x", `${qe.x}px`), (Pe = Ve.current) == null || Pe.style.setProperty("--swipe-amount-y", `${qe.y}px`);
    }
  }, Lr && !l.jsx && Me !== "loading" ? /* @__PURE__ */ w.createElement("button", {
    "aria-label": we,
    "data-disabled": kn,
    "data-close-button": !0,
    onClick: kn || !dt ? () => {
    } : () => {
      L(), l.onDismiss == null || l.onDismiss.call(l, l);
    },
    className: tt(U?.closeButton, l == null || (r = l.classNames) == null ? void 0 : r.closeButton)
  }, (Ee = ne?.close) != null ? Ee : yb) : null, (Me || l.icon || l.promise) && l.icon !== null && (ne?.[Me] !== null || l.icon) ? /* @__PURE__ */ w.createElement("div", {
    "data-icon": "",
    className: tt(U?.icon, l == null || (o = l.classNames) == null ? void 0 : o.icon)
  }, l.promise || l.type === "loading" && !l.icon ? l.icon || oe() : null, l.type !== "loading" ? H : null) : null, /* @__PURE__ */ w.createElement("div", {
    "data-content": "",
    className: tt(U?.content, l == null || (s = l.classNames) == null ? void 0 : s.content)
  }, /* @__PURE__ */ w.createElement("div", {
    "data-title": "",
    className: tt(U?.title, l == null || (a = l.classNames) == null ? void 0 : a.title)
  }, l.jsx ? l.jsx : typeof l.title == "function" ? l.title() : l.title), l.description ? /* @__PURE__ */ w.createElement("div", {
    "data-description": "",
    className: tt(J, wn, U?.description, l == null || (i = l.classNames) == null ? void 0 : i.description)
  }, typeof l.description == "function" ? l.description() : l.description) : null), /* @__PURE__ */ w.isValidElement(l.cancel) ? l.cancel : l.cancel && dr(l.cancel) ? /* @__PURE__ */ w.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: l.cancelButtonStyle || O,
    onClick: (A) => {
      dr(l.cancel) && dt && (l.cancel.onClick == null || l.cancel.onClick.call(l.cancel, A), L());
    },
    className: tt(U?.cancelButton, l == null || (c = l.classNames) == null ? void 0 : c.cancelButton)
  }, l.cancel.label) : null, /* @__PURE__ */ w.isValidElement(l.action) ? l.action : l.action && dr(l.action) ? /* @__PURE__ */ w.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: l.actionButtonStyle || B,
    onClick: (A) => {
      dr(l.action) && (l.action.onClick == null || l.action.onClick.call(l.action, A), !A.defaultPrevented && L());
    },
    className: tt(U?.actionButton, l == null || (d = l.classNames) == null ? void 0 : d.actionButton)
  }, l.action.label) : null);
};
function cs() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function $b(e, t) {
  const n = {};
  return [
    e,
    t
  ].forEach((r, o) => {
    const s = o === 1, a = s ? "--mobile-offset" : "--offset", i = s ? Eb : Db;
    function c(d) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((f) => {
        n[`${a}-${f}`] = typeof d == "number" ? `${d}px` : d;
      });
    }
    typeof r == "number" || typeof r == "string" ? c(r) : typeof r == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((d) => {
      r[d] === void 0 ? n[`${a}-${d}`] = i : n[`${a}-${d}`] = typeof r[d] == "number" ? `${r[d]}px` : r[d];
    }) : c(i);
  }), n;
}
const Rb = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const { id: r, invert: o, position: s = "bottom-right", hotkey: a = [
    "altKey",
    "KeyT"
  ], expand: i, closeButton: c, className: d, offset: f, mobileOffset: l, theme: m = "light", richColors: p, duration: b, style: v, visibleToasts: y = Ob, toastOptions: x, dir: _ = cs(), gap: S = Mb, icons: D, containerAriaLabel: N = "Notifications" } = t, [k, P] = w.useState([]), O = w.useMemo(() => r ? k.filter((T) => T.toasterId === r) : k.filter((T) => !T.toasterId), [
    k,
    r
  ]), B = w.useMemo(() => Array.from(new Set([
    s
  ].concat(O.filter((T) => T.position).map((T) => T.position)))), [
    O,
    s
  ]), [Z, J] = w.useState([]), [Y, Q] = w.useState(!1), [re, ce] = w.useState(!1), [U, ne] = w.useState(m !== "system" ? m : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), we = w.useRef(null), le = a.join("+").replace(/Key/g, "").replace(/Digit/g, ""), I = w.useRef(null), ue = w.useRef(!1), z = w.useCallback((T) => {
    P((W) => {
      var M;
      return (M = W.find((F) => F.id === T.id)) != null && M.delete || Re.dismiss(T.id), W.filter(({ id: F }) => F !== T.id);
    });
  }, []);
  return w.useEffect(() => Re.subscribe((T) => {
    if (T.dismiss) {
      requestAnimationFrame(() => {
        P((W) => W.map((M) => M.id === T.id ? {
          ...M,
          delete: !0
        } : M));
      });
      return;
    }
    setTimeout(() => {
      yl.flushSync(() => {
        P((W) => {
          const M = W.findIndex((F) => F.id === T.id);
          return M !== -1 ? [
            ...W.slice(0, M),
            {
              ...W[M],
              ...T
            },
            ...W.slice(M + 1)
          ] : [
            T,
            ...W
          ];
        });
      });
    });
  }), [
    k
  ]), w.useEffect(() => {
    if (m !== "system") {
      ne(m);
      return;
    }
    if (m === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? ne("dark") : ne("light")), typeof window > "u") return;
    const T = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      T.addEventListener("change", ({ matches: W }) => {
        ne(W ? "dark" : "light");
      });
    } catch {
      T.addListener(({ matches: M }) => {
        try {
          ne(M ? "dark" : "light");
        } catch (F) {
          console.error(F);
        }
      });
    }
  }, [
    m
  ]), w.useEffect(() => {
    k.length <= 1 && Q(!1);
  }, [
    k
  ]), w.useEffect(() => {
    const T = (W) => {
      var M;
      if (a.every((q) => W[q] || W.code === q)) {
        var X;
        Q(!0), (X = we.current) == null || X.focus();
      }
      W.code === "Escape" && (document.activeElement === we.current || (M = we.current) != null && M.contains(document.activeElement)) && Q(!1);
    };
    return document.addEventListener("keydown", T), () => document.removeEventListener("keydown", T);
  }, [
    a
  ]), w.useEffect(() => {
    if (we.current)
      return () => {
        I.current && (I.current.focus({
          preventScroll: !0
        }), I.current = null, ue.current = !1);
      };
  }, [
    we.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ w.createElement("section", {
    ref: n,
    "aria-label": `${N} ${le}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, B.map((T, W) => {
    var M;
    const [F, X] = T.split("-");
    return O.length ? /* @__PURE__ */ w.createElement("ol", {
      key: T,
      dir: _ === "auto" ? cs() : _,
      tabIndex: -1,
      ref: we,
      className: d,
      "data-sonner-toaster": !0,
      "data-sonner-theme": U,
      "data-y-position": F,
      "data-x-position": X,
      style: {
        "--front-toast-height": `${((M = Z[0]) == null ? void 0 : M.height) || 0}px`,
        "--width": `${zb}px`,
        "--gap": `${S}px`,
        ...v,
        ...$b(f, l)
      },
      onBlur: (q) => {
        ue.current && !q.currentTarget.contains(q.relatedTarget) && (ue.current = !1, I.current && (I.current.focus({
          preventScroll: !0
        }), I.current = null));
      },
      onFocus: (q) => {
        q.target instanceof HTMLElement && q.target.dataset.dismissible === "false" || ue.current || (ue.current = !0, I.current = q.relatedTarget);
      },
      onMouseEnter: () => Q(!0),
      onMouseMove: () => Q(!0),
      onMouseLeave: () => {
        re || Q(!1);
      },
      onDragEnd: () => Q(!1),
      onPointerDown: (q) => {
        q.target instanceof HTMLElement && q.target.dataset.dismissible === "false" || ce(!0);
      },
      onPointerUp: () => ce(!1)
    }, O.filter((q) => !q.position && W === 0 || q.position === T).map((q, G) => {
      var Ce, Ue;
      return /* @__PURE__ */ w.createElement(Ab, {
        key: q.id,
        icons: D,
        index: G,
        toast: q,
        defaultRichColors: p,
        duration: (Ce = x?.duration) != null ? Ce : b,
        className: x?.className,
        descriptionClassName: x?.descriptionClassName,
        invert: o,
        visibleToasts: y,
        closeButton: (Ue = x?.closeButton) != null ? Ue : c,
        interacting: re,
        position: T,
        style: x?.style,
        unstyled: x?.unstyled,
        classNames: x?.classNames,
        cancelButtonStyle: x?.cancelButtonStyle,
        actionButtonStyle: x?.actionButtonStyle,
        closeButtonAriaLabel: x?.closeButtonAriaLabel,
        removeToast: z,
        toasts: O.filter((We) => We.position == q.position),
        heights: Z.filter((We) => We.position == q.position),
        setHeights: J,
        expandByDefault: i,
        gap: S,
        expanded: Y,
        swipeDirections: t.swipeDirections
      });
    })) : null;
  }));
});
function Wb() {
  return localStorage.getItem("theme") === "dark" ? "dark" : "light";
}
function Fb(e) {
  const t = (n) => {
    n.key === "theme" && e();
  };
  return window.addEventListener("storage", t), () => window.removeEventListener("storage", t);
}
const s1 = ({ ...e }) => {
  const t = pl(Fb, Wb);
  return /* @__PURE__ */ u(
    Rb,
    {
      theme: t,
      className: "toaster group",
      icons: {
        success: /* @__PURE__ */ u(jd, { className: "size-4" }),
        info: /* @__PURE__ */ u(tu, { className: "size-4" }),
        warning: /* @__PURE__ */ u(_u, { className: "size-4" }),
        error: /* @__PURE__ */ u(uu, { className: "size-4" }),
        loading: /* @__PURE__ */ u(au, { className: "size-4 animate-spin" })
      },
      style: {
        "--normal-bg": "var(--popover)",
        "--normal-text": "var(--popover-foreground)",
        "--normal-border": "var(--border)",
        "--border-radius": "var(--radius)"
      },
      ...e
    }
  );
};
function jb({
  className: e,
  size: t = "default",
  ...n
}) {
  return /* @__PURE__ */ u(
    va.Root,
    {
      "data-slot": "switch",
      "data-size": t,
      className: g(
        "peer group/switch inline-flex shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-[1.15rem] data-[size=default]:w-8 data-[size=sm]:h-3.5 data-[size=sm]:w-6 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80",
        e
      ),
      ...n,
      children: /* @__PURE__ */ u(
        va.Thumb,
        {
          "data-slot": "switch-thumb",
          className: g(
            "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0 dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground"
          )
        }
      )
    }
  );
}
function i1({
  className: e,
  orientation: t = "horizontal",
  ...n
}) {
  return /* @__PURE__ */ u(
    Dr.Root,
    {
      "data-slot": "tabs",
      "data-orientation": t,
      orientation: t,
      className: g(
        "group/tabs flex gap-2 data-[orientation=horizontal]:flex-col",
        e
      ),
      ...n
    }
  );
}
const Bb = Yt(
  "group/tabs-list inline-flex w-fit items-center justify-center rounded-lg p-[3px] text-muted-foreground group-data-[orientation=horizontal]/tabs:h-9 group-data-[orientation=vertical]/tabs:h-fit group-data-[orientation=vertical]/tabs:flex-col data-[variant=line]:rounded-none",
  {
    variants: {
      variant: {
        default: "bg-muted",
        line: "gap-1 bg-transparent"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function c1({
  className: e,
  variant: t = "default",
  ...n
}) {
  return /* @__PURE__ */ u(
    Dr.List,
    {
      "data-slot": "tabs-list",
      "data-variant": t,
      className: g(Bb({ variant: t }), e),
      ...n
    }
  );
}
function l1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Dr.Trigger,
    {
      "data-slot": "tabs-trigger",
      className: g(
        "relative inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 rounded-md border border-transparent px-2 py-1 text-sm font-medium whitespace-nowrap text-foreground/60 transition-all group-data-[orientation=vertical]/tabs:w-full group-data-[orientation=vertical]/tabs:justify-start hover:text-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 focus-visible:outline-1 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50 group-data-[variant=default]/tabs-list:data-[state=active]:shadow-sm group-data-[variant=line]/tabs-list:data-[state=active]:shadow-none dark:text-muted-foreground dark:hover:text-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        "group-data-[variant=line]/tabs-list:bg-transparent group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent dark:group-data-[variant=line]/tabs-list:data-[state=active]:border-transparent dark:group-data-[variant=line]/tabs-list:data-[state=active]:bg-transparent",
        "data-[state=active]:bg-background data-[state=active]:text-foreground dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 dark:data-[state=active]:text-foreground",
        "after:absolute after:bg-foreground after:opacity-0 after:transition-opacity group-data-[orientation=horizontal]/tabs:after:inset-x-0 group-data-[orientation=horizontal]/tabs:after:-bottom-1.25 group-data-[orientation=horizontal]/tabs:after:h-0.5 group-data-[orientation=vertical]/tabs:after:inset-y-0 group-data-[orientation=vertical]/tabs:after:-right-1 group-data-[orientation=vertical]/tabs:after:w-0.5 group-data-[variant=line]/tabs-list:data-[state=active]:after:opacity-100",
        e
      ),
      ...t
    }
  );
}
function d1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    Dr.Content,
    {
      "data-slot": "tabs-content",
      className: g("flex-1 outline-none", e),
      ...t
    }
  );
}
function u1({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "textarea",
    {
      "data-slot": "textarea",
      className: g(
        "flex field-sizing-content min-h-16 w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm dark:bg-input/30 dark:aria-invalid:ring-destructive/40",
        e
      ),
      ...t
    }
  );
}
function Zb({
  label: e,
  error: t,
  required: n,
  checked: r,
  defaultChecked: o,
  onCheckedChange: s,
  disabled: a,
  className: i
}) {
  const c = Cr();
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "form-group-default",
      className: g(
        "rounded-sm border bg-background transition-colors",
        "border-input",
        t && "border-destructive",
        i
      ),
      children: [
        /* @__PURE__ */ E("div", { "data-slot": "form-group-control", className: "flex items-center gap-2", children: [
          /* @__PURE__ */ u(
            Nh,
            {
              id: c,
              checked: r,
              defaultChecked: o,
              onCheckedChange: (d) => s?.(d === !0),
              disabled: a
            }
          ),
          /* @__PURE__ */ E("label", { "data-slot": "form-group-label", htmlFor: c, className: "!p-0", children: [
            e,
            n && /* @__PURE__ */ u("span", { "data-slot": "form-group-required", children: "*" })
          ] })
        ] }),
        t && /* @__PURE__ */ u("p", { "data-slot": "form-group-error", children: t })
      ]
    }
  );
}
Zb.displayName = "FormGroupCheckbox";
function Lb({
  label: e,
  error: t,
  required: n,
  value: r,
  onValueChange: o,
  disabled: s,
  placeholder: a,
  className: i
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "form-group-default",
      className: g(
        "rounded-sm border bg-background transition-colors",
        "border-input",
        t && "border-destructive",
        i
      ),
      children: [
        /* @__PURE__ */ E("label", { "data-slot": "form-group-label", children: [
          e,
          n && /* @__PURE__ */ u("span", { "data-slot": "form-group-required", children: "*" })
        ] }),
        /* @__PURE__ */ u("div", { "data-slot": "form-group-control", children: /* @__PURE__ */ u(
          Ug,
          {
            value: r,
            onValueChange: o,
            disabled: s,
            placeholder: a,
            className: "h-auto border-0 shadow-none rounded-none w-full"
          }
        ) }),
        t && /* @__PURE__ */ u("p", { "data-slot": "form-group-error", children: t })
      ]
    }
  );
}
Lb.displayName = "FormGroupDate";
const Yb = Nr(({ label: e, error: t, required: n, className: r, id: o, ...s }, a) => {
  const [i, c] = he(!1), d = o || Cr();
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "form-group-default",
      className: g(
        "rounded-sm border bg-background transition-colors",
        i ? "border-black" : "border-input",
        t && "border-destructive",
        r
      ),
      children: [
        /* @__PURE__ */ E("label", { "data-slot": "form-group-label", htmlFor: d, children: [
          e,
          n && /* @__PURE__ */ u("span", { "data-slot": "form-group-required", children: "*" })
        ] }),
        /* @__PURE__ */ u(
          "input",
          {
            ref: a,
            id: d,
            "data-slot": "form-group-control",
            onFocus: (f) => {
              c(!0), s.onFocus?.(f);
            },
            onBlur: (f) => {
              c(!1), s.onBlur?.(f);
            },
            ...s
          }
        ),
        t && /* @__PURE__ */ u("p", { "data-slot": "form-group-error", children: t })
      ]
    }
  );
});
Yb.displayName = "FormGroupDefault";
const Hb = Nr(({ label: e, error: t, required: n, className: r, id: o, rows: s = 3, ...a }, i) => {
  const [c, d] = he(!1), f = o || Cr();
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "form-group-default",
      className: g(
        "rounded-sm border bg-background transition-colors",
        c ? "border-black" : "border-input",
        t && "border-destructive",
        r
      ),
      children: [
        /* @__PURE__ */ E("label", { "data-slot": "form-group-label", htmlFor: f, children: [
          e,
          n && /* @__PURE__ */ u("span", { "data-slot": "form-group-required", children: "*" })
        ] }),
        /* @__PURE__ */ u(
          "textarea",
          {
            ref: i,
            id: f,
            rows: s,
            "data-slot": "form-group-control",
            onFocus: (l) => {
              d(!0), a.onFocus?.(l);
            },
            onBlur: (l) => {
              d(!1), a.onBlur?.(l);
            },
            ...a
          }
        ),
        t && /* @__PURE__ */ u("p", { "data-slot": "form-group-error", children: t })
      ]
    }
  );
});
Hb.displayName = "FormGroupMultiline";
function Ub({
  label: e,
  error: t,
  required: n,
  options: r,
  value: o,
  defaultValue: s,
  onValueChange: a,
  disabled: i,
  className: c,
  orientation: d = "horizontal"
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "form-group-default",
      className: g(
        "rounded-sm border bg-background transition-colors",
        "border-input",
        t && "border-destructive",
        c
      ),
      children: [
        /* @__PURE__ */ E("label", { "data-slot": "form-group-label", children: [
          e,
          n && /* @__PURE__ */ u("span", { "data-slot": "form-group-required", children: "*" })
        ] }),
        /* @__PURE__ */ u("div", { "data-slot": "form-group-control", children: /* @__PURE__ */ u(
          Qg,
          {
            value: o,
            defaultValue: s,
            onValueChange: a,
            disabled: i,
            className: g(
              d === "horizontal" ? "flex gap-4" : "grid gap-2"
            ),
            children: r.map((f) => /* @__PURE__ */ E("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ u(eb, { value: f.value, id: `radio-${f.value}` }),
              /* @__PURE__ */ u(Kg, { htmlFor: `radio-${f.value}`, className: "text-sm font-normal", children: f.label })
            ] }, f.value))
          }
        ) }),
        t && /* @__PURE__ */ u("p", { "data-slot": "form-group-error", children: t })
      ]
    }
  );
}
Ub.displayName = "FormGroupRadio";
function Vb({
  label: e,
  error: t,
  required: n,
  options: r,
  placeholder: o,
  value: s,
  defaultValue: a,
  onValueChange: i,
  disabled: c,
  className: d
}) {
  const [f, l] = he(!1);
  return /* @__PURE__ */ E(
    nb,
    {
      value: s,
      defaultValue: a,
      onValueChange: i,
      disabled: c,
      open: f,
      onOpenChange: l,
      children: [
        /* @__PURE__ */ E(
          "div",
          {
            "data-slot": "form-group-default",
            className: g(
              "rounded-sm border bg-background transition-colors",
              f ? "border-black" : "border-input",
              t && "border-destructive",
              d
            ),
            children: [
              /* @__PURE__ */ E("label", { "data-slot": "form-group-label", children: [
                e,
                n && /* @__PURE__ */ u("span", { "data-slot": "form-group-required", children: "*" })
              ] }),
              /* @__PURE__ */ u(
                ob,
                {
                  "data-slot": "form-group-control",
                  className: "border-0 shadow-none ring-0 h-auto rounded-none focus-visible:ring-0 focus-visible:border-0",
                  children: /* @__PURE__ */ u(rb, { placeholder: o })
                }
              ),
              t && /* @__PURE__ */ u("p", { "data-slot": "form-group-error", children: t })
            ]
          }
        ),
        /* @__PURE__ */ u(ab, { children: r.map((m) => /* @__PURE__ */ u(sb, { value: m.value, children: m.label }, m.value)) })
      ]
    }
  );
}
Vb.displayName = "FormGroupSelect";
function Gb({
  label: e,
  error: t,
  required: n,
  checked: r,
  defaultChecked: o,
  onCheckedChange: s,
  disabled: a,
  className: i
}) {
  const c = Cr();
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "form-group-default",
      className: g(
        "rounded-sm border bg-background transition-colors",
        "border-input",
        t && "border-destructive",
        i
      ),
      children: [
        /* @__PURE__ */ E("div", { "data-slot": "form-group-control", className: "flex items-center justify-between", children: [
          /* @__PURE__ */ E("label", { "data-slot": "form-group-label", htmlFor: c, className: "!p-0", children: [
            e,
            n && /* @__PURE__ */ u("span", { "data-slot": "form-group-required", children: "*" })
          ] }),
          /* @__PURE__ */ u(
            jb,
            {
              id: c,
              checked: r,
              defaultChecked: o,
              onCheckedChange: s,
              disabled: a
            }
          )
        ] }),
        t && /* @__PURE__ */ u("p", { "data-slot": "form-group-error", children: t })
      ]
    }
  );
}
Gb.displayName = "FormGroupSwitch";
function qb({
  area: e,
  className: t,
  style: n,
  ...r
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "form-section-field",
      className: g("bg-card", t),
      style: { gridArea: e, ...n },
      ...r
    }
  );
}
function Jb({
  title: e,
  areas: t,
  columns: n,
  className: r,
  children: o,
  style: s,
  ...a
}) {
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "form-section",
      className: g("rounded-md border bg-card p-4", r),
      ...a,
      children: [
        e && /* @__PURE__ */ u("h3", { className: "mb-3 text-xs font-bold uppercase tracking-wider text-muted-foreground", children: e }),
        /* @__PURE__ */ u(
          "div",
          {
            "data-slot": "form-section-grid",
            style: {
              gridTemplateAreas: t,
              gridTemplateColumns: n,
              ...s
            },
            children: o
          }
        )
      ]
    }
  );
}
Jb.Field = qb;
const io = 768;
function $c() {
  const [e, t] = he(void 0);
  return Ct(() => {
    const n = window.matchMedia(`(max-width: ${io - 1}px)`), r = () => {
      t(window.innerWidth < io);
    };
    return n.addEventListener("change", r), t(window.innerWidth < io), () => n.removeEventListener("change", r);
  }, []), !!e;
}
const Kb = "sidebar_state", Xb = 3600 * 24 * 7, Qb = "16rem", ev = "18rem", tv = "3rem", nv = "b", Rc = Zt(null);
function bn() {
  const e = it(Rc);
  if (!e)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return e;
}
function rv({
  defaultOpen: e = !0,
  open: t,
  onOpenChange: n,
  className: r,
  style: o,
  children: s,
  ...a
}) {
  const i = $c(), [c, d] = he(!1), [f, l] = he(e), m = t ?? f, p = Oe(
    (x) => {
      const _ = typeof x == "function" ? x(m) : x;
      n ? n(_) : l(_), document.cookie = `${Kb}=${_}; path=/; max-age=${Xb}`;
    },
    [n, m]
  ), b = Oe(() => i ? d((x) => !x) : p((x) => !x), [i, p, d]);
  Ct(() => {
    const x = (_) => {
      _.key === nv && (_.metaKey || _.ctrlKey) && (_.preventDefault(), b());
    };
    return window.addEventListener("keydown", x), () => window.removeEventListener("keydown", x);
  }, [b]);
  const v = m ? "expanded" : "collapsed", y = bt(
    () => ({
      state: v,
      open: m,
      setOpen: p,
      isMobile: i,
      openMobile: c,
      setOpenMobile: d,
      toggleSidebar: b
    }),
    [v, m, p, i, c, d, b]
  );
  return /* @__PURE__ */ u(Rc.Provider, { value: y, children: /* @__PURE__ */ u(yd, { delayDuration: 0, children: /* @__PURE__ */ u(
    "div",
    {
      style: {
        "--sidebar-width": Qb,
        "--sidebar-width-icon": tv,
        ...o
      },
      className: g(
        "group/sidebar-wrapper has-data-[variant=inset]:bg-sidebar flex min-h-svh w-full",
        r
      ),
      ...a,
      children: s
    }
  ) }) });
}
function ov({
  side: e = "left",
  variant: t = "sidebar",
  collapsible: n = "offcanvas",
  docked: r = !1,
  className: o,
  children: s,
  ...a
}) {
  const { isMobile: i, state: c, openMobile: d, setOpenMobile: f } = bn();
  return n === "none" ? /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sidebar",
      className: g(
        "flex h-full w-(--sidebar-width) flex-col bg-sidebar text-sidebar-foreground",
        o
      ),
      ...a,
      children: s
    }
  ) : i ? /* @__PURE__ */ u(Mc, { open: d, onOpenChange: f, ...a, children: /* @__PURE__ */ E(
    Pc,
    {
      "data-sidebar": "sidebar",
      "data-mobile": "true",
      className: "w-(--sidebar-width) bg-sidebar p-0 text-sidebar-foreground [&>button]:hidden",
      style: {
        "--sidebar-width": ev
      },
      side: e,
      showCloseButton: !1,
      children: [
        /* @__PURE__ */ E(Tc, { className: "sr-only", children: [
          /* @__PURE__ */ u(Ic, { children: "Sidebar" }),
          /* @__PURE__ */ u(Ac, { children: "Sidebar navigation" })
        ] }),
        /* @__PURE__ */ u("div", { className: "flex h-full w-full flex-col", children: s })
      ]
    }
  ) }) : /* @__PURE__ */ E(
    "div",
    {
      className: "group peer hidden md:block text-sidebar-foreground",
      "data-state": c,
      "data-collapsible": c === "collapsed" ? n : "",
      "data-docked": r ? "" : void 0,
      "data-variant": t,
      "data-side": e,
      "data-slot": "sidebar",
      children: [
        /* @__PURE__ */ u(
          "div",
          {
            className: g(
              "relative bg-transparent transition-[width] duration-200 ease-linear",
              "group-data-[collapsible=offcanvas]:w-0",
              "group-data-[side=right]:rotate-180",
              r ? t === "floating" || t === "inset" ? "w-(--sidebar-width) group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "w-(--sidebar-width) group-data-[collapsible=icon]:w-(--sidebar-width-icon)" : t === "floating" || t === "inset" ? "w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "w-(--sidebar-width-icon)"
            )
          }
        ),
        /* @__PURE__ */ u(
          "div",
          {
            className: g(
              "fixed inset-y-0 z-40 hidden h-svh w-(--sidebar-width) transition-[left,right,width] duration-200 ease-linear md:flex group-data-docked:z-10",
              e === "left" ? "left-0 group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "right-0 group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
              // Adjust the padding for floating and inset variants.
              t === "floating" || t === "inset" ? "p-2 group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "group-data-[collapsible=icon]:w-(--sidebar-width-icon) group-data-[side=left]:border-r group-data-[side=right]:border-l",
              o
            ),
            ...a,
            children: /* @__PURE__ */ u(
              "div",
              {
                "data-sidebar": "sidebar",
                className: "flex h-full w-full flex-col overflow-hidden bg-sidebar shadow-xl group-data-docked:shadow-none group-data-[variant=floating]:rounded-lg group-data-[variant=floating]:border group-data-[variant=floating]:border-sidebar-border group-data-[variant=floating]:shadow-sm",
                children: s
              }
            )
          }
        )
      ]
    }
  );
}
function av({
  className: e,
  onClick: t,
  ...n
}) {
  const { toggleSidebar: r } = bn();
  return /* @__PURE__ */ E(
    at,
    {
      "data-sidebar": "trigger",
      "data-slot": "sidebar-trigger",
      variant: "ghost",
      size: "icon",
      className: g("h-7 w-7", e),
      onClick: (o) => {
        t?.(o), r();
      },
      ...n,
      children: [
        /* @__PURE__ */ u(mu, {}),
        /* @__PURE__ */ u("span", { className: "sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
}
function sv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "main",
    {
      "data-slot": "sidebar-inset",
      className: g(
        "relative flex w-full flex-1 flex-col bg-background",
        "peer-data-[variant=inset]:min-h-[calc(100svh-(--spacing(4)))] md:peer-data-[variant=inset]:m-2 md:peer-data-[variant=inset]:ml-0 md:peer-data-[variant=inset]:rounded-xl md:peer-data-[variant=inset]:shadow-sm md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2",
        e
      ),
      ...t
    }
  );
}
function iv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sidebar-header",
      "data-sidebar": "header",
      className: g("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function cv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sidebar-footer",
      "data-sidebar": "footer",
      className: g("flex flex-col gap-2 p-2", e),
      ...t
    }
  );
}
function lv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sidebar-content",
      "data-sidebar": "content",
      className: g(
        "flex min-h-0 flex-1 flex-col gap-2 overflow-auto group-data-[collapsible=icon]:overflow-hidden",
        e
      ),
      ...t
    }
  );
}
function dv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "sidebar-group",
      "data-sidebar": "group",
      className: g("relative flex w-full min-w-0 flex-col p-2", e),
      ...t
    }
  );
}
function Co({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "ul",
    {
      "data-slot": "sidebar-menu",
      "data-sidebar": "menu",
      className: g(
        "flex w-full min-w-0 flex-col gap-1",
        e
      ),
      ...t
    }
  );
}
function yr({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "li",
    {
      "data-slot": "sidebar-menu-item",
      "data-sidebar": "menu-item",
      className: g("group/menu-item relative", e),
      ...t
    }
  );
}
const uv = Yt(
  "peer/menu-button flex w-full items-center gap-2 overflow-hidden rounded-md p-2 text-left text-sm outline-hidden ring-sidebar-ring transition-[width,height,padding] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 group-has-data-[sidebar=menu-action]/menu-item:pr-8 aria-disabled:pointer-events-none aria-disabled:opacity-50 data-[active=true]:bg-sidebar-accent data-[active=true]:font-medium data-[active=true]:text-sidebar-accent-foreground data-[state=open]:hover:bg-sidebar-accent data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:size-8! group-data-[collapsible=icon]:p-2! [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "hover:bg-sidebar-accent hover:text-sidebar-accent-foreground",
        outline: "bg-background shadow-[0_0_0_1px_hsl(var(--sidebar-border))] hover:bg-sidebar-accent hover:text-sidebar-accent-foreground hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      size: {
        default: "h-8 text-sm",
        sm: "h-7 text-xs",
        lg: "h-12 text-sm group-data-[collapsible=icon]:p-0!"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function wr({
  asChild: e = !1,
  isActive: t = !1,
  variant: n = "default",
  size: r = "default",
  tooltip: o,
  className: s,
  ...a
}) {
  const i = e ? Or.Root : "button", { isMobile: c, state: d } = bn(), f = /* @__PURE__ */ u(
    i,
    {
      "data-slot": "sidebar-menu-button",
      "data-sidebar": "menu-button",
      "data-size": r,
      "data-active": t,
      className: g(uv({ variant: n, size: r }), s),
      ...a
    }
  );
  return o ? (typeof o == "string" && (o = {
    children: o
  }), /* @__PURE__ */ E(Vs, { children: [
    /* @__PURE__ */ u(Gs, { asChild: !0, children: f }),
    /* @__PURE__ */ u(
      qs,
      {
        side: "right",
        align: "center",
        hidden: d !== "collapsed" || c,
        ...o
      }
    )
  ] })) : f;
}
function fv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "ul",
    {
      "data-slot": "sidebar-menu-sub",
      "data-sidebar": "menu-sub",
      className: g(
        "mx-3.5 flex min-w-0 translate-x-px flex-col gap-1 border-l border-sidebar-border px-2.5 py-0.5",
        "group-data-[collapsible=icon]:hidden",
        e
      ),
      ...t
    }
  );
}
function mv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "li",
    {
      "data-slot": "sidebar-menu-sub-item",
      "data-sidebar": "menu-sub-item",
      className: g("group/menu-sub-item relative", e),
      ...t
    }
  );
}
function hv({
  asChild: e = !1,
  size: t = "md",
  isActive: n = !1,
  className: r,
  ...o
}) {
  const s = e ? Or.Root : "a";
  return /* @__PURE__ */ u(
    s,
    {
      "data-slot": "sidebar-menu-sub-button",
      "data-sidebar": "menu-sub-button",
      "data-size": t,
      "data-active": n,
      className: g(
        "flex h-7 min-w-0 -translate-x-px items-center gap-2 overflow-hidden rounded-md px-2 text-sidebar-foreground outline-hidden ring-sidebar-ring hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2 active:bg-sidebar-accent active:text-sidebar-accent-foreground disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50 [&>span:last-child]:truncate [&>svg]:size-4 [&>svg]:shrink-0 [&>svg]:text-sidebar-accent-foreground",
        "data-[active=true]:bg-sidebar-accent data-[active=true]:text-sidebar-accent-foreground",
        t === "sm" && "text-xs",
        t === "md" && "text-sm",
        "group-data-[collapsible=icon]:hidden",
        r
      ),
      ...o
    }
  );
}
const oa = Zt(null);
function f1() {
  const e = it(oa);
  if (!e)
    throw new Error("useSidebarNav must be used within AppLayout");
  return e;
}
function pv({ name: e, email: t, avatar: n, children: r, onLogout: o, footer: s }) {
  const { isMobile: a, state: i } = bn(), c = i === "collapsed", d = e ?? "User", f = t ?? "", l = d.split(" ").map((m) => m[0]).join("").slice(0, 2).toUpperCase();
  return /* @__PURE__ */ u(Co, { children: /* @__PURE__ */ u(yr, { children: /* @__PURE__ */ E(Vg, { children: [
    /* @__PURE__ */ u(Gg, { asChild: !0, children: /* @__PURE__ */ E(
      wr,
      {
        size: "lg",
        className: "data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground",
        children: [
          /* @__PURE__ */ E(Ea, { className: "h-8 w-8 rounded-lg", children: [
            n && /* @__PURE__ */ u(za, { src: n, alt: d, className: "rounded-lg" }),
            /* @__PURE__ */ u(Ma, { className: "rounded-lg text-xs bg-primary text-white", children: l })
          ] }),
          !c && /* @__PURE__ */ E(dn, { children: [
            /* @__PURE__ */ E("div", { className: "grid flex-1 text-left text-sm leading-tight", children: [
              /* @__PURE__ */ u("span", { className: "truncate font-medium", children: d }),
              /* @__PURE__ */ u("span", { className: "truncate text-xs text-sidebar-foreground/50", children: f })
            ] }),
            /* @__PURE__ */ u(ei, { className: "ml-auto size-4" })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ E(
      qg,
      {
        className: "w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg",
        side: a ? "bottom" : "right",
        align: "end",
        sideOffset: 4,
        children: [
          /* @__PURE__ */ u(Jg, { className: "p-0 font-normal", children: /* @__PURE__ */ E("div", { className: "flex items-center gap-2 px-1 py-1.5 text-left text-sm", children: [
            /* @__PURE__ */ E(Ea, { className: "h-8 w-8 rounded-lg", children: [
              n && /* @__PURE__ */ u(za, { src: n, alt: d, className: "rounded-lg" }),
              /* @__PURE__ */ u(Ma, { className: "rounded-lg bg-primary text-xs text-white", children: l })
            ] }),
            /* @__PURE__ */ E("div", { className: "grid flex-1 text-left text-sm leading-tight", children: [
              /* @__PURE__ */ u("span", { className: "truncate font-semibold", children: d }),
              /* @__PURE__ */ u("span", { className: "truncate text-xs text-muted-foreground", children: f })
            ] })
          ] }) }),
          /* @__PURE__ */ u(lr, {}),
          r,
          r && /* @__PURE__ */ u(lr, {}),
          /* @__PURE__ */ E(cr, { children: [
            /* @__PURE__ */ u(Ud, { className: "mr-2 h-4 w-4" }),
            "Account"
          ] }),
          /* @__PURE__ */ E(
            cr,
            {
              onSelect: () => {
                const p = document.documentElement.classList.toggle("dark") ? "dark" : "light";
                localStorage.setItem("theme", p), window.dispatchEvent(new StorageEvent("storage", { key: "theme", newValue: p }));
              },
              children: [
                document.documentElement.classList.contains("dark") ? /* @__PURE__ */ u(xu, { className: "mr-2 h-4 w-4" }) : /* @__PURE__ */ u(lu, { className: "mr-2 h-4 w-4" }),
                "Theme"
              ]
            }
          ),
          /* @__PURE__ */ E(cr, { children: [
            /* @__PURE__ */ u(Xs, { className: "mr-2 h-4 w-4" }),
            "Notifications"
          ] }),
          /* @__PURE__ */ u(lr, {}),
          /* @__PURE__ */ E(cr, { onSelect: o, children: [
            /* @__PURE__ */ u(iu, { className: "mr-2 h-4 w-4" }),
            "Log out"
          ] }),
          s && /* @__PURE__ */ E(dn, { children: [
            /* @__PURE__ */ u(lr, {}),
            /* @__PURE__ */ u("div", { className: "px-2 py-1.5 text-xs text-muted-foreground select-none", children: s })
          ] })
        ]
      }
    )
  ] }) }) });
}
function gv({ items: e, userProfileProps: t, showBackButton: n = !0 }) {
  const r = it(oa), { setOpen: o, isMobile: s } = bn(), { isPinned: a, setIsPinned: i } = jc(), c = e, d = r?.isCustomNav ?? !1;
  return /* @__PURE__ */ E(
    ov,
    {
      collapsible: "icon",
      docked: a,
      onMouseEnter: () => {
        !s && !a && o(!0);
      },
      children: [
        /* @__PURE__ */ u(iv, { className: "h-15 justify-center border-b border-sidebar-border px-4 group-data-[collapsible=icon]:px-0 group-data-[collapsible=icon]:py-0", children: /* @__PURE__ */ E("div", { className: "flex items-center justify-between group-data-[collapsible=icon]:justify-center", children: [
          /* @__PURE__ */ E($t, { to: "/", className: "flex items-center gap-2 group-data-[collapsible=icon]:h-15 group-data-[collapsible=icon]:w-12.5 group-data-[collapsible=icon]:items-center group-data-[collapsible=icon]:justify-center", children: [
            /* @__PURE__ */ u(
              "span",
              {
                role: "img",
                "aria-label": "BeProduct",
                className: "block h-5 w-[105px] shrink-0 bg-sidebar-foreground group-data-[collapsible=icon]:hidden",
                style: { mask: 'url("/beproduct-logo.svg") center / contain no-repeat' }
              }
            ),
            /* @__PURE__ */ u(
              "span",
              {
                role: "img",
                "aria-label": "BeProduct",
                className: "hidden shrink-0 bg-sidebar-foreground group-data-[collapsible=icon]:block",
                style: { width: 20, height: 20, mask: 'url("/beproduct.svg") center / contain no-repeat' }
              }
            )
          ] }),
          /* @__PURE__ */ E("div", { className: "flex items-center gap-2 group-data-[collapsible=icon]:hidden", children: [
            d && /* @__PURE__ */ u(
              $t,
              {
                to: "/",
                onClick: () => r?.resetNavItems(),
                className: "text-sidebar-foreground/50 hover:text-white",
                children: /* @__PURE__ */ u(Qd, { className: "h-3.5 w-3.5" })
              }
            ),
            !s && /* @__PURE__ */ u(
              "button",
              {
                onClick: () => {
                  i(!a), a || o(!0);
                },
                className: "text-sidebar-foreground/50 hover:text-white",
                children: a ? /* @__PURE__ */ u(bu, { className: "h-3.5 w-3.5" }) : /* @__PURE__ */ u(Mr, { className: "h-3 w-3" })
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ u(lv, { children: /* @__PURE__ */ E(dv, { className: "p-0", children: [
          n && /* @__PURE__ */ u(Co, { className: "px-2", children: /* @__PURE__ */ u(yr, { children: /* @__PURE__ */ u(
            wr,
            {
              asChild: !!r?.backHref,
              onClick: r?.backHref ? void 0 : () => window.history.back(),
              className: "h-10 bg-primary text-white hover:bg-primary/90 hover:text-white",
              tooltip: "Back",
              children: r?.backHref ? /* @__PURE__ */ E($t, { to: r.backHref, children: [
                /* @__PURE__ */ u(Da, { className: "h-5 w-5" }),
                /* @__PURE__ */ u("span", { children: "Back" })
              ] }) : /* @__PURE__ */ E(dn, { children: [
                /* @__PURE__ */ u(Da, { className: "h-5 w-5" }),
                /* @__PURE__ */ u("span", { children: "Back" })
              ] })
            }
          ) }) }),
          /* @__PURE__ */ u(Co, { className: "mt-2 px-2", children: c.map((f) => /* @__PURE__ */ u(bv, { item: f }, f.title)) })
        ] }) }),
        /* @__PURE__ */ u(cv, { className: "border-t border-sidebar-border", children: /* @__PURE__ */ u(pv, { ...t }) })
      ]
    }
  );
}
function bv({ item: e }) {
  const t = Os(), n = e.href ? e.href === "/" ? t.pathname === "/" : t.pathname.startsWith(e.href) : e.children?.some(
    (r) => r.href ? t.pathname.startsWith(r.href) : !1
  ) ?? !1;
  return e.children ? /* @__PURE__ */ u(
    Ch,
    {
      asChild: !0,
      defaultOpen: n,
      className: "group/collapsible",
      children: /* @__PURE__ */ E(yr, { children: [
        /* @__PURE__ */ u(Oh, { asChild: !0, children: /* @__PURE__ */ E(wr, { tooltip: e.title, isActive: n, children: [
          e.icon && /* @__PURE__ */ u(e.icon, { className: "h-4 w-4" }),
          /* @__PURE__ */ u("span", { children: e.title }),
          /* @__PURE__ */ u(Wn, { className: "ml-auto h-4 w-4 transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" })
        ] }) }),
        /* @__PURE__ */ u(Dh, { children: /* @__PURE__ */ u(fv, { children: e.children.map((r) => {
          const o = r.href ? t.pathname === r.href : !1;
          return /* @__PURE__ */ u(mv, { children: /* @__PURE__ */ u(hv, { asChild: !0, isActive: o, children: /* @__PURE__ */ u($t, { to: r.href, children: /* @__PURE__ */ u("span", { children: r.title }) }) }) }, r.title);
        }) }) })
      ] })
    }
  ) : /* @__PURE__ */ u(yr, { children: /* @__PURE__ */ u(wr, { asChild: !0, tooltip: e.title, isActive: n, children: /* @__PURE__ */ E($t, { to: e.href, children: [
    e.icon && /* @__PURE__ */ u(e.icon, { className: "h-4 w-4" }),
    /* @__PURE__ */ u("span", { children: e.title })
  ] }) }) });
}
function vv({ ...e }) {
  return /* @__PURE__ */ u("nav", { "aria-label": "breadcrumb", "data-slot": "breadcrumb", ...e });
}
function yv({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "ol",
    {
      "data-slot": "breadcrumb-list",
      className: g(
        "flex flex-wrap items-center gap-1.5 text-sm font-semibold font-montserrat text-muted-foreground uppercase sm:gap-2.5",
        e
      ),
      ...t
    }
  );
}
function wv({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "li",
    {
      "data-slot": "breadcrumb-item",
      className: g("inline-flex items-center gap-1.5", e),
      ...t
    }
  );
}
function xv({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    $t,
    {
      "data-slot": "breadcrumb-link",
      className: g(
        "text-muted-foreground hover:text-foreground transition-colors",
        e
      ),
      ...t
    }
  );
}
function kv({ className: e, ...t }) {
  return /* @__PURE__ */ u(
    "span",
    {
      role: "link",
      "aria-disabled": "true",
      "aria-current": "page",
      "data-slot": "breadcrumb-page",
      className: g("text-foreground font-medium", e),
      ...t
    }
  );
}
function _v({
  children: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ u(
    "li",
    {
      role: "presentation",
      "aria-hidden": "true",
      "data-slot": "breadcrumb-separator",
      className: g("[&>svg]:size-3.5", t),
      ...n,
      children: e ?? /* @__PURE__ */ u(Wn, { className: "text-muted-foreground/60" })
    }
  );
}
function m1({ className: e, ...t }) {
  return /* @__PURE__ */ E(
    "span",
    {
      role: "presentation",
      "aria-hidden": "true",
      "data-slot": "breadcrumb-ellipsis",
      className: g("flex size-9 items-center justify-center", e),
      ...t,
      children: [
        /* @__PURE__ */ u(qd, { className: "size-4" }),
        /* @__PURE__ */ u("span", { className: "sr-only", children: "More" })
      ]
    }
  );
}
function Sv({ items: e, className: t }) {
  return e.length === 0 ? null : /* @__PURE__ */ u(vv, { className: g("px-5 py-2.5", t), children: /* @__PURE__ */ u(yv, { children: e.map((n, r) => {
    const o = r === e.length - 1;
    return /* @__PURE__ */ E(gl, { children: [
      r > 0 && /* @__PURE__ */ u(_v, {}),
      /* @__PURE__ */ u(wv, { children: n.href && !o ? /* @__PURE__ */ u(xv, { to: n.href, children: n.label }) : /* @__PURE__ */ u(kv, { children: n.label }) })
    ] }, r);
  }) }) });
}
const Wc = "380px", Nv = "36px", Cv = "20rem", aa = Zt(null);
function $r() {
  const e = it(aa);
  if (!e)
    throw new Error("useActionBar must be used within an ActionBarProvider.");
  return e;
}
const sa = Zt(null);
function Ov() {
  const e = it(sa);
  if (!e)
    throw new Error("useActionBarSlotValue must be used within an ActionBarProvider.");
  return e.active ? e.childrenRef.current : null;
}
function h1({ defaultOpen: e, docked: t, width: n, children: r }) {
  const o = it(sa);
  if (!o)
    throw new Error("ActionPanel must be used within an ActionBarProvider.");
  const { register: s, childrenRef: a } = o, i = it(aa);
  return a.current = r, Ct(() => s(), [s]), Ct(() => {
    i && (t ? (i.setIsPinned(!0), i.setOpen(!0)) : (i.setIsPinned(!1), e ? i.setOpen(!0) : i.setOpen(!1)));
  }, []), Ct(() => {
    if (!n) return;
    const c = document.querySelector('[data-slot="actionbar-wrapper"]');
    if (c)
      return c.style.setProperty("--actionbar-width", n), () => {
        c.style.setProperty("--actionbar-width", Wc);
      };
  }, [n]), null;
}
function p1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "action-panel-header",
      className: g("flex h-15 shrink-0 items-center gap-2 border-b bg-primary-darker px-4 pr-12 text-sm font-bold font-montserrat uppercase text-white", e),
      ...t
    }
  );
}
function g1({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ u(zc, { className: "flex-1", children: /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "action-panel-body",
      className: g("px-4 py-3", e),
      ...t
    }
  ) });
}
function Dv({
  defaultOpen: e = !1,
  open: t,
  onOpenChange: n,
  defaultPinned: r = !1,
  className: o,
  style: s,
  children: a,
  ...i
}) {
  const c = $c(), [d, f] = he(!1), [l, m] = he(e), [p, b] = he(r), [v, y] = he(!1), x = Nt(null), _ = t ?? l, S = Oe(
    (Z) => {
      const J = typeof Z == "function" ? Z(_) : Z;
      n ? n(J) : m(J);
    },
    [n, _]
  ), D = Oe(() => c ? f((Z) => !Z) : S((Z) => !Z), [c, S]), N = _ ? "expanded" : "collapsed", k = bt(
    () => ({
      state: N,
      open: _,
      setOpen: S,
      isMobile: c,
      openMobile: d,
      setOpenMobile: f,
      isPinned: p,
      setIsPinned: b,
      toggleActionBar: D
    }),
    [N, _, S, c, d, f, p, b, D]
  ), P = Nt(0), O = Oe(() => {
    const Z = ++P.current;
    return y(!0), () => {
      P.current === Z && y(!1);
    };
  }, []), B = bt(
    () => ({ active: v, childrenRef: x, register: O }),
    [v, O]
  );
  return /* @__PURE__ */ u(aa.Provider, { value: k, children: /* @__PURE__ */ u(sa.Provider, { value: B, children: /* @__PURE__ */ u(
    "div",
    {
      "data-slot": "actionbar-wrapper",
      style: {
        "--actionbar-width": Wc,
        "--actionbar-rail-width": Nv,
        ...s
      },
      className: g("group/actionbar-wrapper flex flex-1", o),
      ...i,
      children: a
    }
  ) }) });
}
function Ev({
  railContent: e,
  title: t = "Action panel",
  className: n,
  children: r,
  ...o
}) {
  const { isMobile: s, state: a, open: i, setOpen: c, openMobile: d, setOpenMobile: f, isPinned: l } = $r(), m = l || i;
  return s ? /* @__PURE__ */ u(Mc, { open: d, onOpenChange: f, ...o, children: /* @__PURE__ */ E(
    Pc,
    {
      "data-slot": "actionbar-mobile",
      className: "bg-card p-0 [&>button]:hidden",
      style: {
        "--actionbar-width-mobile": Cv,
        width: "var(--actionbar-width-mobile)"
      },
      side: "right",
      showCloseButton: !1,
      children: [
        /* @__PURE__ */ E(Tc, { className: "sr-only", children: [
          /* @__PURE__ */ u(Ic, { children: t }),
          /* @__PURE__ */ u(Ac, { children: t })
        ] }),
        /* @__PURE__ */ u("div", { className: "flex h-full w-full flex-col", children: r })
      ]
    }
  ) }) : /* @__PURE__ */ E(
    "div",
    {
      className: "group peer hidden md:block",
      "data-state": a,
      "data-collapsible": m ? "" : "icon",
      "data-docked": l ? "" : void 0,
      "data-slot": "actionbar",
      "data-side": "right",
      children: [
        /* @__PURE__ */ u(
          "div",
          {
            className: g(
              "relative w-(--actionbar-rail-width) transition-[width] duration-200 ease-linear",
              "group-data-docked:w-(--actionbar-width)"
            )
          }
        ),
        /* @__PURE__ */ E(
          "div",
          {
            className: g(
              "fixed inset-y-0 right-0 z-40 hidden h-svh w-(--actionbar-width) transition-[width] duration-200 ease-linear md:flex group-data-docked:z-10",
              "group-data-[collapsible=icon]:w-(--actionbar-rail-width)",
              n
            ),
            ...o,
            children: [
              /* @__PURE__ */ u(
                "div",
                {
                  "data-slot": "actionbar-rail",
                  className: g(
                    "absolute inset-0 flex cursor-pointer flex-col items-center bg-primary-darker text-white transition-opacity duration-200",
                    "group-data-[collapsible=]:opacity-0 group-data-[collapsible=]:pointer-events-none"
                  ),
                  onMouseEnter: () => c(!0),
                  children: e
                }
              ),
              /* @__PURE__ */ u(
                "div",
                {
                  "data-slot": "actionbar-expanded",
                  className: g(
                    "absolute inset-0 flex flex-col overflow-hidden border-l bg-card transition-opacity duration-200",
                    "group-data-[collapsible=icon]:opacity-0 group-data-[collapsible=icon]:pointer-events-none",
                    "shadow-xl group-data-docked:shadow-none"
                  ),
                  children: r
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function b1({
  className: e,
  onClick: t,
  ...n
}) {
  const { toggleActionBar: r } = $r();
  return /* @__PURE__ */ E(
    at,
    {
      "data-slot": "actionbar-trigger",
      variant: "ghost",
      size: "icon",
      className: g("h-8 w-8", e),
      onClick: (o) => {
        t?.(o), r();
      },
      ...n,
      children: [
        /* @__PURE__ */ u(pu, { className: "h-4 w-4" }),
        /* @__PURE__ */ u("span", { className: "sr-only", children: "Toggle action panel" })
      ]
    }
  );
}
function zv({
  railContent: e,
  className: t
}) {
  const n = Ov();
  return n ? /* @__PURE__ */ E(
    Ev,
    {
      railContent: e ?? /* @__PURE__ */ u(Mv, {}),
      className: t,
      children: [
        /* @__PURE__ */ u("div", { className: "absolute right-3 top-0 z-10 flex h-15 items-center", children: /* @__PURE__ */ u(Pv, {}) }),
        n
      ]
    }
  ) : null;
}
const Oo = "h-5 w-5 text-success", Do = 3;
function Mv({ className: e, ...t }) {
  return /* @__PURE__ */ E(
    "div",
    {
      "data-slot": "actionbar-default-rail",
      className: g("flex w-full flex-1 flex-col items-center", e),
      ...t,
      children: [
        /* @__PURE__ */ u("div", { className: "flex h-15 items-center", children: /* @__PURE__ */ u(Mr, { className: Oo, strokeWidth: Do }) }),
        /* @__PURE__ */ u("div", { className: "flex flex-1 items-center", children: /* @__PURE__ */ u(Dd, { className: "h-4 w-4 text-white", strokeWidth: 2.5 }) })
      ]
    }
  );
}
function Pv() {
  const { isPinned: e, setIsPinned: t, isMobile: n } = $r();
  return n ? null : /* @__PURE__ */ u(
    "button",
    {
      onClick: () => t(!e),
      className: "hover:opacity-80",
      "aria-label": e ? "Undock panel" : "Dock panel",
      children: e ? /* @__PURE__ */ u(Yd, { className: Oo, strokeWidth: Do }) : /* @__PURE__ */ u(Zd, { className: Oo, strokeWidth: Do })
    }
  );
}
const Fc = Zt({ isPinned: !1, setIsPinned: () => {
} });
function jc() {
  return it(Fc);
}
function v1({ navItems: e, breadcrumbs: t, userProfileProps: n }) {
  const [r, o] = he(null), [s, a] = he(null), [i, c] = he(!1), d = Nt(0), [f, l] = he(!1), [m, p] = he(!1), b = f || m;
  Ct(() => {
    const y = () => {
      const x = window.scrollY;
      c(x > 60 && x > d.current), d.current = x;
    };
    return window.addEventListener("scroll", y, { passive: !0 }), () => window.removeEventListener("scroll", y);
  }, []);
  const v = bt(
    () => ({
      navItems: r ?? e,
      setNavItems: (y) => o(y),
      resetNavItems: () => o(null),
      isCustomNav: r !== null,
      backHref: s,
      setBackHref: (y) => a(y),
      resetBackHref: () => a(null)
    }),
    [r, e, s]
  );
  return /* @__PURE__ */ u(oa.Provider, { value: v, children: /* @__PURE__ */ u(Fc.Provider, { value: { isPinned: f, setIsPinned: l }, children: /* @__PURE__ */ E(
    rv,
    {
      open: b,
      onOpenChange: (y) => {
        f || p(y);
      },
      style: {
        "--sidebar-width": "250px",
        "--sidebar-width-icon": "50px"
      },
      children: [
        /* @__PURE__ */ u(gv, { items: r ?? e, userProfileProps: n }),
        /* @__PURE__ */ E(Dv, { children: [
          /* @__PURE__ */ u(
            Tv,
            {
              headerHidden: i,
              breadcrumbs: t
            }
          ),
          /* @__PURE__ */ u(zv, {})
        ] })
      ]
    }
  ) }) });
}
function Tv({
  headerHidden: e,
  breadcrumbs: t
}) {
  const { setOpen: n, isMobile: r, state: o } = bn(), { isPinned: s } = jc(), a = o === "expanded", i = $r();
  return /* @__PURE__ */ E(
    sv,
    {
      onMouseEnter: () => {
        !r && !s && n(!1), !i.isMobile && !i.isPinned && i.setOpen(!1);
      },
      children: [
        /* @__PURE__ */ E(
          "header",
          {
            className: g(
              "sticky top-0 z-30 flex h-15 items-center gap-2 border-b border-border bg-background px-5 transition-transform duration-300",
              e && "-translate-y-full"
            ),
            children: [
              /* @__PURE__ */ u(av, { className: "md:hidden" }),
              /* @__PURE__ */ u(
                "img",
                {
                  src: "/beproduct-logo.svg",
                  alt: "BeProduct",
                  className: g(
                    "h-5 dark:brightness-0 dark:invert",
                    a ? "hidden md:hidden" : "hidden lg:block",
                    "max-md:block max-md:mr-auto"
                  )
                }
              ),
              /* @__PURE__ */ E("div", { className: "hidden items-center gap-1 border-l border-r border-border px-4 lg:flex", children: [
                /* @__PURE__ */ E(at, { variant: "ghost", size: "icon", className: "relative h-8 w-8", children: [
                  /* @__PURE__ */ u(Xs, { className: "h-4 w-4" }),
                  /* @__PURE__ */ u("span", { className: "absolute -right-0.5 -top-0.5 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-destructive/80 text-[9px] text-white", children: "3" })
                ] }),
                /* @__PURE__ */ u(at, { variant: "ghost", size: "icon", className: "h-8 w-8", children: /* @__PURE__ */ u(ru, { className: "h-4 w-4" }) }),
                /* @__PURE__ */ u(at, { variant: "ghost", size: "icon", className: "h-8 w-8", children: /* @__PURE__ */ u(Kd, { className: "h-4 w-4" }) })
              ] }),
              /* @__PURE__ */ u("div", { className: "flex-1" })
            ]
          }
        ),
        /* @__PURE__ */ E("main", { className: "min-h-[calc(100vh-60px)]", children: [
          t && /* @__PURE__ */ u(Sv, { items: t }),
          /* @__PURE__ */ u(Ds, {})
        ] })
      ]
    }
  );
}
function y1() {
  return /* @__PURE__ */ u(Ds, {});
}
function C(e, t, n) {
  function r(i, c) {
    if (i._zod || Object.defineProperty(i, "_zod", {
      value: {
        def: c,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), i._zod.traits.has(e))
      return;
    i._zod.traits.add(e), t(i, c);
    const d = a.prototype, f = Object.keys(d);
    for (let l = 0; l < f.length; l++) {
      const m = f[l];
      m in i || (i[m] = d[m].bind(i));
    }
  }
  const o = n?.Parent ?? Object;
  class s extends o {
  }
  Object.defineProperty(s, "name", { value: e });
  function a(i) {
    var c;
    const d = n?.Parent ? new s() : this;
    r(d, i), (c = d._zod).deferred ?? (c.deferred = []);
    for (const f of d._zod.deferred)
      f();
    return d;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (i) => n?.Parent && i instanceof n.Parent ? !0 : i?._zod?.traits?.has(e)
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class ln extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Bc extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Zc = {};
function jt(e) {
  return Zc;
}
function Lc(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, o]) => t.indexOf(+r) === -1).map(([r, o]) => o);
}
function Eo(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function ia(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function ca(e) {
  return e == null;
}
function la(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
const ls = /* @__PURE__ */ Symbol("evaluating");
function te(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== ls)
        return r === void 0 && (r = ls, r = n()), r;
    },
    set(o) {
      Object.defineProperty(e, t, {
        value: o
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Vt(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Et(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function ds(e) {
  return JSON.stringify(e);
}
function Iv(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const Yc = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function xr(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Av = ia(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function $n(e) {
  if (xr(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(xr(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function Hc(e) {
  return $n(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const $v = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Rr(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function zt(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n?.parent) && (r._zod.parent = e), r;
}
function V(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Rv(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function Wv(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const s = Et(e._zod.def, {
    get shape() {
      const a = {};
      for (const i in t) {
        if (!(i in n.shape))
          throw new Error(`Unrecognized key: "${i}"`);
        t[i] && (a[i] = n.shape[i]);
      }
      return Vt(this, "shape", a), a;
    },
    checks: []
  });
  return zt(e, s);
}
function Fv(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const s = Et(e._zod.def, {
    get shape() {
      const a = { ...e._zod.def.shape };
      for (const i in t) {
        if (!(i in n.shape))
          throw new Error(`Unrecognized key: "${i}"`);
        t[i] && delete a[i];
      }
      return Vt(this, "shape", a), a;
    },
    checks: []
  });
  return zt(e, s);
}
function jv(e, t) {
  if (!$n(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const s = e._zod.def.shape;
    for (const a in t)
      if (Object.getOwnPropertyDescriptor(s, a) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const o = Et(e._zod.def, {
    get shape() {
      const s = { ...e._zod.def.shape, ...t };
      return Vt(this, "shape", s), s;
    }
  });
  return zt(e, o);
}
function Bv(e, t) {
  if (!$n(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Et(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Vt(this, "shape", r), r;
    }
  });
  return zt(e, n);
}
function Zv(e, t) {
  const n = Et(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Vt(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return zt(e, n);
}
function Lv(e, t, n) {
  const o = t._zod.def.checks;
  if (o && o.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const a = Et(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, c = { ...i };
      if (n)
        for (const d in n) {
          if (!(d in i))
            throw new Error(`Unrecognized key: "${d}"`);
          n[d] && (c[d] = e ? new e({
            type: "optional",
            innerType: i[d]
          }) : i[d]);
        }
      else
        for (const d in i)
          c[d] = e ? new e({
            type: "optional",
            innerType: i[d]
          }) : i[d];
      return Vt(this, "shape", c), c;
    },
    checks: []
  });
  return zt(t, a);
}
function Yv(e, t, n) {
  const r = Et(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, s = { ...o };
      if (n)
        for (const a in n) {
          if (!(a in s))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (s[a] = new e({
            type: "nonoptional",
            innerType: o[a]
          }));
        }
      else
        for (const a in o)
          s[a] = new e({
            type: "nonoptional",
            innerType: o[a]
          });
      return Vt(this, "shape", s), s;
    }
  });
  return zt(t, r);
}
function an(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n]?.continue !== !0)
      return !0;
  return !1;
}
function Uc(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function ur(e) {
  return typeof e == "string" ? e : e?.message;
}
function Bt(e, t, n) {
  const r = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const o = ur(e.inst?._zod.def?.error?.(e)) ?? ur(t?.error?.(e)) ?? ur(n.customError?.(e)) ?? ur(n.localeError?.(e)) ?? "Invalid input";
    r.message = o;
  }
  return delete r.inst, delete r.continue, t?.reportInput || delete r.input, r;
}
function da(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Rn(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const Vc = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Eo, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Gc = C("$ZodError", Vc), qc = C("$ZodError", Vc, { Parent: Error });
function Hv(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const o of e.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
  return { formErrors: r, fieldErrors: n };
}
function Uv(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (o) => {
    for (const s of o.issues)
      if (s.code === "invalid_union" && s.errors.length)
        s.errors.map((a) => r({ issues: a }));
      else if (s.code === "invalid_key")
        r({ issues: s.issues });
      else if (s.code === "invalid_element")
        r({ issues: s.issues });
      else if (s.path.length === 0)
        n._errors.push(t(s));
      else {
        let a = n, i = 0;
        for (; i < s.path.length; ) {
          const c = s.path[i];
          i === s.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(t(s))) : a[c] = a[c] || { _errors: [] }, a = a[c], i++;
        }
      }
  };
  return r(e), n;
}
const ua = (e) => (t, n, r, o) => {
  const s = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, s);
  if (a instanceof Promise)
    throw new ln();
  if (a.issues.length) {
    const i = new (o?.Err ?? e)(a.issues.map((c) => Bt(c, s, jt())));
    throw Yc(i, o?.callee), i;
  }
  return a.value;
}, fa = (e) => async (t, n, r, o) => {
  const s = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, s);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const i = new (o?.Err ?? e)(a.issues.map((c) => Bt(c, s, jt())));
    throw Yc(i, o?.callee), i;
  }
  return a.value;
}, Wr = (e) => (t, n, r) => {
  const o = r ? { ...r, async: !1 } : { async: !1 }, s = t._zod.run({ value: n, issues: [] }, o);
  if (s instanceof Promise)
    throw new ln();
  return s.issues.length ? {
    success: !1,
    error: new (e ?? Gc)(s.issues.map((a) => Bt(a, o, jt())))
  } : { success: !0, data: s.value };
}, Vv = /* @__PURE__ */ Wr(qc), Fr = (e) => async (t, n, r) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let s = t._zod.run({ value: n, issues: [] }, o);
  return s instanceof Promise && (s = await s), s.issues.length ? {
    success: !1,
    error: new e(s.issues.map((a) => Bt(a, o, jt())))
  } : { success: !0, data: s.value };
}, Gv = /* @__PURE__ */ Fr(qc), qv = (e) => (t, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return ua(e)(t, n, o);
}, Jv = (e) => (t, n, r) => ua(e)(t, n, r), Kv = (e) => async (t, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return fa(e)(t, n, o);
}, Xv = (e) => async (t, n, r) => fa(e)(t, n, r), Qv = (e) => (t, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Wr(e)(t, n, o);
}, ey = (e) => (t, n, r) => Wr(e)(t, n, r), ty = (e) => async (t, n, r) => {
  const o = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Fr(e)(t, n, o);
}, ny = (e) => async (t, n, r) => Fr(e)(t, n, r), ry = /^[cC][^\s-]{8,}$/, oy = /^[0-9a-z]+$/, ay = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, sy = /^[0-9a-vA-V]{20}$/, iy = /^[A-Za-z0-9]{27}$/, cy = /^[a-zA-Z0-9_-]{21}$/, ly = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, dy = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, us = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, uy = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, fy = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function my() {
  return new RegExp(fy, "u");
}
const hy = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, py = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, gy = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, by = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, vy = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Jc = /^[A-Za-z0-9_-]*$/, yy = /^\+[1-9]\d{6,14}$/, Kc = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", wy = /* @__PURE__ */ new RegExp(`^${Kc}$`);
function Xc(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function xy(e) {
  return new RegExp(`^${Xc(e)}$`);
}
function ky(e) {
  const t = Xc({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${Kc}T(?:${r})$`);
}
const _y = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Sy = /^[^A-Z]*$/, Ny = /^[^a-z]*$/, lt = /* @__PURE__ */ C("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Cy = /* @__PURE__ */ C("$ZodCheckMaxLength", (e, t) => {
  var n;
  lt.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !ca(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < o && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length <= t.maximum)
      return;
    const a = da(o);
    r.issues.push({
      origin: a,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), Oy = /* @__PURE__ */ C("$ZodCheckMinLength", (e, t) => {
  var n;
  lt.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !ca(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > o && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const o = r.value;
    if (o.length >= t.minimum)
      return;
    const a = da(o);
    r.issues.push({
      origin: a,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: o,
      inst: e,
      continue: !t.abort
    });
  };
}), Dy = /* @__PURE__ */ C("$ZodCheckLengthEquals", (e, t) => {
  var n;
  lt.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const o = r.value;
    return !ca(o) && o.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.minimum = t.length, o.maximum = t.length, o.length = t.length;
  }), e._zod.check = (r) => {
    const o = r.value, s = o.length;
    if (s === t.length)
      return;
    const a = da(o), i = s > t.length;
    r.issues.push({
      origin: a,
      ...i ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), jr = /* @__PURE__ */ C("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  lt.init(e, t), e._zod.onattach.push((o) => {
    const s = o._zod.bag;
    s.format = t.format, t.pattern && (s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (o) => {
    t.pattern.lastIndex = 0, !t.pattern.test(o.value) && o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: o.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), Ey = /* @__PURE__ */ C("$ZodCheckRegex", (e, t) => {
  jr.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), zy = /* @__PURE__ */ C("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Sy), jr.init(e, t);
}), My = /* @__PURE__ */ C("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Ny), jr.init(e, t);
}), Py = /* @__PURE__ */ C("$ZodCheckIncludes", (e, t) => {
  lt.init(e, t);
  const n = Rr(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((o) => {
    const s = o._zod.bag;
    s.patterns ?? (s.patterns = /* @__PURE__ */ new Set()), s.patterns.add(r);
  }), e._zod.check = (o) => {
    o.value.includes(t.includes, t.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ty = /* @__PURE__ */ C("$ZodCheckStartsWith", (e, t) => {
  lt.init(e, t);
  const n = new RegExp(`^${Rr(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Iy = /* @__PURE__ */ C("$ZodCheckEndsWith", (e, t) => {
  lt.init(e, t);
  const n = new RegExp(`.*${Rr(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ay = /* @__PURE__ */ C("$ZodCheckOverwrite", (e, t) => {
  lt.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class $y {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((a) => a), o = Math.min(...r.map((a) => a.length - a.trimStart().length)), s = r.map((a) => a.slice(o)).map((a) => " ".repeat(this.indent * 2) + a);
    for (const a of s)
      this.content.push(a);
  }
  compile() {
    const t = Function, n = this?.args, o = [...(this?.content ?? [""]).map((s) => `  ${s}`)];
    return new t(...n, o.join(`
`));
  }
}
const Ry = {
  major: 4,
  minor: 3,
  patch: 6
}, ve = /* @__PURE__ */ C("$ZodType", (e, t) => {
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Ry;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const o of r)
    for (const s of o._zod.onattach)
      s(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (a, i, c) => {
      let d = an(a), f;
      for (const l of i) {
        if (l._zod.def.when) {
          if (!l._zod.def.when(a))
            continue;
        } else if (d)
          continue;
        const m = a.issues.length, p = l._zod.check(a);
        if (p instanceof Promise && c?.async === !1)
          throw new ln();
        if (f || p instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await p, a.issues.length !== m && (d || (d = an(a, m)));
          });
        else {
          if (a.issues.length === m)
            continue;
          d || (d = an(a, m));
        }
      }
      return f ? f.then(() => a) : a;
    }, s = (a, i, c) => {
      if (an(a))
        return a.aborted = !0, a;
      const d = o(i, r, c);
      if (d instanceof Promise) {
        if (c.async === !1)
          throw new ln();
        return d.then((f) => e._zod.parse(f, c));
      }
      return e._zod.parse(d, c);
    };
    e._zod.run = (a, i) => {
      if (i.skipChecks)
        return e._zod.parse(a, i);
      if (i.direction === "backward") {
        const d = e._zod.parse({ value: a.value, issues: [] }, { ...i, skipChecks: !0 });
        return d instanceof Promise ? d.then((f) => s(f, a, i)) : s(d, a, i);
      }
      const c = e._zod.parse(a, i);
      if (c instanceof Promise) {
        if (i.async === !1)
          throw new ln();
        return c.then((d) => o(d, r, i));
      }
      return o(c, r, i);
    };
  }
  te(e, "~standard", () => ({
    validate: (o) => {
      try {
        const s = Vv(e, o);
        return s.success ? { value: s.data } : { issues: s.error?.issues };
      } catch {
        return Gv(e, o).then((a) => a.success ? { value: a.data } : { issues: a.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), ma = /* @__PURE__ */ C("$ZodString", (e, t) => {
  ve.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? _y(e._zod.bag), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = String(n.value);
      } catch {
      }
    return typeof n.value == "string" || n.issues.push({
      expected: "string",
      code: "invalid_type",
      input: n.value,
      inst: e
    }), n;
  };
}), de = /* @__PURE__ */ C("$ZodStringFormat", (e, t) => {
  jr.init(e, t), ma.init(e, t);
}), Wy = /* @__PURE__ */ C("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = dy), de.init(e, t);
}), Fy = /* @__PURE__ */ C("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = us(r));
  } else
    t.pattern ?? (t.pattern = us());
  de.init(e, t);
}), jy = /* @__PURE__ */ C("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = uy), de.init(e, t);
}), By = /* @__PURE__ */ C("$ZodURL", (e, t) => {
  de.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), o = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(o.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(o.protocol.endsWith(":") ? o.protocol.slice(0, -1) : o.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = o.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Zy = /* @__PURE__ */ C("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = my()), de.init(e, t);
}), Ly = /* @__PURE__ */ C("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = cy), de.init(e, t);
}), Yy = /* @__PURE__ */ C("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = ry), de.init(e, t);
}), Hy = /* @__PURE__ */ C("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = oy), de.init(e, t);
}), Uy = /* @__PURE__ */ C("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = ay), de.init(e, t);
}), Vy = /* @__PURE__ */ C("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = sy), de.init(e, t);
}), Gy = /* @__PURE__ */ C("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = iy), de.init(e, t);
}), qy = /* @__PURE__ */ C("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = ky(t)), de.init(e, t);
}), Jy = /* @__PURE__ */ C("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = wy), de.init(e, t);
}), Ky = /* @__PURE__ */ C("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = xy(t)), de.init(e, t);
}), Xy = /* @__PURE__ */ C("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = ly), de.init(e, t);
}), Qy = /* @__PURE__ */ C("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = hy), de.init(e, t), e._zod.bag.format = "ipv4";
}), e0 = /* @__PURE__ */ C("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = py), de.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), t0 = /* @__PURE__ */ C("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = gy), de.init(e, t);
}), n0 = /* @__PURE__ */ C("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = by), de.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [o, s] = r;
      if (!s)
        throw new Error();
      const a = Number(s);
      if (`${a}` !== s)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${o}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Qc(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const r0 = /* @__PURE__ */ C("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = vy), de.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    Qc(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function o0(e) {
  if (!Jc.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Qc(n);
}
const a0 = /* @__PURE__ */ C("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Jc), de.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    o0(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), s0 = /* @__PURE__ */ C("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = yy), de.init(e, t);
});
function i0(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const o = JSON.parse(atob(r));
    return !("typ" in o && o?.typ !== "JWT" || !o.alg || t && (!("alg" in o) || o.alg !== t));
  } catch {
    return !1;
  }
}
const c0 = /* @__PURE__ */ C("$ZodJWT", (e, t) => {
  de.init(e, t), e._zod.check = (n) => {
    i0(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), l0 = /* @__PURE__ */ C("$ZodUnknown", (e, t) => {
  ve.init(e, t), e._zod.parse = (n) => n;
}), d0 = /* @__PURE__ */ C("$ZodNever", (e, t) => {
  ve.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function fs(e, t, n) {
  e.issues.length && t.issues.push(...Uc(n, e.issues)), t.value[n] = e.value;
}
const u0 = /* @__PURE__ */ C("$ZodArray", (e, t) => {
  ve.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = Array(o.length);
    const s = [];
    for (let a = 0; a < o.length; a++) {
      const i = o[a], c = t.element._zod.run({
        value: i,
        issues: []
      }, r);
      c instanceof Promise ? s.push(c.then((d) => fs(d, n, a))) : fs(c, n, a);
    }
    return s.length ? Promise.all(s).then(() => n) : n;
  };
});
function kr(e, t, n, r, o) {
  if (e.issues.length) {
    if (o && !(n in r))
      return;
    t.issues.push(...Uc(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function el(e) {
  const t = Object.keys(e.shape);
  for (const r of t)
    if (!e.shape?.[r]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${r}": expected a Zod schema`);
  const n = Rv(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function tl(e, t, n, r, o, s) {
  const a = [], i = o.keySet, c = o.catchall._zod, d = c.def.type, f = c.optout === "optional";
  for (const l in t) {
    if (i.has(l))
      continue;
    if (d === "never") {
      a.push(l);
      continue;
    }
    const m = c.run({ value: t[l], issues: [] }, r);
    m instanceof Promise ? e.push(m.then((p) => kr(p, n, l, t, f))) : kr(m, n, l, t, f);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: s
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const f0 = /* @__PURE__ */ C("$ZodObject", (e, t) => {
  if (ve.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
    const i = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const c = { ...i };
        return Object.defineProperty(t, "shape", {
          value: c
        }), c;
      }
    });
  }
  const r = ia(() => el(t));
  te(e._zod, "propValues", () => {
    const i = t.shape, c = {};
    for (const d in i) {
      const f = i[d]._zod;
      if (f.values) {
        c[d] ?? (c[d] = /* @__PURE__ */ new Set());
        for (const l of f.values)
          c[d].add(l);
      }
    }
    return c;
  });
  const o = xr, s = t.catchall;
  let a;
  e._zod.parse = (i, c) => {
    a ?? (a = r.value);
    const d = i.value;
    if (!o(d))
      return i.issues.push({
        expected: "object",
        code: "invalid_type",
        input: d,
        inst: e
      }), i;
    i.value = {};
    const f = [], l = a.shape;
    for (const m of a.keys) {
      const p = l[m], b = p._zod.optout === "optional", v = p._zod.run({ value: d[m], issues: [] }, c);
      v instanceof Promise ? f.push(v.then((y) => kr(y, i, m, d, b))) : kr(v, i, m, d, b);
    }
    return s ? tl(f, d, i, c, r.value, e) : f.length ? Promise.all(f).then(() => i) : i;
  };
}), m0 = /* @__PURE__ */ C("$ZodObjectJIT", (e, t) => {
  f0.init(e, t);
  const n = e._zod.parse, r = ia(() => el(t)), o = (m) => {
    const p = new $y(["shape", "payload", "ctx"]), b = r.value, v = (S) => {
      const D = ds(S);
      return `shape[${D}]._zod.run({ value: input[${D}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const y = /* @__PURE__ */ Object.create(null);
    let x = 0;
    for (const S of b.keys)
      y[S] = `key_${x++}`;
    p.write("const newResult = {};");
    for (const S of b.keys) {
      const D = y[S], N = ds(S), P = m[S]?._zod?.optout === "optional";
      p.write(`const ${D} = ${v(S)};`), P ? p.write(`
        if (${D}.issues.length) {
          if (${N} in input) {
            payload.issues = payload.issues.concat(${D}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${N}, ...iss.path] : [${N}]
            })));
          }
        }
        
        if (${D}.value === undefined) {
          if (${N} in input) {
            newResult[${N}] = undefined;
          }
        } else {
          newResult[${N}] = ${D}.value;
        }
        
      `) : p.write(`
        if (${D}.issues.length) {
          payload.issues = payload.issues.concat(${D}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${N}, ...iss.path] : [${N}]
          })));
        }
        
        if (${D}.value === undefined) {
          if (${N} in input) {
            newResult[${N}] = undefined;
          }
        } else {
          newResult[${N}] = ${D}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const _ = p.compile();
    return (S, D) => _(m, S, D);
  };
  let s;
  const a = xr, i = !Zc.jitless, d = i && Av.value, f = t.catchall;
  let l;
  e._zod.parse = (m, p) => {
    l ?? (l = r.value);
    const b = m.value;
    return a(b) ? i && d && p?.async === !1 && p.jitless !== !0 ? (s || (s = o(t.shape)), m = s(m, p), f ? tl([], b, m, p, l, e) : m) : n(m, p) : (m.issues.push({
      expected: "object",
      code: "invalid_type",
      input: b,
      inst: e
    }), m);
  };
});
function ms(e, t, n, r) {
  for (const s of e)
    if (s.issues.length === 0)
      return t.value = s.value, t;
  const o = e.filter((s) => !an(s));
  return o.length === 1 ? (t.value = o[0].value, o[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((s) => s.issues.map((a) => Bt(a, r, jt())))
  }), t);
}
const h0 = /* @__PURE__ */ C("$ZodUnion", (e, t) => {
  ve.init(e, t), te(e._zod, "optin", () => t.options.some((o) => o._zod.optin === "optional") ? "optional" : void 0), te(e._zod, "optout", () => t.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0), te(e._zod, "values", () => {
    if (t.options.every((o) => o._zod.values))
      return new Set(t.options.flatMap((o) => Array.from(o._zod.values)));
  }), te(e._zod, "pattern", () => {
    if (t.options.every((o) => o._zod.pattern)) {
      const o = t.options.map((s) => s._zod.pattern);
      return new RegExp(`^(${o.map((s) => la(s.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (o, s) => {
    if (n)
      return r(o, s);
    let a = !1;
    const i = [];
    for (const c of t.options) {
      const d = c._zod.run({
        value: o.value,
        issues: []
      }, s);
      if (d instanceof Promise)
        i.push(d), a = !0;
      else {
        if (d.issues.length === 0)
          return d;
        i.push(d);
      }
    }
    return a ? Promise.all(i).then((c) => ms(c, o, e, s)) : ms(i, o, e, s);
  };
}), p0 = /* @__PURE__ */ C("$ZodIntersection", (e, t) => {
  ve.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value, s = t.left._zod.run({ value: o, issues: [] }, r), a = t.right._zod.run({ value: o, issues: [] }, r);
    return s instanceof Promise || a instanceof Promise ? Promise.all([s, a]).then(([c, d]) => hs(n, c, d)) : hs(n, s, a);
  };
});
function zo(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if ($n(e) && $n(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((s) => n.indexOf(s) !== -1), o = { ...e, ...t };
    for (const s of r) {
      const a = zo(e[s], t[s]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [s, ...a.mergeErrorPath]
        };
      o[s] = a.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r], s = t[r], a = zo(o, s);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function hs(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let o;
  for (const i of t.issues)
    if (i.code === "unrecognized_keys") {
      o ?? (o = i);
      for (const c of i.keys)
        r.has(c) || r.set(c, {}), r.get(c).l = !0;
    } else
      e.issues.push(i);
  for (const i of n.issues)
    if (i.code === "unrecognized_keys")
      for (const c of i.keys)
        r.has(c) || r.set(c, {}), r.get(c).r = !0;
    else
      e.issues.push(i);
  const s = [...r].filter(([, i]) => i.l && i.r).map(([i]) => i);
  if (s.length && o && e.issues.push({ ...o, keys: s }), an(e))
    return e;
  const a = zo(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const g0 = /* @__PURE__ */ C("$ZodEnum", (e, t) => {
  ve.init(e, t);
  const n = Lc(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((o) => $v.has(typeof o)).map((o) => typeof o == "string" ? Rr(o) : o.toString()).join("|")})$`), e._zod.parse = (o, s) => {
    const a = o.value;
    return r.has(a) || o.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), o;
  };
}), b0 = /* @__PURE__ */ C("$ZodTransform", (e, t) => {
  ve.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new Bc(e.constructor.name);
    const o = t.transform(n.value, n);
    if (r.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((a) => (n.value = a, n));
    if (o instanceof Promise)
      throw new ln();
    return n.value = o, n;
  };
});
function ps(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const nl = /* @__PURE__ */ C("$ZodOptional", (e, t) => {
  ve.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", te(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), te(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${la(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const o = t.innerType._zod.run(n, r);
      return o instanceof Promise ? o.then((s) => ps(s, n.value)) : ps(o, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), v0 = /* @__PURE__ */ C("$ZodExactOptional", (e, t) => {
  nl.init(e, t), te(e._zod, "values", () => t.innerType._zod.values), te(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), y0 = /* @__PURE__ */ C("$ZodNullable", (e, t) => {
  ve.init(e, t), te(e._zod, "optin", () => t.innerType._zod.optin), te(e._zod, "optout", () => t.innerType._zod.optout), te(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${la(n.source)}|null)$`) : void 0;
  }), te(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), w0 = /* @__PURE__ */ C("$ZodDefault", (e, t) => {
  ve.init(e, t), e._zod.optin = "optional", te(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => gs(s, t)) : gs(o, t);
  };
});
function gs(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const x0 = /* @__PURE__ */ C("$ZodPrefault", (e, t) => {
  ve.init(e, t), e._zod.optin = "optional", te(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), k0 = /* @__PURE__ */ C("$ZodNonOptional", (e, t) => {
  ve.init(e, t), te(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => bs(s, e)) : bs(o, e);
  };
});
function bs(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const _0 = /* @__PURE__ */ C("$ZodCatch", (e, t) => {
  ve.init(e, t), te(e._zod, "optin", () => t.innerType._zod.optin), te(e._zod, "optout", () => t.innerType._zod.optout), te(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => (n.value = s.value, s.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: s.issues.map((a) => Bt(a, r, jt()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((s) => Bt(s, r, jt()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), S0 = /* @__PURE__ */ C("$ZodPipe", (e, t) => {
  ve.init(e, t), te(e._zod, "values", () => t.in._zod.values), te(e._zod, "optin", () => t.in._zod.optin), te(e._zod, "optout", () => t.out._zod.optout), te(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const s = t.out._zod.run(n, r);
      return s instanceof Promise ? s.then((a) => fr(a, t.in, r)) : fr(s, t.in, r);
    }
    const o = t.in._zod.run(n, r);
    return o instanceof Promise ? o.then((s) => fr(s, t.out, r)) : fr(o, t.out, r);
  };
});
function fr(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const N0 = /* @__PURE__ */ C("$ZodReadonly", (e, t) => {
  ve.init(e, t), te(e._zod, "propValues", () => t.innerType._zod.propValues), te(e._zod, "values", () => t.innerType._zod.values), te(e._zod, "optin", () => t.innerType?._zod?.optin), te(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then(vs) : vs(o);
  };
});
function vs(e) {
  return e.value = Object.freeze(e.value), e;
}
const C0 = /* @__PURE__ */ C("$ZodLazy", (e, t) => {
  ve.init(e, t), te(e._zod, "innerType", () => t.getter()), te(e._zod, "pattern", () => e._zod.innerType?._zod?.pattern), te(e._zod, "propValues", () => e._zod.innerType?._zod?.propValues), te(e._zod, "optin", () => e._zod.innerType?._zod?.optin ?? void 0), te(e._zod, "optout", () => e._zod.innerType?._zod?.optout ?? void 0), e._zod.parse = (n, r) => e._zod.innerType._zod.run(n, r);
}), O0 = /* @__PURE__ */ C("$ZodCustom", (e, t) => {
  lt.init(e, t), ve.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, o = t.fn(r);
    if (o instanceof Promise)
      return o.then((s) => ys(s, n, r, e));
    ys(o, n, r, e);
  };
});
function ys(e, t, n, r) {
  if (!e) {
    const o = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (o.params = r._zod.def.params), t.issues.push(Rn(o));
  }
}
var ws;
class D0 {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const o = { ...r, ...this._map.get(t) };
      return Object.keys(o).length ? o : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function E0() {
  return new D0();
}
(ws = globalThis).__zod_globalRegistry ?? (ws.__zod_globalRegistry = E0());
const Dn = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function z0(e, t) {
  return new e({
    type: "string",
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function M0(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xs(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function P0(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function T0(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function I0(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function A0(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $0(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function R0(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function W0(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function F0(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function j0(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function B0(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Z0(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function L0(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Y0(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function H0(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function U0(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function V0(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function G0(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function q0(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function J0(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function K0(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function X0(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Q0(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ew(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tw(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nw(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function rw(e, t) {
  return new e({
    type: "never",
    ...V(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rl(e, t) {
  return new Cy({
    check: "max_length",
    ...V(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function _r(e, t) {
  return new Oy({
    check: "min_length",
    ...V(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function ol(e, t) {
  return new Dy({
    check: "length_equals",
    ...V(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function ow(e, t) {
  return new Ey({
    check: "string_format",
    format: "regex",
    ...V(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function aw(e) {
  return new zy({
    check: "string_format",
    format: "lowercase",
    ...V(e)
  });
}
// @__NO_SIDE_EFFECTS__
function sw(e) {
  return new My({
    check: "string_format",
    format: "uppercase",
    ...V(e)
  });
}
// @__NO_SIDE_EFFECTS__
function iw(e, t) {
  return new Py({
    check: "string_format",
    format: "includes",
    ...V(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function cw(e, t) {
  return new Ty({
    check: "string_format",
    format: "starts_with",
    ...V(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function lw(e, t) {
  return new Iy({
    check: "string_format",
    format: "ends_with",
    ...V(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function vn(e) {
  return new Ay({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function dw(e) {
  return /* @__PURE__ */ vn((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function uw() {
  return /* @__PURE__ */ vn((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function fw() {
  return /* @__PURE__ */ vn((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function mw() {
  return /* @__PURE__ */ vn((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function hw() {
  return /* @__PURE__ */ vn((e) => Iv(e));
}
// @__NO_SIDE_EFFECTS__
function pw(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...V(n)
  });
}
// @__NO_SIDE_EFFECTS__
function gw(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...V(n)
  });
}
// @__NO_SIDE_EFFECTS__
function bw(e) {
  const t = /* @__PURE__ */ vw((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Rn(r, n.value, t._zod.def));
    else {
      const o = r;
      o.fatal && (o.continue = !1), o.code ?? (o.code = "custom"), o.input ?? (o.input = n.value), o.inst ?? (o.inst = t), o.continue ?? (o.continue = !t._zod.def.abort), n.issues.push(Rn(o));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function vw(e, t) {
  const n = new lt({
    check: "custom",
    ...V(t)
  });
  return n._zod.check = e, n;
}
function al(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? Dn,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function Ne(e, t, n = { path: [], schemaPath: [] }) {
  var r;
  const o = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const a = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, a);
  const i = e._zod.toJSONSchema?.();
  if (i)
    a.schema = i;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, a.schema, f);
    else {
      const m = a.schema, p = t.processors[o.type];
      if (!p)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${o.type}`);
      p(e, t, m, f);
    }
    const l = e._zod.parent;
    l && (a.ref || (a.ref = l), Ne(l, t, f), t.seen.get(l).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(a.schema, c), t.io === "input" && Te(e) && (delete a.schema.examples, delete a.schema.default), t.io === "input" && a.schema._prefault && ((r = a.schema).default ?? (r.default = a.schema._prefault)), delete a.schema._prefault, t.seen.get(e).schema;
}
function sl(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = /* @__PURE__ */ new Map();
  for (const a of e.seen.entries()) {
    const i = e.metadataRegistry.get(a[0])?.id;
    if (i) {
      const c = r.get(i);
      if (c && c !== a[0])
        throw new Error(`Duplicate schema id "${i}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      r.set(i, a[0]);
    }
  }
  const o = (a) => {
    const i = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const l = e.external.registry.get(a[0])?.id, m = e.external.uri ?? ((b) => b);
      if (l)
        return { ref: m(l) };
      const p = a[1].defId ?? a[1].schema.id ?? `schema${e.counter++}`;
      return a[1].defId = p, { defId: p, ref: `${m("__shared")}#/${i}/${p}` };
    }
    if (a[1] === n)
      return { ref: "#" };
    const d = `#/${i}/`, f = a[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: f, ref: d + f };
  }, s = (a) => {
    if (a[1].schema.$ref)
      return;
    const i = a[1], { ref: c, defId: d } = o(a);
    i.def = { ...i.schema }, d && (i.defId = d);
    const f = i.schema;
    for (const l in f)
      delete f[l];
    f.$ref = c;
  };
  if (e.cycles === "throw")
    for (const a of e.seen.entries()) {
      const i = a[1];
      if (i.cycle)
        throw new Error(`Cycle detected: #/${i.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const a of e.seen.entries()) {
    const i = a[1];
    if (t === a[0]) {
      s(a);
      continue;
    }
    if (e.external) {
      const d = e.external.registry.get(a[0])?.id;
      if (t !== a[0] && d) {
        s(a);
        continue;
      }
    }
    if (e.metadataRegistry.get(a[0])?.id) {
      s(a);
      continue;
    }
    if (i.cycle) {
      s(a);
      continue;
    }
    if (i.count > 1 && e.reused === "ref") {
      s(a);
      continue;
    }
  }
}
function il(e, t) {
  const n = e.seen.get(t);
  if (!n)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const r = (a) => {
    const i = e.seen.get(a);
    if (i.ref === null)
      return;
    const c = i.def ?? i.schema, d = { ...c }, f = i.ref;
    if (i.ref = null, f) {
      r(f);
      const m = e.seen.get(f), p = m.schema;
      if (p.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (c.allOf = c.allOf ?? [], c.allOf.push(p)) : Object.assign(c, p), Object.assign(c, d), a._zod.parent === f)
        for (const v in c)
          v === "$ref" || v === "allOf" || v in d || delete c[v];
      if (p.$ref && m.def)
        for (const v in c)
          v === "$ref" || v === "allOf" || v in m.def && JSON.stringify(c[v]) === JSON.stringify(m.def[v]) && delete c[v];
    }
    const l = a._zod.parent;
    if (l && l !== f) {
      r(l);
      const m = e.seen.get(l);
      if (m?.schema.$ref && (c.$ref = m.schema.$ref, m.def))
        for (const p in c)
          p === "$ref" || p === "allOf" || p in m.def && JSON.stringify(c[p]) === JSON.stringify(m.def[p]) && delete c[p];
    }
    e.override({
      zodSchema: a,
      jsonSchema: c,
      path: i.path ?? []
    });
  };
  for (const a of [...e.seen.entries()].reverse())
    r(a[0]);
  const o = {};
  if (e.target === "draft-2020-12" ? o.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? o.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? o.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
    const a = e.external.registry.get(t)?.id;
    if (!a)
      throw new Error("Schema is missing an `id` property");
    o.$id = e.external.uri(a);
  }
  Object.assign(o, n.def ?? n.schema);
  const s = e.external?.defs ?? {};
  for (const a of e.seen.entries()) {
    const i = a[1];
    i.def && i.defId && (s[i.defId] = i.def);
  }
  e.external || Object.keys(s).length > 0 && (e.target === "draft-2020-12" ? o.$defs = s : o.definitions = s);
  try {
    const a = JSON.parse(JSON.stringify(o));
    return Object.defineProperty(a, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: Sr(t, "input", e.processors),
          output: Sr(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), a;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Te(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Te(r.element, n);
  if (r.type === "set")
    return Te(r.valueType, n);
  if (r.type === "lazy")
    return Te(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return Te(r.innerType, n);
  if (r.type === "intersection")
    return Te(r.left, n) || Te(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Te(r.keyType, n) || Te(r.valueType, n);
  if (r.type === "pipe")
    return Te(r.in, n) || Te(r.out, n);
  if (r.type === "object") {
    for (const o in r.shape)
      if (Te(r.shape[o], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const o of r.options)
      if (Te(o, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const o of r.items)
      if (Te(o, n))
        return !0;
    return !!(r.rest && Te(r.rest, n));
  }
  return !1;
}
const yw = (e, t = {}) => (n) => {
  const r = al({ ...n, processors: t });
  return Ne(e, r), sl(r, e), il(r, e);
}, Sr = (e, t, n = {}) => (r) => {
  const { libraryOptions: o, target: s } = r ?? {}, a = al({ ...o ?? {}, target: s, io: t, processors: n });
  return Ne(e, a), sl(a, e), il(a, e);
}, ww = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, xw = (e, t, n, r) => {
  const o = n;
  o.type = "string";
  const { minimum: s, maximum: a, format: i, patterns: c, contentEncoding: d } = e._zod.bag;
  if (typeof s == "number" && (o.minLength = s), typeof a == "number" && (o.maxLength = a), i && (o.format = ww[i] ?? i, o.format === "" && delete o.format, i === "time" && delete o.format), d && (o.contentEncoding = d), c && c.size > 0) {
    const f = [...c];
    f.length === 1 ? o.pattern = f[0].source : f.length > 1 && (o.allOf = [
      ...f.map((l) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: l.source
      }))
    ]);
  }
}, kw = (e, t, n, r) => {
  n.not = {};
}, _w = (e, t, n, r) => {
}, Sw = (e, t, n, r) => {
  const o = e._zod.def, s = Lc(o.entries);
  s.every((a) => typeof a == "number") && (n.type = "number"), s.every((a) => typeof a == "string") && (n.type = "string"), n.enum = s;
}, Nw = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, Cw = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, Ow = (e, t, n, r) => {
  const o = n, s = e._zod.def, { minimum: a, maximum: i } = e._zod.bag;
  typeof a == "number" && (o.minItems = a), typeof i == "number" && (o.maxItems = i), o.type = "array", o.items = Ne(s.element, t, { ...r, path: [...r.path, "items"] });
}, Dw = (e, t, n, r) => {
  const o = n, s = e._zod.def;
  o.type = "object", o.properties = {};
  const a = s.shape;
  for (const d in a)
    o.properties[d] = Ne(a[d], t, {
      ...r,
      path: [...r.path, "properties", d]
    });
  const i = new Set(Object.keys(a)), c = new Set([...i].filter((d) => {
    const f = s.shape[d]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  c.size > 0 && (o.required = Array.from(c)), s.catchall?._zod.def.type === "never" ? o.additionalProperties = !1 : s.catchall ? s.catchall && (o.additionalProperties = Ne(s.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, Ew = (e, t, n, r) => {
  const o = e._zod.def, s = o.inclusive === !1, a = o.options.map((i, c) => Ne(i, t, {
    ...r,
    path: [...r.path, s ? "oneOf" : "anyOf", c]
  }));
  s ? n.oneOf = a : n.anyOf = a;
}, zw = (e, t, n, r) => {
  const o = e._zod.def, s = Ne(o.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = Ne(o.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), i = (d) => "allOf" in d && Object.keys(d).length === 1, c = [
    ...i(s) ? s.allOf : [s],
    ...i(a) ? a.allOf : [a]
  ];
  n.allOf = c;
}, Mw = (e, t, n, r) => {
  const o = e._zod.def, s = Ne(o.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = o.innerType, n.nullable = !0) : n.anyOf = [s, { type: "null" }];
}, Pw = (e, t, n, r) => {
  const o = e._zod.def;
  Ne(o.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = o.innerType;
}, Tw = (e, t, n, r) => {
  const o = e._zod.def;
  Ne(o.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = o.innerType, n.default = JSON.parse(JSON.stringify(o.defaultValue));
}, Iw = (e, t, n, r) => {
  const o = e._zod.def;
  Ne(o.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = o.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(o.defaultValue)));
}, Aw = (e, t, n, r) => {
  const o = e._zod.def;
  Ne(o.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = o.innerType;
  let a;
  try {
    a = o.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, $w = (e, t, n, r) => {
  const o = e._zod.def, s = t.io === "input" ? o.in._zod.def.type === "transform" ? o.out : o.in : o.out;
  Ne(s, t, r);
  const a = t.seen.get(e);
  a.ref = s;
}, Rw = (e, t, n, r) => {
  const o = e._zod.def;
  Ne(o.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = o.innerType, n.readOnly = !0;
}, cl = (e, t, n, r) => {
  const o = e._zod.def;
  Ne(o.innerType, t, r);
  const s = t.seen.get(e);
  s.ref = o.innerType;
}, Ww = (e, t, n, r) => {
  const o = e._zod.innerType;
  Ne(o, t, r);
  const s = t.seen.get(e);
  s.ref = o;
}, Fw = /* @__PURE__ */ C("ZodISODateTime", (e, t) => {
  qy.init(e, t), me.init(e, t);
});
function jw(e) {
  return /* @__PURE__ */ X0(Fw, e);
}
const Bw = /* @__PURE__ */ C("ZodISODate", (e, t) => {
  Jy.init(e, t), me.init(e, t);
});
function Zw(e) {
  return /* @__PURE__ */ Q0(Bw, e);
}
const Lw = /* @__PURE__ */ C("ZodISOTime", (e, t) => {
  Ky.init(e, t), me.init(e, t);
});
function Yw(e) {
  return /* @__PURE__ */ ew(Lw, e);
}
const Hw = /* @__PURE__ */ C("ZodISODuration", (e, t) => {
  Xy.init(e, t), me.init(e, t);
});
function Uw(e) {
  return /* @__PURE__ */ tw(Hw, e);
}
const Vw = (e, t) => {
  Gc.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => Uv(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => Hv(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Eo, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Eo, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, He = C("ZodError", Vw, {
  Parent: Error
}), Gw = /* @__PURE__ */ ua(He), qw = /* @__PURE__ */ fa(He), Jw = /* @__PURE__ */ Wr(He), Kw = /* @__PURE__ */ Fr(He), Xw = /* @__PURE__ */ qv(He), Qw = /* @__PURE__ */ Jv(He), ex = /* @__PURE__ */ Kv(He), tx = /* @__PURE__ */ Xv(He), nx = /* @__PURE__ */ Qv(He), rx = /* @__PURE__ */ ey(He), ox = /* @__PURE__ */ ty(He), ax = /* @__PURE__ */ ny(He), ye = /* @__PURE__ */ C("ZodType", (e, t) => (ve.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: Sr(e, "input"),
    output: Sr(e, "output")
  }
}), e.toJSONSchema = yw(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(Et(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => zt(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => Gw(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => Jw(e, n, r), e.parseAsync = async (n, r) => qw(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => Kw(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => Xw(e, n, r), e.decode = (n, r) => Qw(e, n, r), e.encodeAsync = async (n, r) => ex(e, n, r), e.decodeAsync = async (n, r) => tx(e, n, r), e.safeEncode = (n, r) => nx(e, n, r), e.safeDecode = (n, r) => rx(e, n, r), e.safeEncodeAsync = async (n, r) => ox(e, n, r), e.safeDecodeAsync = async (n, r) => ax(e, n, r), e.refine = (n, r) => e.check(Qx(n, r)), e.superRefine = (n) => e.check(ek(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ vn(n)), e.optional = () => Ss(e), e.exactOptional = () => Wx(e), e.nullable = () => Ns(e), e.nullish = () => Ss(Ns(e)), e.nonoptional = (n) => Yx(e, n), e.array = () => ha(e), e.or = (n) => Mx([e, n]), e.and = (n) => Tx(e, n), e.transform = (n) => Cs(e, $x(n)), e.default = (n) => Bx(e, n), e.prefault = (n) => Lx(e, n), e.catch = (n) => Ux(e, n), e.pipe = (n) => Cs(e, n), e.readonly = () => qx(e), e.describe = (n) => {
  const r = e.clone();
  return Dn.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    return Dn.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Dn.get(e);
  const r = e.clone();
  return Dn.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), ll = /* @__PURE__ */ C("_ZodString", (e, t) => {
  ma.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (r, o, s) => xw(e, r, o);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ ow(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ iw(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ cw(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ lw(...r)), e.min = (...r) => e.check(/* @__PURE__ */ _r(...r)), e.max = (...r) => e.check(/* @__PURE__ */ rl(...r)), e.length = (...r) => e.check(/* @__PURE__ */ ol(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ _r(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ aw(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ sw(r)), e.trim = () => e.check(/* @__PURE__ */ uw()), e.normalize = (...r) => e.check(/* @__PURE__ */ dw(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ fw()), e.toUpperCase = () => e.check(/* @__PURE__ */ mw()), e.slugify = () => e.check(/* @__PURE__ */ hw());
}), sx = /* @__PURE__ */ C("ZodString", (e, t) => {
  ma.init(e, t), ll.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ M0(ix, n)), e.url = (n) => e.check(/* @__PURE__ */ $0(cx, n)), e.jwt = (n) => e.check(/* @__PURE__ */ K0(_x, n)), e.emoji = (n) => e.check(/* @__PURE__ */ R0(lx, n)), e.guid = (n) => e.check(/* @__PURE__ */ xs(ks, n)), e.uuid = (n) => e.check(/* @__PURE__ */ P0(hr, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ T0(hr, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ I0(hr, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ A0(hr, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ W0(dx, n)), e.guid = (n) => e.check(/* @__PURE__ */ xs(ks, n)), e.cuid = (n) => e.check(/* @__PURE__ */ F0(ux, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ j0(fx, n)), e.ulid = (n) => e.check(/* @__PURE__ */ B0(mx, n)), e.base64 = (n) => e.check(/* @__PURE__ */ G0(wx, n)), e.base64url = (n) => e.check(/* @__PURE__ */ q0(xx, n)), e.xid = (n) => e.check(/* @__PURE__ */ Z0(hx, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ L0(px, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ Y0(gx, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ H0(bx, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ U0(vx, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ V0(yx, n)), e.e164 = (n) => e.check(/* @__PURE__ */ J0(kx, n)), e.datetime = (n) => e.check(jw(n)), e.date = (n) => e.check(Zw(n)), e.time = (n) => e.check(Yw(n)), e.duration = (n) => e.check(Uw(n));
});
function mr(e) {
  return /* @__PURE__ */ z0(sx, e);
}
const me = /* @__PURE__ */ C("ZodStringFormat", (e, t) => {
  de.init(e, t), ll.init(e, t);
}), ix = /* @__PURE__ */ C("ZodEmail", (e, t) => {
  jy.init(e, t), me.init(e, t);
}), ks = /* @__PURE__ */ C("ZodGUID", (e, t) => {
  Wy.init(e, t), me.init(e, t);
}), hr = /* @__PURE__ */ C("ZodUUID", (e, t) => {
  Fy.init(e, t), me.init(e, t);
}), cx = /* @__PURE__ */ C("ZodURL", (e, t) => {
  By.init(e, t), me.init(e, t);
}), lx = /* @__PURE__ */ C("ZodEmoji", (e, t) => {
  Zy.init(e, t), me.init(e, t);
}), dx = /* @__PURE__ */ C("ZodNanoID", (e, t) => {
  Ly.init(e, t), me.init(e, t);
}), ux = /* @__PURE__ */ C("ZodCUID", (e, t) => {
  Yy.init(e, t), me.init(e, t);
}), fx = /* @__PURE__ */ C("ZodCUID2", (e, t) => {
  Hy.init(e, t), me.init(e, t);
}), mx = /* @__PURE__ */ C("ZodULID", (e, t) => {
  Uy.init(e, t), me.init(e, t);
}), hx = /* @__PURE__ */ C("ZodXID", (e, t) => {
  Vy.init(e, t), me.init(e, t);
}), px = /* @__PURE__ */ C("ZodKSUID", (e, t) => {
  Gy.init(e, t), me.init(e, t);
}), gx = /* @__PURE__ */ C("ZodIPv4", (e, t) => {
  Qy.init(e, t), me.init(e, t);
}), bx = /* @__PURE__ */ C("ZodIPv6", (e, t) => {
  e0.init(e, t), me.init(e, t);
}), vx = /* @__PURE__ */ C("ZodCIDRv4", (e, t) => {
  t0.init(e, t), me.init(e, t);
}), yx = /* @__PURE__ */ C("ZodCIDRv6", (e, t) => {
  n0.init(e, t), me.init(e, t);
}), wx = /* @__PURE__ */ C("ZodBase64", (e, t) => {
  r0.init(e, t), me.init(e, t);
}), xx = /* @__PURE__ */ C("ZodBase64URL", (e, t) => {
  a0.init(e, t), me.init(e, t);
}), kx = /* @__PURE__ */ C("ZodE164", (e, t) => {
  s0.init(e, t), me.init(e, t);
}), _x = /* @__PURE__ */ C("ZodJWT", (e, t) => {
  c0.init(e, t), me.init(e, t);
}), Sx = /* @__PURE__ */ C("ZodUnknown", (e, t) => {
  l0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => _w();
});
function _s() {
  return /* @__PURE__ */ nw(Sx);
}
const Nx = /* @__PURE__ */ C("ZodNever", (e, t) => {
  d0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => kw(e, n, r);
});
function Cx(e) {
  return /* @__PURE__ */ rw(Nx, e);
}
const Ox = /* @__PURE__ */ C("ZodArray", (e, t) => {
  u0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Ow(e, n, r, o), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ _r(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ _r(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ rl(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ ol(n, r)), e.unwrap = () => e.element;
});
function ha(e, t) {
  return /* @__PURE__ */ pw(Ox, e, t);
}
const Dx = /* @__PURE__ */ C("ZodObject", (e, t) => {
  m0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Dw(e, n, r, o), te(e, "shape", () => t.shape), e.keyof = () => Ix(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: _s() }), e.loose = () => e.clone({ ...e._zod.def, catchall: _s() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Cx() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => jv(e, n), e.safeExtend = (n) => Bv(e, n), e.merge = (n) => Zv(e, n), e.pick = (n) => Wv(e, n), e.omit = (n) => Fv(e, n), e.partial = (...n) => Lv(dl, e, n[0]), e.required = (...n) => Yv(ul, e, n[0]);
});
function Ex(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...V(t)
  };
  return new Dx(n);
}
const zx = /* @__PURE__ */ C("ZodUnion", (e, t) => {
  h0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Ew(e, n, r, o), e.options = t.options;
});
function Mx(e, t) {
  return new zx({
    type: "union",
    options: e,
    ...V(t)
  });
}
const Px = /* @__PURE__ */ C("ZodIntersection", (e, t) => {
  p0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => zw(e, n, r, o);
});
function Tx(e, t) {
  return new Px({
    type: "intersection",
    left: e,
    right: t
  });
}
const Mo = /* @__PURE__ */ C("ZodEnum", (e, t) => {
  g0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (r, o, s) => Sw(e, r, o), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, o) => {
    const s = {};
    for (const a of r)
      if (n.has(a))
        s[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new Mo({
      ...t,
      checks: [],
      ...V(o),
      entries: s
    });
  }, e.exclude = (r, o) => {
    const s = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete s[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new Mo({
      ...t,
      checks: [],
      ...V(o),
      entries: s
    });
  };
});
function Ix(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new Mo({
    type: "enum",
    entries: n,
    ...V(t)
  });
}
const Ax = /* @__PURE__ */ C("ZodTransform", (e, t) => {
  b0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Cw(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new Bc(e.constructor.name);
    n.addIssue = (s) => {
      if (typeof s == "string")
        n.issues.push(Rn(s, n.value, t));
      else {
        const a = s;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Rn(a));
      }
    };
    const o = t.transform(n.value, n);
    return o instanceof Promise ? o.then((s) => (n.value = s, n)) : (n.value = o, n);
  };
});
function $x(e) {
  return new Ax({
    type: "transform",
    transform: e
  });
}
const dl = /* @__PURE__ */ C("ZodOptional", (e, t) => {
  nl.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => cl(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Ss(e) {
  return new dl({
    type: "optional",
    innerType: e
  });
}
const Rx = /* @__PURE__ */ C("ZodExactOptional", (e, t) => {
  v0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => cl(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Wx(e) {
  return new Rx({
    type: "optional",
    innerType: e
  });
}
const Fx = /* @__PURE__ */ C("ZodNullable", (e, t) => {
  y0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Mw(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Ns(e) {
  return new Fx({
    type: "nullable",
    innerType: e
  });
}
const jx = /* @__PURE__ */ C("ZodDefault", (e, t) => {
  w0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Tw(e, n, r, o), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Bx(e, t) {
  return new jx({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Hc(t);
    }
  });
}
const Zx = /* @__PURE__ */ C("ZodPrefault", (e, t) => {
  x0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Iw(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Lx(e, t) {
  return new Zx({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Hc(t);
    }
  });
}
const ul = /* @__PURE__ */ C("ZodNonOptional", (e, t) => {
  k0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Pw(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function Yx(e, t) {
  return new ul({
    type: "nonoptional",
    innerType: e,
    ...V(t)
  });
}
const Hx = /* @__PURE__ */ C("ZodCatch", (e, t) => {
  _0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Aw(e, n, r, o), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Ux(e, t) {
  return new Hx({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Vx = /* @__PURE__ */ C("ZodPipe", (e, t) => {
  S0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => $w(e, n, r, o), e.in = t.in, e.out = t.out;
});
function Cs(e, t) {
  return new Vx({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Gx = /* @__PURE__ */ C("ZodReadonly", (e, t) => {
  N0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Rw(e, n, r, o), e.unwrap = () => e._zod.def.innerType;
});
function qx(e) {
  return new Gx({
    type: "readonly",
    innerType: e
  });
}
const Jx = /* @__PURE__ */ C("ZodLazy", (e, t) => {
  C0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Ww(e, n, r, o), e.unwrap = () => e._zod.def.getter();
});
function Kx(e) {
  return new Jx({
    type: "lazy",
    getter: e
  });
}
const Xx = /* @__PURE__ */ C("ZodCustom", (e, t) => {
  O0.init(e, t), ye.init(e, t), e._zod.processJSONSchema = (n, r, o) => Nw(e, n);
});
function Qx(e, t = {}) {
  return /* @__PURE__ */ gw(Xx, e, t);
}
function ek(e) {
  return /* @__PURE__ */ bw(e);
}
const fl = Ex({
  title: mr(),
  href: mr().optional(),
  iconLabel: mr().optional(),
  details: mr().optional(),
  children: Kx(() => ha(fl)).optional()
}), tk = ha(fl);
function w1({
  items: e,
  children: t,
  header: n,
  panelWidth: r = 260,
  className: o,
  open: s,
  onOpenChange: a
}) {
  if (typeof process < "u" && process.env.NODE_ENV !== "production") {
    const c = tk.safeParse(e);
    c.success || console.warn("[AppContentPanel] Invalid nav items:", c.error.format());
  }
  const i = /* @__PURE__ */ E(dn, { children: [
    n && /* @__PURE__ */ u("div", { className: "border-b px-4 py-3", children: n }),
    /* @__PURE__ */ u(zc, { className: "flex-1", children: /* @__PURE__ */ u("nav", { className: "py-2", children: /* @__PURE__ */ u("ul", { children: e.map((c) => /* @__PURE__ */ u(
      ml,
      {
        item: c,
        onNavigate: () => a?.(!1)
      },
      c.title
    )) }) }) })
  ] });
  return /* @__PURE__ */ E("div", { className: g("flex h-[calc(100vh-60px)]", o), children: [
    s && /* @__PURE__ */ u(
      "div",
      {
        className: "fixed inset-0 z-40 bg-black/50 lg:hidden",
        onClick: () => a?.(!1)
      }
    ),
    /* @__PURE__ */ u(
      "aside",
      {
        className: g(
          "fixed left-0 top-15 z-50 flex h-[calc(100vh-60px)] flex-col border-r bg-card transition-transform duration-300 ease-[cubic-bezier(0.05,0.74,0.27,0.99)] lg:hidden",
          s ? "translate-x-0" : "-translate-x-full"
        ),
        style: { width: r },
        children: i
      }
    ),
    /* @__PURE__ */ u(
      "aside",
      {
        className: "hidden lg:flex flex-col border-r bg-card",
        style: { width: r, minWidth: r },
        children: i
      }
    ),
    /* @__PURE__ */ u("div", { className: "flex-1 overflow-auto", children: t })
  ] });
}
function ml({
  item: e,
  onNavigate: t
}) {
  const n = Os(), [r, o] = he(() => e.children ? e.children.some(
    (i) => i.href ? n.pathname.startsWith(i.href) : !1
  ) : !1), s = e.href ? e.href === "/" ? n.pathname === "/" : n.pathname === e.href : e.children?.some(
    (i) => i.href ? n.pathname.startsWith(i.href) : !1
  ) ?? !1, a = e.icon;
  return e.children ? /* @__PURE__ */ E("li", { children: [
    /* @__PURE__ */ E(
      "button",
      {
        onClick: () => o(!r),
        className: g(
          "flex w-full items-center gap-3 rounded-md px-3 py-2 text-sm",
          s ? "bg-accent text-accent-foreground font-medium" : "text-muted-foreground hover:bg-accent/50 hover:text-foreground"
        ),
        children: [
          a && /* @__PURE__ */ u(a, { className: "h-4 w-4 shrink-0" }),
          /* @__PURE__ */ u("span", { className: "flex-1 truncate text-left", children: e.title }),
          /* @__PURE__ */ u(
            Wn,
            {
              className: g(
                "h-3.5 w-3.5 shrink-0 transition-transform duration-200",
                r && "rotate-90"
              )
            }
          )
        ]
      }
    ),
    r && /* @__PURE__ */ u("ul", { className: "ml-4 mt-1 border-l pl-3", children: e.children.map((i) => /* @__PURE__ */ u(ml, { item: i, onNavigate: t }, i.title)) })
  ] }) : /* @__PURE__ */ u("li", { children: /* @__PURE__ */ E(
    $t,
    {
      to: e.href,
      onClick: t,
      className: g(
        "flex items-center gap-3 rounded-md px-3 py-2 text-sm",
        s ? "bg-accent text-accent-foreground font-medium" : "text-muted-foreground hover:bg-accent/50 hover:text-foreground"
      ),
      children: [
        a && /* @__PURE__ */ u(a, { className: "h-4 w-4 shrink-0" }),
        /* @__PURE__ */ u("span", { className: "truncate", children: e.title })
      ]
    }
  ) });
}
function x1({ children: e, className: t }) {
  return /* @__PURE__ */ u(
    "div",
    {
      className: [
        "flex flex-col gap-6 px-6 pb-6 pt-0",
        t
      ].filter(Boolean).join(" "),
      children: e
    }
  );
}
export {
  mk as Accordion,
  gk as AccordionContent,
  hk as AccordionItem,
  pk as AccordionTrigger,
  Ev as ActionBar,
  aa as ActionBarContext,
  Dv as ActionBarProvider,
  sa as ActionBarSlotContext,
  b1 as ActionBarTrigger,
  dk as ActionButton,
  uk as ActionButtonGroup,
  fk as ActionIconButton,
  h1 as ActionPanel,
  g1 as ActionPanelBody,
  p1 as ActionPanelHeader,
  bk as Alert,
  yk as AlertDescription,
  ck as AlertDialog,
  bd as AlertDialogAction,
  vd as AlertDialogCancel,
  fd as AlertDialogContent,
  gd as AlertDialogDescription,
  hd as AlertDialogFooter,
  md as AlertDialogHeader,
  Us as AlertDialogOverlay,
  ud as AlertDialogPortal,
  pd as AlertDialogTitle,
  lk as AlertDialogTrigger,
  vk as AlertTitle,
  zv as AppActionBar,
  w1 as AppContentPanel,
  v1 as AppLayout,
  gv as AppSidebar,
  y1 as AuthLayout,
  Ea as Avatar,
  wk as AvatarBadge,
  Ma as AvatarFallback,
  xk as AvatarGroup,
  kk as AvatarGroupCount,
  za as AvatarImage,
  _k as Badge,
  Sv as Breadcrumb,
  m1 as BreadcrumbEllipsis,
  wv as BreadcrumbItem,
  xv as BreadcrumbLink,
  yv as BreadcrumbList,
  kv as BreadcrumbPage,
  vv as BreadcrumbRoot,
  _v as BreadcrumbSeparator,
  at as Button,
  Pi as Calendar,
  Sh as CalendarDayButton,
  Sk as Card,
  Dk as CardAction,
  Ek as CardContent,
  Ok as CardDescription,
  zk as CardFooter,
  Nk as CardHeader,
  Ck as CardTitle,
  Nh as Checkbox,
  Ch as Collapsible,
  Dh as CollapsibleContent,
  Oh as CollapsibleTrigger,
  Fk as Combobox,
  Ec as Command,
  $k as CommandDialog,
  Lg as CommandEmpty,
  Yg as CommandGroup,
  Bg as CommandInput,
  Hg as CommandItem,
  Zg as CommandList,
  Rk as CommandSeparator,
  Wk as CommandShortcut,
  Ug as DatePicker,
  jk as DateTimePicker,
  Ig as Dialog,
  Ik as DialogClose,
  Rg as DialogContent,
  jg as DialogDescription,
  Ak as DialogFooter,
  Wg as DialogHeader,
  $g as DialogOverlay,
  Ag as DialogPortal,
  Fg as DialogTitle,
  Tk as DialogTrigger,
  Vg as DropdownMenu,
  Lk as DropdownMenuCheckboxItem,
  qg as DropdownMenuContent,
  Zk as DropdownMenuGroup,
  cr as DropdownMenuItem,
  Jg as DropdownMenuLabel,
  Bk as DropdownMenuPortal,
  Yk as DropdownMenuRadioGroup,
  Hk as DropdownMenuRadioItem,
  lr as DropdownMenuSeparator,
  Uk as DropdownMenuShortcut,
  Vk as DropdownMenuSub,
  qk as DropdownMenuSubContent,
  Gk as DropdownMenuSubTrigger,
  Gg as DropdownMenuTrigger,
  Zb as FormGroupCheckbox,
  Lb as FormGroupDate,
  Yb as FormGroupDefault,
  Hb as FormGroupMultiline,
  Ub as FormGroupRadio,
  Vb as FormGroupSelect,
  Gb as FormGroupSwitch,
  Jb as FormSection,
  qb as FormSectionField,
  ss as Input,
  Kg as Label,
  x1 as PageContent,
  Fc as PinContext,
  Ho as Popover,
  Mk as PopoverAnchor,
  Vo as PopoverContent,
  Uo as PopoverTrigger,
  Jk as Progress,
  Qg as RadioGroup,
  eb as RadioGroupItem,
  zc as ScrollArea,
  tb as ScrollBar,
  nb as Select,
  ab as SelectContent,
  Kk as SelectGroup,
  sb as SelectItem,
  Xk as SelectLabel,
  cb as SelectScrollDownButton,
  ib as SelectScrollUpButton,
  Qk as SelectSeparator,
  ob as SelectTrigger,
  rb as SelectValue,
  e1 as Separator,
  Mc as Sheet,
  n1 as SheetClose,
  Pc as SheetContent,
  Ac as SheetDescription,
  r1 as SheetFooter,
  Tc as SheetHeader,
  Ic as SheetTitle,
  t1 as SheetTrigger,
  sv as SidebarInset,
  oa as SidebarNavContext,
  rv as SidebarProvider,
  av as SidebarTrigger,
  o1 as Skeleton,
  a1 as Slider,
  jb as Switch,
  i1 as Tabs,
  d1 as TabsContent,
  c1 as TabsList,
  l1 as TabsTrigger,
  u1 as Textarea,
  s1 as Toaster,
  Vs as Tooltip,
  qs as TooltipContent,
  yd as TooltipProvider,
  Gs as TooltipTrigger,
  wd as actionButtonVariants,
  xd as actionIconButtonVariants,
  Ou as badgeVariants,
  Pn as buttonVariants,
  g as cn,
  fl as navItemSchema,
  tk as navItemsSchema,
  Bb as tabsListVariants,
  $r as useActionBar,
  Ov as useActionBarSlotValue,
  $c as useIsMobile,
  jc as usePinned,
  bn as useSidebar,
  f1 as useSidebarNav
};
